// CommonJS package manager support
if (typeof module !== 'undefined' && typeof exports !== 'undefined' &&
  module.exports === exports) {
  // Export the *name* of this Angular module
  // Sample usage:
  //
  //   import lbServices from './lb-services';
  //   angular.module('app', [lbServices]);
  //
  module.exports = "lbServices";
}

(function(window, angular, undefined) {
  'use strict';

  var urlBase = "https://api.accountingbox.nl";
  var authHeader = 'authorization';

  function getHost(url) {
    var m = url.match(/^(?:https?:)?\/\/([^\/]+)/);
    return m ? m[1] : null;
  }
  // need to use the urlBase as the base to handle multiple
  // loopback servers behind a proxy/gateway where the host
  // would be the same.
  var urlBaseHost = getHost(urlBase) ? urlBase : location.host;

/**
 * @ngdoc overview
 * @name lbServices
 * @module
 * @description
 *
 * The `lbServices` module provides services for interacting with
 * the models exposed by the LoopBack server via the REST API.
 *
 */
  var module = angular.module("lbServices", ['ngResource']);

/**
 * @ngdoc object
 * @name lbServices.Journal
 * @header lbServices.Journal
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Journal` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Journal",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Journals/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Journal#prototype$__get__transaction
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Fetches belongsTo relation transaction.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Journal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "prototype$__get__transaction": {
              url: urlBase + "/Journals/:id/transaction",
              method: "GET",
            },

            // INTERNAL. Use Journal.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/Journals/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Journal.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Journals/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#prototype$__findById__journalLines
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Find a related item by id for journalLines.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Journal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journalLines
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "prototype$__findById__journalLines": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Journals/:id/journalLines/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#prototype$__destroyById__journalLines
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Delete a related item by id for journalLines.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Journal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journalLines
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__journalLines": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Journals/:id/journalLines/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#prototype$__updateById__journalLines
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Update a related item by id for journalLines.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Journal id
             *
             *  - `fk` – `{*}` - Foreign key for journalLines
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "prototype$__updateById__journalLines": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Journals/:id/journalLines/:fk",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#prototype$__get__journalLines
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Queries journalLines of Journal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Journal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "prototype$__get__journalLines": {
              isArray: true,
              url: urlBase + "/Journals/:id/journalLines",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#prototype$__create__journalLines
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Creates a new instance in journalLines of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Journal id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "prototype$__create__journalLines": {
              url: urlBase + "/Journals/:id/journalLines",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#prototype$__delete__journalLines
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Deletes all journalLines of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Journal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__journalLines": {
              url: urlBase + "/Journals/:id/journalLines",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#prototype$__count__journalLines
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Counts journalLines of Journal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Journal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__journalLines": {
              url: urlBase + "/Journals/:id/journalLines/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#create
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Journals",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#patchOrCreate
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Journals",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#replaceOrCreate
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Journals/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#upsertWithWhere
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Journals/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#exists
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Journals/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#findById
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Journals/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#replaceById
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Journals/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#find
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Journals",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#findOne
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Journals/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#deleteById
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Journals/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#count
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Journals/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#prototype$patchAttributes
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Journal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Journals/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Journal#createMany
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Journals",
              method: "POST",
            },

            // INTERNAL. Use Company.journals.findById() instead.
            "::findById::Company::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/journals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.journals.destroyById() instead.
            "::destroyById::Company::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/journals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.journals.updateById() instead.
            "::updateById::Company::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/journals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.journals() instead.
            "::get::Company::journals": {
              isArray: true,
              url: urlBase + "/Companies/:id/journals",
              method: "GET",
            },

            // INTERNAL. Use Company.journals.create() instead.
            "::create::Company::journals": {
              url: urlBase + "/Companies/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use Company.journals.createMany() instead.
            "::createMany::Company::journals": {
              isArray: true,
              url: urlBase + "/Companies/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use Company.journals.destroyAll() instead.
            "::delete::Company::journals": {
              url: urlBase + "/Companies/:id/journals",
              method: "DELETE",
            },

            // INTERNAL. Use Company.journals.count() instead.
            "::count::Company::journals": {
              url: urlBase + "/Companies/:id/journals/count",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.journal() instead.
            "::get::TransactionBase::journal": {
              url: urlBase + "/TransactionBases/:id/journal",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.journal.create() instead.
            "::create::TransactionBase::journal": {
              url: urlBase + "/TransactionBases/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use TransactionBase.journal.createMany() instead.
            "::createMany::TransactionBase::journal": {
              isArray: true,
              url: urlBase + "/TransactionBases/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use TransactionBase.journal.update() instead.
            "::update::TransactionBase::journal": {
              url: urlBase + "/TransactionBases/:id/journal",
              method: "PUT",
            },

            // INTERNAL. Use TransactionBase.journal.destroy() instead.
            "::destroy::TransactionBase::journal": {
              url: urlBase + "/TransactionBases/:id/journal",
              method: "DELETE",
            },

            // INTERNAL. Use TransactionBase.journals.findById() instead.
            "::findById::TransactionBase::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/TransactionBases/:id/journals/:fk",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.journals.destroyById() instead.
            "::destroyById::TransactionBase::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/TransactionBases/:id/journals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use TransactionBase.journals.updateById() instead.
            "::updateById::TransactionBase::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/TransactionBases/:id/journals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use TransactionBase.journals() instead.
            "::get::TransactionBase::journals": {
              isArray: true,
              url: urlBase + "/TransactionBases/:id/journals",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.journals.create() instead.
            "::create::TransactionBase::journals": {
              url: urlBase + "/TransactionBases/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use TransactionBase.journals.createMany() instead.
            "::createMany::TransactionBase::journals": {
              isArray: true,
              url: urlBase + "/TransactionBases/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use TransactionBase.journals.destroyAll() instead.
            "::delete::TransactionBase::journals": {
              url: urlBase + "/TransactionBases/:id/journals",
              method: "DELETE",
            },

            // INTERNAL. Use TransactionBase.journals.count() instead.
            "::count::TransactionBase::journals": {
              url: urlBase + "/TransactionBases/:id/journals/count",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.journal() instead.
            "::get::BankTransaction::journal": {
              url: urlBase + "/BankTransactions/:id/journal",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.journal.create() instead.
            "::create::BankTransaction::journal": {
              url: urlBase + "/BankTransactions/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.journal.createMany() instead.
            "::createMany::BankTransaction::journal": {
              isArray: true,
              url: urlBase + "/BankTransactions/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.journal.update() instead.
            "::update::BankTransaction::journal": {
              url: urlBase + "/BankTransactions/:id/journal",
              method: "PUT",
            },

            // INTERNAL. Use BankTransaction.journal.destroy() instead.
            "::destroy::BankTransaction::journal": {
              url: urlBase + "/BankTransactions/:id/journal",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.journals.findById() instead.
            "::findById::BankTransaction::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/journals/:fk",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.journals.destroyById() instead.
            "::destroyById::BankTransaction::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/journals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.journals.updateById() instead.
            "::updateById::BankTransaction::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/journals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use BankTransaction.journals() instead.
            "::get::BankTransaction::journals": {
              isArray: true,
              url: urlBase + "/BankTransactions/:id/journals",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.journals.create() instead.
            "::create::BankTransaction::journals": {
              url: urlBase + "/BankTransactions/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.journals.createMany() instead.
            "::createMany::BankTransaction::journals": {
              isArray: true,
              url: urlBase + "/BankTransactions/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.journals.destroyAll() instead.
            "::delete::BankTransaction::journals": {
              url: urlBase + "/BankTransactions/:id/journals",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.journals.count() instead.
            "::count::BankTransaction::journals": {
              url: urlBase + "/BankTransactions/:id/journals/count",
              method: "GET",
            },

            // INTERNAL. Use Invoice.journal() instead.
            "::get::Invoice::journal": {
              url: urlBase + "/Invoices/:id/journal",
              method: "GET",
            },

            // INTERNAL. Use Invoice.journal.create() instead.
            "::create::Invoice::journal": {
              url: urlBase + "/Invoices/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use Invoice.journal.createMany() instead.
            "::createMany::Invoice::journal": {
              isArray: true,
              url: urlBase + "/Invoices/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use Invoice.journal.update() instead.
            "::update::Invoice::journal": {
              url: urlBase + "/Invoices/:id/journal",
              method: "PUT",
            },

            // INTERNAL. Use Invoice.journal.destroy() instead.
            "::destroy::Invoice::journal": {
              url: urlBase + "/Invoices/:id/journal",
              method: "DELETE",
            },

            // INTERNAL. Use Invoice.journals.findById() instead.
            "::findById::Invoice::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Invoices/:id/journals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Invoice.journals.destroyById() instead.
            "::destroyById::Invoice::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Invoices/:id/journals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Invoice.journals.updateById() instead.
            "::updateById::Invoice::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Invoices/:id/journals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Invoice.journals() instead.
            "::get::Invoice::journals": {
              isArray: true,
              url: urlBase + "/Invoices/:id/journals",
              method: "GET",
            },

            // INTERNAL. Use Invoice.journals.create() instead.
            "::create::Invoice::journals": {
              url: urlBase + "/Invoices/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use Invoice.journals.createMany() instead.
            "::createMany::Invoice::journals": {
              isArray: true,
              url: urlBase + "/Invoices/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use Invoice.journals.destroyAll() instead.
            "::delete::Invoice::journals": {
              url: urlBase + "/Invoices/:id/journals",
              method: "DELETE",
            },

            // INTERNAL. Use Invoice.journals.count() instead.
            "::count::Invoice::journals": {
              url: urlBase + "/Invoices/:id/journals/count",
              method: "GET",
            },

            // INTERNAL. Use Purchase.journal() instead.
            "::get::Purchase::journal": {
              url: urlBase + "/Purchases/:id/journal",
              method: "GET",
            },

            // INTERNAL. Use Purchase.journal.create() instead.
            "::create::Purchase::journal": {
              url: urlBase + "/Purchases/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use Purchase.journal.createMany() instead.
            "::createMany::Purchase::journal": {
              isArray: true,
              url: urlBase + "/Purchases/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use Purchase.journal.update() instead.
            "::update::Purchase::journal": {
              url: urlBase + "/Purchases/:id/journal",
              method: "PUT",
            },

            // INTERNAL. Use Purchase.journal.destroy() instead.
            "::destroy::Purchase::journal": {
              url: urlBase + "/Purchases/:id/journal",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.journals.findById() instead.
            "::findById::Purchase::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/journals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Purchase.journals.destroyById() instead.
            "::destroyById::Purchase::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/journals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.journals.updateById() instead.
            "::updateById::Purchase::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/journals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Purchase.journals() instead.
            "::get::Purchase::journals": {
              isArray: true,
              url: urlBase + "/Purchases/:id/journals",
              method: "GET",
            },

            // INTERNAL. Use Purchase.journals.create() instead.
            "::create::Purchase::journals": {
              url: urlBase + "/Purchases/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use Purchase.journals.createMany() instead.
            "::createMany::Purchase::journals": {
              isArray: true,
              url: urlBase + "/Purchases/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use Purchase.journals.destroyAll() instead.
            "::delete::Purchase::journals": {
              url: urlBase + "/Purchases/:id/journals",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.journals.count() instead.
            "::count::Purchase::journals": {
              url: urlBase + "/Purchases/:id/journals/count",
              method: "GET",
            },

            // INTERNAL. Use Sale.journal() instead.
            "::get::Sale::journal": {
              url: urlBase + "/Sales/:id/journal",
              method: "GET",
            },

            // INTERNAL. Use Sale.journal.create() instead.
            "::create::Sale::journal": {
              url: urlBase + "/Sales/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use Sale.journal.createMany() instead.
            "::createMany::Sale::journal": {
              isArray: true,
              url: urlBase + "/Sales/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use Sale.journal.update() instead.
            "::update::Sale::journal": {
              url: urlBase + "/Sales/:id/journal",
              method: "PUT",
            },

            // INTERNAL. Use Sale.journal.destroy() instead.
            "::destroy::Sale::journal": {
              url: urlBase + "/Sales/:id/journal",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.journals.findById() instead.
            "::findById::Sale::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/journals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Sale.journals.destroyById() instead.
            "::destroyById::Sale::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/journals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.journals.updateById() instead.
            "::updateById::Sale::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/journals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Sale.journals() instead.
            "::get::Sale::journals": {
              isArray: true,
              url: urlBase + "/Sales/:id/journals",
              method: "GET",
            },

            // INTERNAL. Use Sale.journals.create() instead.
            "::create::Sale::journals": {
              url: urlBase + "/Sales/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use Sale.journals.createMany() instead.
            "::createMany::Sale::journals": {
              isArray: true,
              url: urlBase + "/Sales/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use Sale.journals.destroyAll() instead.
            "::delete::Sale::journals": {
              url: urlBase + "/Sales/:id/journals",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.journals.count() instead.
            "::count::Sale::journals": {
              url: urlBase + "/Sales/:id/journals/count",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.journal() instead.
            "::get::JournalEntry::journal": {
              url: urlBase + "/JournalEntries/:id/journal",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.journal.create() instead.
            "::create::JournalEntry::journal": {
              url: urlBase + "/JournalEntries/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use JournalEntry.journal.createMany() instead.
            "::createMany::JournalEntry::journal": {
              isArray: true,
              url: urlBase + "/JournalEntries/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use JournalEntry.journal.update() instead.
            "::update::JournalEntry::journal": {
              url: urlBase + "/JournalEntries/:id/journal",
              method: "PUT",
            },

            // INTERNAL. Use JournalEntry.journal.destroy() instead.
            "::destroy::JournalEntry::journal": {
              url: urlBase + "/JournalEntries/:id/journal",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.journals.findById() instead.
            "::findById::JournalEntry::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/journals/:fk",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.journals.destroyById() instead.
            "::destroyById::JournalEntry::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/journals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.journals.updateById() instead.
            "::updateById::JournalEntry::journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/journals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use JournalEntry.journals() instead.
            "::get::JournalEntry::journals": {
              isArray: true,
              url: urlBase + "/JournalEntries/:id/journals",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.journals.create() instead.
            "::create::JournalEntry::journals": {
              url: urlBase + "/JournalEntries/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use JournalEntry.journals.createMany() instead.
            "::createMany::JournalEntry::journals": {
              isArray: true,
              url: urlBase + "/JournalEntries/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use JournalEntry.journals.destroyAll() instead.
            "::delete::JournalEntry::journals": {
              url: urlBase + "/JournalEntries/:id/journals",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.journals.count() instead.
            "::count::JournalEntry::journals": {
              url: urlBase + "/JournalEntries/:id/journals/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Journal#upsert
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Journal#updateOrCreate
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Journal#patchOrCreateWithWhere
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Journal#destroyById
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Journal#removeById
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Journal#prototype$updateAttributes
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Journal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Journal#modelName
        * @propertyOf lbServices.Journal
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Journal`.
        */
        R.modelName = "Journal";


            /**
             * @ngdoc method
             * @name lbServices.Journal#company
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Journal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::Journal::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Journal#user
             * @methodOf lbServices.Journal
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Journal id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Journal::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Company
 * @header lbServices.Company
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Company` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Company",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Companies/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Company.journals.findById() instead.
            "prototype$__findById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/journals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.journals.destroyById() instead.
            "prototype$__destroyById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/journals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.journals.updateById() instead.
            "prototype$__updateById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/journals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.users.findById() instead.
            "prototype$__findById__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/users/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.users.destroyById() instead.
            "prototype$__destroyById__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/users/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.users.updateById() instead.
            "prototype$__updateById__users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/users/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.assignedAccountants.findById() instead.
            "prototype$__findById__assignedAccountants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/assignedAccountants/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.assignedAccountants.destroyById() instead.
            "prototype$__destroyById__assignedAccountants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/assignedAccountants/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.assignedAccountants.updateById() instead.
            "prototype$__updateById__assignedAccountants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/assignedAccountants/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.assignedAccountants.link() instead.
            "prototype$__link__assignedAccountants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/assignedAccountants/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.assignedAccountants.unlink() instead.
            "prototype$__unlink__assignedAccountants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/assignedAccountants/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.assignedAccountants.exists() instead.
            "prototype$__exists__assignedAccountants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/assignedAccountants/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Company.bankAccounts.findById() instead.
            "prototype$__findById__bankAccounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/bankAccounts/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.bankAccounts.destroyById() instead.
            "prototype$__destroyById__bankAccounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/bankAccounts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.bankAccounts.updateById() instead.
            "prototype$__updateById__bankAccounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/bankAccounts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.purchases.findById() instead.
            "prototype$__findById__purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/purchases/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.purchases.destroyById() instead.
            "prototype$__destroyById__purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/purchases/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.purchases.updateById() instead.
            "prototype$__updateById__purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/purchases/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.sales.findById() instead.
            "prototype$__findById__sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/sales/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.sales.destroyById() instead.
            "prototype$__destroyById__sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/sales/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.sales.updateById() instead.
            "prototype$__updateById__sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/sales/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.journalEntries.findById() instead.
            "prototype$__findById__journalEntries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/journalEntries/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.journalEntries.destroyById() instead.
            "prototype$__destroyById__journalEntries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/journalEntries/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.journalEntries.updateById() instead.
            "prototype$__updateById__journalEntries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/journalEntries/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.customers.findById() instead.
            "prototype$__findById__customers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/customers/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.customers.destroyById() instead.
            "prototype$__destroyById__customers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/customers/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.customers.updateById() instead.
            "prototype$__updateById__customers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/customers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.vendors.findById() instead.
            "prototype$__findById__vendors": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/vendors/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.vendors.destroyById() instead.
            "prototype$__destroyById__vendors": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/vendors/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.vendors.updateById() instead.
            "prototype$__updateById__vendors": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/vendors/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.journals() instead.
            "prototype$__get__journals": {
              isArray: true,
              url: urlBase + "/Companies/:id/journals",
              method: "GET",
            },

            // INTERNAL. Use Company.journals.create() instead.
            "prototype$__create__journals": {
              url: urlBase + "/Companies/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use Company.journals.destroyAll() instead.
            "prototype$__delete__journals": {
              url: urlBase + "/Companies/:id/journals",
              method: "DELETE",
            },

            // INTERNAL. Use Company.journals.count() instead.
            "prototype$__count__journals": {
              url: urlBase + "/Companies/:id/journals/count",
              method: "GET",
            },

            // INTERNAL. Use Company.users() instead.
            "prototype$__get__users": {
              isArray: true,
              url: urlBase + "/Companies/:id/users",
              method: "GET",
            },

            // INTERNAL. Use Company.users.create() instead.
            "prototype$__create__users": {
              url: urlBase + "/Companies/:id/users",
              method: "POST",
            },

            // INTERNAL. Use Company.users.destroyAll() instead.
            "prototype$__delete__users": {
              url: urlBase + "/Companies/:id/users",
              method: "DELETE",
            },

            // INTERNAL. Use Company.users.count() instead.
            "prototype$__count__users": {
              url: urlBase + "/Companies/:id/users/count",
              method: "GET",
            },

            // INTERNAL. Use Company.assignedAccountants() instead.
            "prototype$__get__assignedAccountants": {
              isArray: true,
              url: urlBase + "/Companies/:id/assignedAccountants",
              method: "GET",
            },

            // INTERNAL. Use Company.assignedAccountants.create() instead.
            "prototype$__create__assignedAccountants": {
              url: urlBase + "/Companies/:id/assignedAccountants",
              method: "POST",
            },

            // INTERNAL. Use Company.assignedAccountants.destroyAll() instead.
            "prototype$__delete__assignedAccountants": {
              url: urlBase + "/Companies/:id/assignedAccountants",
              method: "DELETE",
            },

            // INTERNAL. Use Company.assignedAccountants.count() instead.
            "prototype$__count__assignedAccountants": {
              url: urlBase + "/Companies/:id/assignedAccountants/count",
              method: "GET",
            },

            // INTERNAL. Use Company.bankAccounts() instead.
            "prototype$__get__bankAccounts": {
              isArray: true,
              url: urlBase + "/Companies/:id/bankAccounts",
              method: "GET",
            },

            // INTERNAL. Use Company.bankAccounts.create() instead.
            "prototype$__create__bankAccounts": {
              url: urlBase + "/Companies/:id/bankAccounts",
              method: "POST",
            },

            // INTERNAL. Use Company.bankAccounts.destroyAll() instead.
            "prototype$__delete__bankAccounts": {
              url: urlBase + "/Companies/:id/bankAccounts",
              method: "DELETE",
            },

            // INTERNAL. Use Company.bankAccounts.count() instead.
            "prototype$__count__bankAccounts": {
              url: urlBase + "/Companies/:id/bankAccounts/count",
              method: "GET",
            },

            // INTERNAL. Use Company.purchases() instead.
            "prototype$__get__purchases": {
              isArray: true,
              url: urlBase + "/Companies/:id/purchases",
              method: "GET",
            },

            // INTERNAL. Use Company.purchases.create() instead.
            "prototype$__create__purchases": {
              url: urlBase + "/Companies/:id/purchases",
              method: "POST",
            },

            // INTERNAL. Use Company.purchases.destroyAll() instead.
            "prototype$__delete__purchases": {
              url: urlBase + "/Companies/:id/purchases",
              method: "DELETE",
            },

            // INTERNAL. Use Company.purchases.count() instead.
            "prototype$__count__purchases": {
              url: urlBase + "/Companies/:id/purchases/count",
              method: "GET",
            },

            // INTERNAL. Use Company.sales() instead.
            "prototype$__get__sales": {
              isArray: true,
              url: urlBase + "/Companies/:id/sales",
              method: "GET",
            },

            // INTERNAL. Use Company.sales.create() instead.
            "prototype$__create__sales": {
              url: urlBase + "/Companies/:id/sales",
              method: "POST",
            },

            // INTERNAL. Use Company.sales.destroyAll() instead.
            "prototype$__delete__sales": {
              url: urlBase + "/Companies/:id/sales",
              method: "DELETE",
            },

            // INTERNAL. Use Company.sales.count() instead.
            "prototype$__count__sales": {
              url: urlBase + "/Companies/:id/sales/count",
              method: "GET",
            },

            // INTERNAL. Use Company.journalEntries() instead.
            "prototype$__get__journalEntries": {
              isArray: true,
              url: urlBase + "/Companies/:id/journalEntries",
              method: "GET",
            },

            // INTERNAL. Use Company.journalEntries.create() instead.
            "prototype$__create__journalEntries": {
              url: urlBase + "/Companies/:id/journalEntries",
              method: "POST",
            },

            // INTERNAL. Use Company.journalEntries.destroyAll() instead.
            "prototype$__delete__journalEntries": {
              url: urlBase + "/Companies/:id/journalEntries",
              method: "DELETE",
            },

            // INTERNAL. Use Company.journalEntries.count() instead.
            "prototype$__count__journalEntries": {
              url: urlBase + "/Companies/:id/journalEntries/count",
              method: "GET",
            },

            // INTERNAL. Use Company.customers() instead.
            "prototype$__get__customers": {
              isArray: true,
              url: urlBase + "/Companies/:id/customers",
              method: "GET",
            },

            // INTERNAL. Use Company.customers.create() instead.
            "prototype$__create__customers": {
              url: urlBase + "/Companies/:id/customers",
              method: "POST",
            },

            // INTERNAL. Use Company.customers.destroyAll() instead.
            "prototype$__delete__customers": {
              url: urlBase + "/Companies/:id/customers",
              method: "DELETE",
            },

            // INTERNAL. Use Company.customers.count() instead.
            "prototype$__count__customers": {
              url: urlBase + "/Companies/:id/customers/count",
              method: "GET",
            },

            // INTERNAL. Use Company.vendors() instead.
            "prototype$__get__vendors": {
              isArray: true,
              url: urlBase + "/Companies/:id/vendors",
              method: "GET",
            },

            // INTERNAL. Use Company.vendors.create() instead.
            "prototype$__create__vendors": {
              url: urlBase + "/Companies/:id/vendors",
              method: "POST",
            },

            // INTERNAL. Use Company.vendors.destroyAll() instead.
            "prototype$__delete__vendors": {
              url: urlBase + "/Companies/:id/vendors",
              method: "DELETE",
            },

            // INTERNAL. Use Company.vendors.count() instead.
            "prototype$__count__vendors": {
              url: urlBase + "/Companies/:id/vendors/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#create
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Companies",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#patchOrCreate
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Companies",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#replaceOrCreate
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Companies/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#upsertWithWhere
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Companies/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#exists
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Companies/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#findById
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Companies/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#replaceById
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Companies/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#findOne
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Companies/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#updateAll
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Companies/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#deleteById
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Companies/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#count
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Companies/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#prototype$patchAttributes
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Companies/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#createChangeStream
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Companies/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#prototype$updateInvoiceSettingsRemote
             * @methodOf lbServices.Company
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "prototype$updateInvoiceSettingsRemote": {
              url: urlBase + "/Companies/:id/invoice-settings",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#usageOverview
             * @methodOf lbServices.Company
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `year` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "usageOverview": {
              isArray: true,
              url: urlBase + "/Companies/usage",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#customFind
             * @methodOf lbServices.Company
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "customFind": {
              isArray: true,
              url: urlBase + "/Companies",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#convert
             * @methodOf lbServices.Company
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "convert": {
              url: urlBase + "/Companies/:id/convert",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#activate
             * @methodOf lbServices.Company
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "activate": {
              url: urlBase + "/Companies/:id/activate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#deactivate
             * @methodOf lbServices.Company
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "deactivate": {
              url: urlBase + "/Companies/:id/deactivate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Company#createMany
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Companies",
              method: "POST",
            },

            // INTERNAL. Use Journal.company() instead.
            "::get::Journal::company": {
              url: urlBase + "/Journals/:id/company",
              method: "GET",
            },

            // INTERNAL. Use User.company() instead.
            "::get::User::company": {
              url: urlBase + "/users/:id/company",
              method: "GET",
            },

            // INTERNAL. Use User.assignedCompanies.findById() instead.
            "::findById::User::assignedCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/assignedCompanies/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.assignedCompanies.destroyById() instead.
            "::destroyById::User::assignedCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/assignedCompanies/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.assignedCompanies.updateById() instead.
            "::updateById::User::assignedCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/assignedCompanies/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.assignedCompanies.link() instead.
            "::link::User::assignedCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/assignedCompanies/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.assignedCompanies.unlink() instead.
            "::unlink::User::assignedCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/assignedCompanies/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.assignedCompanies.exists() instead.
            "::exists::User::assignedCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/assignedCompanies/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use User.assignedCompanies() instead.
            "::get::User::assignedCompanies": {
              isArray: true,
              url: urlBase + "/users/:id/assignedCompanies",
              method: "GET",
            },

            // INTERNAL. Use User.assignedCompanies.create() instead.
            "::create::User::assignedCompanies": {
              url: urlBase + "/users/:id/assignedCompanies",
              method: "POST",
            },

            // INTERNAL. Use User.assignedCompanies.createMany() instead.
            "::createMany::User::assignedCompanies": {
              isArray: true,
              url: urlBase + "/users/:id/assignedCompanies",
              method: "POST",
            },

            // INTERNAL. Use User.assignedCompanies.destroyAll() instead.
            "::delete::User::assignedCompanies": {
              url: urlBase + "/users/:id/assignedCompanies",
              method: "DELETE",
            },

            // INTERNAL. Use User.assignedCompanies.count() instead.
            "::count::User::assignedCompanies": {
              url: urlBase + "/users/:id/assignedCompanies/count",
              method: "GET",
            },

            // INTERNAL. Use SubAccount.company() instead.
            "::get::SubAccount::company": {
              url: urlBase + "/SubAccounts/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Attachment.company() instead.
            "::get::Attachment::company": {
              url: urlBase + "/Attachments/:id/company",
              method: "GET",
            },

            // INTERNAL. Use BankAccount.company() instead.
            "::get::BankAccount::company": {
              url: urlBase + "/BankAccounts/:id/company",
              method: "GET",
            },

            // INTERNAL. Use KlarnaConnection.company() instead.
            "::get::KlarnaConnection::company": {
              url: urlBase + "/klarna-connections/:id/company",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.company() instead.
            "::get::TransactionBase::company": {
              url: urlBase + "/TransactionBases/:id/company",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.company() instead.
            "::get::BankTransaction::company": {
              url: urlBase + "/BankTransactions/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Invoice.company() instead.
            "::get::Invoice::company": {
              url: urlBase + "/Invoices/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Purchase.company() instead.
            "::get::Purchase::company": {
              url: urlBase + "/Purchases/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Sale.company() instead.
            "::get::Sale::company": {
              url: urlBase + "/Sales/:id/company",
              method: "GET",
            },

            // INTERNAL. Use RecurringSale.company() instead.
            "::get::RecurringSale::company": {
              url: urlBase + "/recurring-sales/:id/company",
              method: "GET",
            },

            // INTERNAL. Use SaleItem.company() instead.
            "::get::SaleItem::company": {
              url: urlBase + "/sale-items/:id/company",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.company() instead.
            "::get::JournalEntry::company": {
              url: urlBase + "/JournalEntries/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Payment.company() instead.
            "::get::Payment::company": {
              url: urlBase + "/Payments/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Customer.company() instead.
            "::get::Customer::company": {
              url: urlBase + "/Customers/:id/company",
              method: "GET",
            },

            // INTERNAL. Use BankRule.company() instead.
            "::get::BankRule::company": {
              url: urlBase + "/BankRules/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Event.company() instead.
            "::get::Event::company": {
              url: urlBase + "/events/:id/company",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Company#upsert
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Company#updateOrCreate
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Company#patchOrCreateWithWhere
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Company#update
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Company#destroyById
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Company#removeById
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Company#prototype$updateAttributes
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Company#modelName
        * @propertyOf lbServices.Company
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Company`.
        */
        R.modelName = "Company";

    /**
     * @ngdoc object
     * @name lbServices.Company.journals
     * @header lbServices.Company.journals
     * @object
     * @description
     *
     * The object `Company.journals` groups methods
     * manipulating `Journal` instances related to `Company`.
     *
     * Call {@link lbServices.Company#journals Company.journals()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Company#journals
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Queries journals of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::get::Company::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.journals#count
             * @methodOf lbServices.Company.journals
             *
             * @description
             *
             * Counts journals of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.journals.count = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::count::Company::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.journals#create
             * @methodOf lbServices.Company.journals
             *
             * @description
             *
             * Creates a new instance in journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.create = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::create::Company::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.journals#createMany
             * @methodOf lbServices.Company.journals
             *
             * @description
             *
             * Creates a new instance in journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.createMany = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::createMany::Company::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.journals#destroyAll
             * @methodOf lbServices.Company.journals
             *
             * @description
             *
             * Deletes all journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journals.destroyAll = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::delete::Company::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.journals#destroyById
             * @methodOf lbServices.Company.journals
             *
             * @description
             *
             * Delete a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journals.destroyById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::destroyById::Company::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.journals#findById
             * @methodOf lbServices.Company.journals
             *
             * @description
             *
             * Find a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.findById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::findById::Company::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.journals#updateById
             * @methodOf lbServices.Company.journals
             *
             * @description
             *
             * Update a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.updateById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::updateById::Company::journals"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Company.users
     * @header lbServices.Company.users
     * @object
     * @description
     *
     * The object `Company.users` groups methods
     * manipulating `User` instances related to `Company`.
     *
     * Call {@link lbServices.Company#users Company.users()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Company#users
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Queries users of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Company::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.users#count
             * @methodOf lbServices.Company.users
             *
             * @description
             *
             * Counts users of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.users.count = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::count::Company::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.users#create
             * @methodOf lbServices.Company.users
             *
             * @description
             *
             * Creates a new instance in users of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users.create = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::create::Company::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.users#createMany
             * @methodOf lbServices.Company.users
             *
             * @description
             *
             * Creates a new instance in users of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users.createMany = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::createMany::Company::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.users#destroyAll
             * @methodOf lbServices.Company.users
             *
             * @description
             *
             * Deletes all users of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.users.destroyAll = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::delete::Company::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.users#destroyById
             * @methodOf lbServices.Company.users
             *
             * @description
             *
             * Delete a related item by id for users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.users.destroyById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::destroyById::Company::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.users#findById
             * @methodOf lbServices.Company.users
             *
             * @description
             *
             * Find a related item by id for users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users.findById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::findById::Company::users"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.users#updateById
             * @methodOf lbServices.Company.users
             *
             * @description
             *
             * Update a related item by id for users.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `fk` – `{*}` - Foreign key for users
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.users.updateById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::updateById::Company::users"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Company.assignedAccountants
     * @header lbServices.Company.assignedAccountants
     * @object
     * @description
     *
     * The object `Company.assignedAccountants` groups methods
     * manipulating `User` instances related to `Company`.
     *
     * Call {@link lbServices.Company#assignedAccountants Company.assignedAccountants()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Company#assignedAccountants
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Queries assignedAccountants of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.assignedAccountants = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Company::assignedAccountants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.assignedAccountants#count
             * @methodOf lbServices.Company.assignedAccountants
             *
             * @description
             *
             * Counts assignedAccountants of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.assignedAccountants.count = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::count::Company::assignedAccountants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.assignedAccountants#create
             * @methodOf lbServices.Company.assignedAccountants
             *
             * @description
             *
             * Creates a new instance in assignedAccountants of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.assignedAccountants.create = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::create::Company::assignedAccountants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.assignedAccountants#createMany
             * @methodOf lbServices.Company.assignedAccountants
             *
             * @description
             *
             * Creates a new instance in assignedAccountants of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.assignedAccountants.createMany = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::createMany::Company::assignedAccountants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.assignedAccountants#destroyAll
             * @methodOf lbServices.Company.assignedAccountants
             *
             * @description
             *
             * Deletes all assignedAccountants of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.assignedAccountants.destroyAll = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::delete::Company::assignedAccountants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.assignedAccountants#destroyById
             * @methodOf lbServices.Company.assignedAccountants
             *
             * @description
             *
             * Delete a related item by id for assignedAccountants.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for assignedAccountants
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.assignedAccountants.destroyById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::destroyById::Company::assignedAccountants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.assignedAccountants#exists
             * @methodOf lbServices.Company.assignedAccountants
             *
             * @description
             *
             * Check the existence of assignedAccountants relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for assignedAccountants
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.assignedAccountants.exists = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::exists::Company::assignedAccountants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.assignedAccountants#findById
             * @methodOf lbServices.Company.assignedAccountants
             *
             * @description
             *
             * Find a related item by id for assignedAccountants.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for assignedAccountants
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.assignedAccountants.findById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::findById::Company::assignedAccountants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.assignedAccountants#link
             * @methodOf lbServices.Company.assignedAccountants
             *
             * @description
             *
             * Add a related item by id for assignedAccountants.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `fk` – `{*}` - Foreign key for assignedAccountants
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.assignedAccountants.link = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::link::Company::assignedAccountants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.assignedAccountants#unlink
             * @methodOf lbServices.Company.assignedAccountants
             *
             * @description
             *
             * Remove the assignedAccountants relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for assignedAccountants
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.assignedAccountants.unlink = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::unlink::Company::assignedAccountants"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.assignedAccountants#updateById
             * @methodOf lbServices.Company.assignedAccountants
             *
             * @description
             *
             * Update a related item by id for assignedAccountants.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `fk` – `{*}` - Foreign key for assignedAccountants
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.assignedAccountants.updateById = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::updateById::Company::assignedAccountants"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Company.bankAccounts
     * @header lbServices.Company.bankAccounts
     * @object
     * @description
     *
     * The object `Company.bankAccounts` groups methods
     * manipulating `BankAccount` instances related to `Company`.
     *
     * Call {@link lbServices.Company#bankAccounts Company.bankAccounts()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Company#bankAccounts
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Queries bankAccounts of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R.bankAccounts = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::get::Company::bankAccounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.bankAccounts#count
             * @methodOf lbServices.Company.bankAccounts
             *
             * @description
             *
             * Counts bankAccounts of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.bankAccounts.count = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::count::Company::bankAccounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.bankAccounts#create
             * @methodOf lbServices.Company.bankAccounts
             *
             * @description
             *
             * Creates a new instance in bankAccounts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R.bankAccounts.create = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::create::Company::bankAccounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.bankAccounts#createMany
             * @methodOf lbServices.Company.bankAccounts
             *
             * @description
             *
             * Creates a new instance in bankAccounts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R.bankAccounts.createMany = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::createMany::Company::bankAccounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.bankAccounts#destroyAll
             * @methodOf lbServices.Company.bankAccounts
             *
             * @description
             *
             * Deletes all bankAccounts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bankAccounts.destroyAll = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::delete::Company::bankAccounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.bankAccounts#destroyById
             * @methodOf lbServices.Company.bankAccounts
             *
             * @description
             *
             * Delete a related item by id for bankAccounts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bankAccounts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bankAccounts.destroyById = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::destroyById::Company::bankAccounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.bankAccounts#findById
             * @methodOf lbServices.Company.bankAccounts
             *
             * @description
             *
             * Find a related item by id for bankAccounts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bankAccounts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R.bankAccounts.findById = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::findById::Company::bankAccounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.bankAccounts#updateById
             * @methodOf lbServices.Company.bankAccounts
             *
             * @description
             *
             * Update a related item by id for bankAccounts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `fk` – `{*}` - Foreign key for bankAccounts
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R.bankAccounts.updateById = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::updateById::Company::bankAccounts"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Company.purchases
     * @header lbServices.Company.purchases
     * @object
     * @description
     *
     * The object `Company.purchases` groups methods
     * manipulating `Purchase` instances related to `Company`.
     *
     * Call {@link lbServices.Company#purchases Company.purchases()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Company#purchases
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Queries purchases of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R.purchases = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::get::Company::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.purchases#count
             * @methodOf lbServices.Company.purchases
             *
             * @description
             *
             * Counts purchases of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.purchases.count = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::count::Company::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.purchases#create
             * @methodOf lbServices.Company.purchases
             *
             * @description
             *
             * Creates a new instance in purchases of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R.purchases.create = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::create::Company::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.purchases#createMany
             * @methodOf lbServices.Company.purchases
             *
             * @description
             *
             * Creates a new instance in purchases of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R.purchases.createMany = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::createMany::Company::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.purchases#destroyAll
             * @methodOf lbServices.Company.purchases
             *
             * @description
             *
             * Deletes all purchases of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.purchases.destroyAll = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::delete::Company::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.purchases#destroyById
             * @methodOf lbServices.Company.purchases
             *
             * @description
             *
             * Delete a related item by id for purchases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for purchases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.purchases.destroyById = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::destroyById::Company::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.purchases#findById
             * @methodOf lbServices.Company.purchases
             *
             * @description
             *
             * Find a related item by id for purchases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for purchases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R.purchases.findById = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::findById::Company::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.purchases#updateById
             * @methodOf lbServices.Company.purchases
             *
             * @description
             *
             * Update a related item by id for purchases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `fk` – `{*}` - Foreign key for purchases
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R.purchases.updateById = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::updateById::Company::purchases"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Company.sales
     * @header lbServices.Company.sales
     * @object
     * @description
     *
     * The object `Company.sales` groups methods
     * manipulating `Sale` instances related to `Company`.
     *
     * Call {@link lbServices.Company#sales Company.sales()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Company#sales
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Queries sales of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.sales = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::get::Company::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.sales#count
             * @methodOf lbServices.Company.sales
             *
             * @description
             *
             * Counts sales of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.sales.count = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::count::Company::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.sales#create
             * @methodOf lbServices.Company.sales
             *
             * @description
             *
             * Creates a new instance in sales of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.sales.create = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::create::Company::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.sales#createMany
             * @methodOf lbServices.Company.sales
             *
             * @description
             *
             * Creates a new instance in sales of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.sales.createMany = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::createMany::Company::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.sales#destroyAll
             * @methodOf lbServices.Company.sales
             *
             * @description
             *
             * Deletes all sales of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sales.destroyAll = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::delete::Company::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.sales#destroyById
             * @methodOf lbServices.Company.sales
             *
             * @description
             *
             * Delete a related item by id for sales.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for sales
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sales.destroyById = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::destroyById::Company::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.sales#findById
             * @methodOf lbServices.Company.sales
             *
             * @description
             *
             * Find a related item by id for sales.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for sales
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.sales.findById = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::findById::Company::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.sales#updateById
             * @methodOf lbServices.Company.sales
             *
             * @description
             *
             * Update a related item by id for sales.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `fk` – `{*}` - Foreign key for sales
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.sales.updateById = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::updateById::Company::sales"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Company.journalEntries
     * @header lbServices.Company.journalEntries
     * @object
     * @description
     *
     * The object `Company.journalEntries` groups methods
     * manipulating `JournalEntry` instances related to `Company`.
     *
     * Call {@link lbServices.Company#journalEntries Company.journalEntries()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Company#journalEntries
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Queries journalEntries of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
        R.journalEntries = function() {
          var TargetResource = $injector.get("JournalEntry");
          var action = TargetResource["::get::Company::journalEntries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.journalEntries#count
             * @methodOf lbServices.Company.journalEntries
             *
             * @description
             *
             * Counts journalEntries of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.journalEntries.count = function() {
          var TargetResource = $injector.get("JournalEntry");
          var action = TargetResource["::count::Company::journalEntries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.journalEntries#create
             * @methodOf lbServices.Company.journalEntries
             *
             * @description
             *
             * Creates a new instance in journalEntries of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
        R.journalEntries.create = function() {
          var TargetResource = $injector.get("JournalEntry");
          var action = TargetResource["::create::Company::journalEntries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.journalEntries#createMany
             * @methodOf lbServices.Company.journalEntries
             *
             * @description
             *
             * Creates a new instance in journalEntries of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
        R.journalEntries.createMany = function() {
          var TargetResource = $injector.get("JournalEntry");
          var action = TargetResource["::createMany::Company::journalEntries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.journalEntries#destroyAll
             * @methodOf lbServices.Company.journalEntries
             *
             * @description
             *
             * Deletes all journalEntries of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journalEntries.destroyAll = function() {
          var TargetResource = $injector.get("JournalEntry");
          var action = TargetResource["::delete::Company::journalEntries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.journalEntries#destroyById
             * @methodOf lbServices.Company.journalEntries
             *
             * @description
             *
             * Delete a related item by id for journalEntries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journalEntries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journalEntries.destroyById = function() {
          var TargetResource = $injector.get("JournalEntry");
          var action = TargetResource["::destroyById::Company::journalEntries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.journalEntries#findById
             * @methodOf lbServices.Company.journalEntries
             *
             * @description
             *
             * Find a related item by id for journalEntries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journalEntries
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
        R.journalEntries.findById = function() {
          var TargetResource = $injector.get("JournalEntry");
          var action = TargetResource["::findById::Company::journalEntries"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.journalEntries#updateById
             * @methodOf lbServices.Company.journalEntries
             *
             * @description
             *
             * Update a related item by id for journalEntries.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `fk` – `{*}` - Foreign key for journalEntries
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
        R.journalEntries.updateById = function() {
          var TargetResource = $injector.get("JournalEntry");
          var action = TargetResource["::updateById::Company::journalEntries"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Company.customers
     * @header lbServices.Company.customers
     * @object
     * @description
     *
     * The object `Company.customers` groups methods
     * manipulating `Customer` instances related to `Company`.
     *
     * Call {@link lbServices.Company#customers Company.customers()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Company#customers
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Queries customers of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R.customers = function() {
          var TargetResource = $injector.get("Customer");
          var action = TargetResource["::get::Company::customers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.customers#count
             * @methodOf lbServices.Company.customers
             *
             * @description
             *
             * Counts customers of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.customers.count = function() {
          var TargetResource = $injector.get("Customer");
          var action = TargetResource["::count::Company::customers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.customers#create
             * @methodOf lbServices.Company.customers
             *
             * @description
             *
             * Creates a new instance in customers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R.customers.create = function() {
          var TargetResource = $injector.get("Customer");
          var action = TargetResource["::create::Company::customers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.customers#createMany
             * @methodOf lbServices.Company.customers
             *
             * @description
             *
             * Creates a new instance in customers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R.customers.createMany = function() {
          var TargetResource = $injector.get("Customer");
          var action = TargetResource["::createMany::Company::customers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.customers#destroyAll
             * @methodOf lbServices.Company.customers
             *
             * @description
             *
             * Deletes all customers of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.customers.destroyAll = function() {
          var TargetResource = $injector.get("Customer");
          var action = TargetResource["::delete::Company::customers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.customers#destroyById
             * @methodOf lbServices.Company.customers
             *
             * @description
             *
             * Delete a related item by id for customers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for customers
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.customers.destroyById = function() {
          var TargetResource = $injector.get("Customer");
          var action = TargetResource["::destroyById::Company::customers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.customers#findById
             * @methodOf lbServices.Company.customers
             *
             * @description
             *
             * Find a related item by id for customers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for customers
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R.customers.findById = function() {
          var TargetResource = $injector.get("Customer");
          var action = TargetResource["::findById::Company::customers"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.customers#updateById
             * @methodOf lbServices.Company.customers
             *
             * @description
             *
             * Update a related item by id for customers.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `fk` – `{*}` - Foreign key for customers
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R.customers.updateById = function() {
          var TargetResource = $injector.get("Customer");
          var action = TargetResource["::updateById::Company::customers"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Company.vendors
     * @header lbServices.Company.vendors
     * @object
     * @description
     *
     * The object `Company.vendors` groups methods
     * manipulating `Vendor` instances related to `Company`.
     *
     * Call {@link lbServices.Company#vendors Company.vendors()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Company#vendors
             * @methodOf lbServices.Company
             *
             * @description
             *
             * Queries vendors of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
        R.vendors = function() {
          var TargetResource = $injector.get("Vendor");
          var action = TargetResource["::get::Company::vendors"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.vendors#count
             * @methodOf lbServices.Company.vendors
             *
             * @description
             *
             * Counts vendors of Company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.vendors.count = function() {
          var TargetResource = $injector.get("Vendor");
          var action = TargetResource["::count::Company::vendors"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.vendors#create
             * @methodOf lbServices.Company.vendors
             *
             * @description
             *
             * Creates a new instance in vendors of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
        R.vendors.create = function() {
          var TargetResource = $injector.get("Vendor");
          var action = TargetResource["::create::Company::vendors"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.vendors#createMany
             * @methodOf lbServices.Company.vendors
             *
             * @description
             *
             * Creates a new instance in vendors of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
        R.vendors.createMany = function() {
          var TargetResource = $injector.get("Vendor");
          var action = TargetResource["::createMany::Company::vendors"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.vendors#destroyAll
             * @methodOf lbServices.Company.vendors
             *
             * @description
             *
             * Deletes all vendors of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.vendors.destroyAll = function() {
          var TargetResource = $injector.get("Vendor");
          var action = TargetResource["::delete::Company::vendors"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.vendors#destroyById
             * @methodOf lbServices.Company.vendors
             *
             * @description
             *
             * Delete a related item by id for vendors.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for vendors
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.vendors.destroyById = function() {
          var TargetResource = $injector.get("Vendor");
          var action = TargetResource["::destroyById::Company::vendors"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.vendors#findById
             * @methodOf lbServices.Company.vendors
             *
             * @description
             *
             * Find a related item by id for vendors.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for vendors
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
        R.vendors.findById = function() {
          var TargetResource = $injector.get("Vendor");
          var action = TargetResource["::findById::Company::vendors"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Company.vendors#updateById
             * @methodOf lbServices.Company.vendors
             *
             * @description
             *
             * Update a related item by id for vendors.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Company id
             *
             *  - `fk` – `{*}` - Foreign key for vendors
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
        R.vendors.updateById = function() {
          var TargetResource = $injector.get("Vendor");
          var action = TargetResource["::updateById::Company::vendors"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.User
 * @header lbServices.User
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `User` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "User",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/users/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__findById__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__findById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__destroyById__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__updateById__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update a related item by id for accessTokens.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for accessTokens
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__updateById__accessTokens": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/accessTokens/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/users/:id/company",
              method: "GET",
            },

            // INTERNAL. Use User.assignedCompanies.findById() instead.
            "prototype$__findById__assignedCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/assignedCompanies/:fk",
              method: "GET",
            },

            // INTERNAL. Use User.assignedCompanies.destroyById() instead.
            "prototype$__destroyById__assignedCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/assignedCompanies/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.assignedCompanies.updateById() instead.
            "prototype$__updateById__assignedCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/assignedCompanies/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.assignedCompanies.link() instead.
            "prototype$__link__assignedCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/assignedCompanies/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use User.assignedCompanies.unlink() instead.
            "prototype$__unlink__assignedCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/assignedCompanies/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use User.assignedCompanies.exists() instead.
            "prototype$__exists__assignedCompanies": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/users/:id/assignedCompanies/rel/:fk",
              method: "HEAD",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__get__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries accessTokens of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__get__accessTokens": {
              isArray: true,
              url: urlBase + "/users/:id/accessTokens",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__create__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Creates a new instance in accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$__create__accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__delete__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Deletes all accessTokens of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__accessTokens": {
              url: urlBase + "/users/:id/accessTokens",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$__count__accessTokens
             * @methodOf lbServices.User
             *
             * @description
             *
             * Counts accessTokens of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__accessTokens": {
              url: urlBase + "/users/:id/accessTokens/count",
              method: "GET",
            },

            // INTERNAL. Use User.assignedCompanies() instead.
            "prototype$__get__assignedCompanies": {
              isArray: true,
              url: urlBase + "/users/:id/assignedCompanies",
              method: "GET",
            },

            // INTERNAL. Use User.assignedCompanies.create() instead.
            "prototype$__create__assignedCompanies": {
              url: urlBase + "/users/:id/assignedCompanies",
              method: "POST",
            },

            // INTERNAL. Use User.assignedCompanies.destroyAll() instead.
            "prototype$__delete__assignedCompanies": {
              url: urlBase + "/users/:id/assignedCompanies",
              method: "DELETE",
            },

            // INTERNAL. Use User.assignedCompanies.count() instead.
            "prototype$__count__assignedCompanies": {
              url: urlBase + "/users/:id/assignedCompanies/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#create
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/users",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#patchOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/users",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#replaceOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/users/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#upsertWithWhere
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/users/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#exists
             * @methodOf lbServices.User
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/users/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#findById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/users/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#replaceById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/users/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#find
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/users",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#findOne
             * @methodOf lbServices.User
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/users/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#updateAll
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/users/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#deleteById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/users/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#count
             * @methodOf lbServices.User
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/users/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$patchAttributes
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/users/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createChangeStream
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/users/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#login
             * @methodOf lbServices.User
             *
             * @description
             *
             * Login a user with username/email and password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `include` – `{string=}` - Related objects to include in the response. See the description of return value for more details.
             *   Default value: `user`.
             *
             *  - `rememberMe` - `boolean` - Whether the authentication credentials
             *     should be remembered in localStorage across app/browser restarts.
             *     Default: `true`.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * The response body contains properties of the AccessToken created on login.
             * Depending on the value of `include` parameter, the body may contain additional properties:
             *   - `user` - `U+007BUserU+007D` - Data of the currently logged in user. (`include=user`)
             *
             */
            "login": {
              params: {
                include: 'user',
              },
              interceptor: {
                response: function(response) {
                  var accessToken = response.data;
                  LoopBackAuth.setUser(
                    accessToken.id, accessToken.userId, accessToken.user);
                  LoopBackAuth.rememberMe =
                    response.config.params.rememberMe !== false;
                  LoopBackAuth.save();
                  return response.resource;
                },
              },
              url: urlBase + "/users/login",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#logout
             * @methodOf lbServices.User
             *
             * @description
             *
             * Logout a user with access token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `access_token` – `{string=}` - Do not supply this argument, it is automatically extracted from request headers.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "logout": {
              interceptor: {
                response: function(response) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return responseError.resource;
                },
              },
              url: urlBase + "/users/logout",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$verify
             * @methodOf lbServices.User
             *
             * @description
             *
             * Trigger user's identity verification with configured verifyOptions
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `verifyOptions` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$verify": {
              url: urlBase + "/users/:id/verify",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#confirm
             * @methodOf lbServices.User
             *
             * @description
             *
             * Confirm a user registration with identity verification token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `uid` – `{string}` -
             *
             *  - `token` – `{string}` -
             *
             *  - `redirect` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "confirm": {
              url: urlBase + "/users/confirm",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#resetPassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * Reset password for a user with email.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "resetPassword": {
              url: urlBase + "/users/reset",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#changePassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * Change a user's password.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `oldPassword` – `{string}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePassword": {
              url: urlBase + "/users/change-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#setPassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * Reset user's password via a password-reset token.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{*=}` -
             *
             *  - `newPassword` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "setPassword": {
              url: urlBase + "/users/reset-password",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#changePassword
             * @methodOf lbServices.User
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "changePassword": {
              url: urlBase + "/users/changePassword",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#createMany
             * @methodOf lbServices.User
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/users",
              method: "POST",
            },

            // INTERNAL. Use Journal.user() instead.
            "::get::Journal::user": {
              url: urlBase + "/Journals/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Company.users.findById() instead.
            "::findById::Company::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/users/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.users.destroyById() instead.
            "::destroyById::Company::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/users/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.users.updateById() instead.
            "::updateById::Company::users": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/users/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.assignedAccountants.findById() instead.
            "::findById::Company::assignedAccountants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/assignedAccountants/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.assignedAccountants.destroyById() instead.
            "::destroyById::Company::assignedAccountants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/assignedAccountants/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.assignedAccountants.updateById() instead.
            "::updateById::Company::assignedAccountants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/assignedAccountants/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.assignedAccountants.link() instead.
            "::link::Company::assignedAccountants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/assignedAccountants/rel/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.assignedAccountants.unlink() instead.
            "::unlink::Company::assignedAccountants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/assignedAccountants/rel/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.assignedAccountants.exists() instead.
            "::exists::Company::assignedAccountants": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/assignedAccountants/rel/:fk",
              method: "HEAD",
            },

            // INTERNAL. Use Company.users() instead.
            "::get::Company::users": {
              isArray: true,
              url: urlBase + "/Companies/:id/users",
              method: "GET",
            },

            // INTERNAL. Use Company.users.create() instead.
            "::create::Company::users": {
              url: urlBase + "/Companies/:id/users",
              method: "POST",
            },

            // INTERNAL. Use Company.users.createMany() instead.
            "::createMany::Company::users": {
              isArray: true,
              url: urlBase + "/Companies/:id/users",
              method: "POST",
            },

            // INTERNAL. Use Company.users.destroyAll() instead.
            "::delete::Company::users": {
              url: urlBase + "/Companies/:id/users",
              method: "DELETE",
            },

            // INTERNAL. Use Company.users.count() instead.
            "::count::Company::users": {
              url: urlBase + "/Companies/:id/users/count",
              method: "GET",
            },

            // INTERNAL. Use Company.assignedAccountants() instead.
            "::get::Company::assignedAccountants": {
              isArray: true,
              url: urlBase + "/Companies/:id/assignedAccountants",
              method: "GET",
            },

            // INTERNAL. Use Company.assignedAccountants.create() instead.
            "::create::Company::assignedAccountants": {
              url: urlBase + "/Companies/:id/assignedAccountants",
              method: "POST",
            },

            // INTERNAL. Use Company.assignedAccountants.createMany() instead.
            "::createMany::Company::assignedAccountants": {
              isArray: true,
              url: urlBase + "/Companies/:id/assignedAccountants",
              method: "POST",
            },

            // INTERNAL. Use Company.assignedAccountants.destroyAll() instead.
            "::delete::Company::assignedAccountants": {
              url: urlBase + "/Companies/:id/assignedAccountants",
              method: "DELETE",
            },

            // INTERNAL. Use Company.assignedAccountants.count() instead.
            "::count::Company::assignedAccountants": {
              url: urlBase + "/Companies/:id/assignedAccountants/count",
              method: "GET",
            },

            // INTERNAL. Use SubAccount.user() instead.
            "::get::SubAccount::user": {
              url: urlBase + "/SubAccounts/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Attachment.user() instead.
            "::get::Attachment::user": {
              url: urlBase + "/Attachments/:id/user",
              method: "GET",
            },

            // INTERNAL. Use BankAccount.user() instead.
            "::get::BankAccount::user": {
              url: urlBase + "/BankAccounts/:id/user",
              method: "GET",
            },

            // INTERNAL. Use KlarnaConnection.user() instead.
            "::get::KlarnaConnection::user": {
              url: urlBase + "/klarna-connections/:id/user",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.user() instead.
            "::get::TransactionBase::user": {
              url: urlBase + "/TransactionBases/:id/user",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.user() instead.
            "::get::BankTransaction::user": {
              url: urlBase + "/BankTransactions/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Invoice.user() instead.
            "::get::Invoice::user": {
              url: urlBase + "/Invoices/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Purchase.user() instead.
            "::get::Purchase::user": {
              url: urlBase + "/Purchases/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Sale.user() instead.
            "::get::Sale::user": {
              url: urlBase + "/Sales/:id/user",
              method: "GET",
            },

            // INTERNAL. Use RecurringSale.user() instead.
            "::get::RecurringSale::user": {
              url: urlBase + "/recurring-sales/:id/user",
              method: "GET",
            },

            // INTERNAL. Use SaleItem.user() instead.
            "::get::SaleItem::user": {
              url: urlBase + "/sale-items/:id/user",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.user() instead.
            "::get::JournalEntry::user": {
              url: urlBase + "/JournalEntries/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Payment.user() instead.
            "::get::Payment::user": {
              url: urlBase + "/Payments/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Customer.user() instead.
            "::get::Customer::user": {
              url: urlBase + "/Customers/:id/user",
              method: "GET",
            },

            // INTERNAL. Use BankRule.user() instead.
            "::get::BankRule::user": {
              url: urlBase + "/BankRules/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Event.user() instead.
            "::get::Event::user": {
              url: urlBase + "/events/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.User#getCurrent
             * @methodOf lbServices.User
             *
             * @description
             *
             * Get data of the currently logged user. Fail with HTTP result 401
             * when there is no user logged in.
             *
             * @param {function(Object,Object)=} successCb
             *    Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *    `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             */
            'getCurrent': {
              url: urlBase + "/users" + '/:id',
              method: 'GET',
              params: {
                id: function() {
                  var id = LoopBackAuth.currentUserId;
                  if (id == null) id = '__anonymous__';
                  return id;
                },
              },
              interceptor: {
                response: function(response) {
                  LoopBackAuth.currentUserData = response.data;
                  return response.resource;
                },
                responseError: function(responseError) {
                  LoopBackAuth.clearUser();
                  LoopBackAuth.clearStorage();
                  return $q.reject(responseError);
                },
              },
              __isGetCurrentUser__: true,
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.User#upsert
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.User#updateOrCreate
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.User#patchOrCreateWithWhere
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.User#update
             * @methodOf lbServices.User
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.User#destroyById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.User#removeById
             * @methodOf lbServices.User
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.User#prototype$updateAttributes
             * @methodOf lbServices.User
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];

        /**
         * @ngdoc method
         * @name lbServices.User#getCachedCurrent
         * @methodOf lbServices.User
         *
         * @description
         *
         * Get data of the currently logged user that was returned by the last
         * call to {@link lbServices.User#login} or
         * {@link lbServices.User#getCurrent}. Return null when there
         * is no user logged in or the data of the current user were not fetched
         * yet.
         *
         * @returns {Object} A User instance.
         */
        R.getCachedCurrent = function() {
          var data = LoopBackAuth.currentUserData;
          return data ? new R(data) : null;
        };

        /**
         * @ngdoc method
         * @name lbServices.User#isAuthenticated
         * @methodOf lbServices.User
         *
         * @returns {boolean} True if the current user is authenticated (logged in).
         */
        R.isAuthenticated = function() {
          return this.getCurrentId() != null;
        };

        /**
         * @ngdoc method
         * @name lbServices.User#getCurrentId
         * @methodOf lbServices.User
         *
         * @returns {Object} Id of the currently logged-in user or null.
         */
        R.getCurrentId = function() {
          return LoopBackAuth.currentUserId;
        };

        /**
        * @ngdoc property
        * @name lbServices.User#modelName
        * @propertyOf lbServices.User
        * @description
        * The name of the model represented by this $resource,
        * i.e. `User`.
        */
        R.modelName = "User";


            /**
             * @ngdoc method
             * @name lbServices.User#company
             * @methodOf lbServices.User
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::User::company"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.User.assignedCompanies
     * @header lbServices.User.assignedCompanies
     * @object
     * @description
     *
     * The object `User.assignedCompanies` groups methods
     * manipulating `Company` instances related to `User`.
     *
     * Call {@link lbServices.User#assignedCompanies User.assignedCompanies()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.User#assignedCompanies
             * @methodOf lbServices.User
             *
             * @description
             *
             * Queries assignedCompanies of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.assignedCompanies = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::User::assignedCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.assignedCompanies#count
             * @methodOf lbServices.User.assignedCompanies
             *
             * @description
             *
             * Counts assignedCompanies of user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.assignedCompanies.count = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::count::User::assignedCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.assignedCompanies#create
             * @methodOf lbServices.User.assignedCompanies
             *
             * @description
             *
             * Creates a new instance in assignedCompanies of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.assignedCompanies.create = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::create::User::assignedCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.assignedCompanies#createMany
             * @methodOf lbServices.User.assignedCompanies
             *
             * @description
             *
             * Creates a new instance in assignedCompanies of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.assignedCompanies.createMany = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::createMany::User::assignedCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.assignedCompanies#destroyAll
             * @methodOf lbServices.User.assignedCompanies
             *
             * @description
             *
             * Deletes all assignedCompanies of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.assignedCompanies.destroyAll = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::delete::User::assignedCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.assignedCompanies#destroyById
             * @methodOf lbServices.User.assignedCompanies
             *
             * @description
             *
             * Delete a related item by id for assignedCompanies.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for assignedCompanies
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.assignedCompanies.destroyById = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::destroyById::User::assignedCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.assignedCompanies#exists
             * @methodOf lbServices.User.assignedCompanies
             *
             * @description
             *
             * Check the existence of assignedCompanies relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for assignedCompanies
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.assignedCompanies.exists = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::exists::User::assignedCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.assignedCompanies#findById
             * @methodOf lbServices.User.assignedCompanies
             *
             * @description
             *
             * Find a related item by id for assignedCompanies.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for assignedCompanies
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.assignedCompanies.findById = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::findById::User::assignedCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.assignedCompanies#link
             * @methodOf lbServices.User.assignedCompanies
             *
             * @description
             *
             * Add a related item by id for assignedCompanies.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for assignedCompanies
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.assignedCompanies.link = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::link::User::assignedCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.assignedCompanies#unlink
             * @methodOf lbServices.User.assignedCompanies
             *
             * @description
             *
             * Remove the assignedCompanies relation to an item by id.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for assignedCompanies
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.assignedCompanies.unlink = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::unlink::User::assignedCompanies"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.User.assignedCompanies#updateById
             * @methodOf lbServices.User.assignedCompanies
             *
             * @description
             *
             * Update a related item by id for assignedCompanies.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - user id
             *
             *  - `fk` – `{*}` - Foreign key for assignedCompanies
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.assignedCompanies.updateById = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::updateById::User::assignedCompanies"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Account
 * @header lbServices.Account
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Account` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Account",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Accounts/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Account#prototype$__findById__journalLines
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Find a related item by id for journalLines.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journalLines
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "prototype$__findById__journalLines": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Accounts/:id/journalLines/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#prototype$__destroyById__journalLines
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Delete a related item by id for journalLines.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journalLines
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__journalLines": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Accounts/:id/journalLines/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#prototype$__updateById__journalLines
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Update a related item by id for journalLines.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `fk` – `{*}` - Foreign key for journalLines
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "prototype$__updateById__journalLines": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Accounts/:id/journalLines/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Account.subCategory() instead.
            "prototype$__get__subCategory": {
              url: urlBase + "/Accounts/:id/subCategory",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#prototype$__get__journalLines
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Queries journalLines of Account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "prototype$__get__journalLines": {
              isArray: true,
              url: urlBase + "/Accounts/:id/journalLines",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#prototype$__create__journalLines
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Creates a new instance in journalLines of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "prototype$__create__journalLines": {
              url: urlBase + "/Accounts/:id/journalLines",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#prototype$__delete__journalLines
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Deletes all journalLines of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__journalLines": {
              url: urlBase + "/Accounts/:id/journalLines",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#prototype$__count__journalLines
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Counts journalLines of Account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__journalLines": {
              url: urlBase + "/Accounts/:id/journalLines/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#create
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Accounts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#patchOrCreate
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Accounts",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#replaceOrCreate
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Accounts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#upsertWithWhere
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Accounts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#exists
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Accounts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#findById
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Accounts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#replaceById
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Accounts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#find
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Accounts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#findOne
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Accounts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#updateAll
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Accounts/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#deleteById
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Accounts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#count
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Accounts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#prototype$patchAttributes
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Accounts/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#createChangeStream
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Accounts/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#balance
             * @methodOf lbServices.Account
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `beginDate` – `{date=}` -
             *
             *  - `endDate` – `{date=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `balance` – `{number=}` -
             */
            "balance": {
              url: urlBase + "/Accounts/:id/balance",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#systemAccounts
             * @methodOf lbServices.Account
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `systemAccounts` – `{object=}` -
             */
            "systemAccounts": {
              url: urlBase + "/Accounts/system",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#findApplicable
             * @methodOf lbServices.Account
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "findApplicable": {
              isArray: true,
              url: urlBase + "/Accounts/applicable",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Account#createMany
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Accounts",
              method: "POST",
            },

            // INTERNAL. Use AccountCategory.accounts.findById() instead.
            "::findById::AccountCategory::accounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/AccountCategories/:id/accounts/:fk",
              method: "GET",
            },

            // INTERNAL. Use AccountCategory.accounts.destroyById() instead.
            "::destroyById::AccountCategory::accounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/AccountCategories/:id/accounts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use AccountCategory.accounts.updateById() instead.
            "::updateById::AccountCategory::accounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/AccountCategories/:id/accounts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use AccountCategory.accounts() instead.
            "::get::AccountCategory::accounts": {
              isArray: true,
              url: urlBase + "/AccountCategories/:id/accounts",
              method: "GET",
            },

            // INTERNAL. Use AccountCategory.accounts.create() instead.
            "::create::AccountCategory::accounts": {
              url: urlBase + "/AccountCategories/:id/accounts",
              method: "POST",
            },

            // INTERNAL. Use AccountCategory.accounts.createMany() instead.
            "::createMany::AccountCategory::accounts": {
              isArray: true,
              url: urlBase + "/AccountCategories/:id/accounts",
              method: "POST",
            },

            // INTERNAL. Use AccountCategory.accounts.destroyAll() instead.
            "::delete::AccountCategory::accounts": {
              url: urlBase + "/AccountCategories/:id/accounts",
              method: "DELETE",
            },

            // INTERNAL. Use AccountCategory.accounts.count() instead.
            "::count::AccountCategory::accounts": {
              url: urlBase + "/AccountCategories/:id/accounts/count",
              method: "GET",
            },

            // INTERNAL. Use BankRule.account() instead.
            "::get::BankRule::account": {
              url: urlBase + "/BankRules/:id/account",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Account#upsert
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Account#updateOrCreate
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Account#patchOrCreateWithWhere
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Account#update
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Account#destroyById
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Account#removeById
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Account#prototype$updateAttributes
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Account#modelName
        * @propertyOf lbServices.Account
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Account`.
        */
        R.modelName = "Account";


            /**
             * @ngdoc method
             * @name lbServices.Account#subCategory
             * @methodOf lbServices.Account
             *
             * @description
             *
             * Fetches belongsTo relation subCategory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Account id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
        R.subCategory = function() {
          var TargetResource = $injector.get("AccountCategory");
          var action = TargetResource["::get::Account::subCategory"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.SubAccount
 * @header lbServices.SubAccount
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `SubAccount` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "SubAccount",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/SubAccounts/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#prototype$__findById__journalLines
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Find a related item by id for journalLines.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journalLines
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
            "prototype$__findById__journalLines": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SubAccounts/:id/journalLines/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#prototype$__destroyById__journalLines
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Delete a related item by id for journalLines.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journalLines
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__journalLines": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SubAccounts/:id/journalLines/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#prototype$__updateById__journalLines
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Update a related item by id for journalLines.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubAccount id
             *
             *  - `fk` – `{*}` - Foreign key for journalLines
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
            "prototype$__updateById__journalLines": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/SubAccounts/:id/journalLines/:fk",
              method: "PUT",
            },

            // INTERNAL. Use SubAccount.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/SubAccounts/:id/company",
              method: "GET",
            },

            // INTERNAL. Use SubAccount.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/SubAccounts/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#prototype$__get__journalLines
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Queries journalLines of SubAccount.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
            "prototype$__get__journalLines": {
              isArray: true,
              url: urlBase + "/SubAccounts/:id/journalLines",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#prototype$__create__journalLines
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Creates a new instance in journalLines of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubAccount id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
            "prototype$__create__journalLines": {
              url: urlBase + "/SubAccounts/:id/journalLines",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#prototype$__delete__journalLines
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Deletes all journalLines of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__journalLines": {
              url: urlBase + "/SubAccounts/:id/journalLines",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#prototype$__count__journalLines
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Counts journalLines of SubAccount.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__journalLines": {
              url: urlBase + "/SubAccounts/:id/journalLines/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#create
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/SubAccounts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#patchOrCreate
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/SubAccounts",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#replaceOrCreate
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/SubAccounts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#upsertWithWhere
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/SubAccounts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#exists
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/SubAccounts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#findById
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/SubAccounts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#replaceById
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/SubAccounts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#find
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/SubAccounts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#findOne
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/SubAccounts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#deleteById
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/SubAccounts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#count
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/SubAccounts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#prototype$patchAttributes
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/SubAccounts/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#createMany
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/SubAccounts",
              method: "POST",
            },

            // INTERNAL. Use BankRule.subAccount() instead.
            "::get::BankRule::subAccount": {
              url: urlBase + "/BankRules/:id/subAccount",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.SubAccount#upsert
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#updateOrCreate
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#patchOrCreateWithWhere
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#destroyById
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#removeById
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#prototype$updateAttributes
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.SubAccount#modelName
        * @propertyOf lbServices.SubAccount
        * @description
        * The name of the model represented by this $resource,
        * i.e. `SubAccount`.
        */
        R.modelName = "SubAccount";


            /**
             * @ngdoc method
             * @name lbServices.SubAccount#company
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::SubAccount::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.SubAccount#user
             * @methodOf lbServices.SubAccount
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SubAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::SubAccount::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.AccountCategory
 * @header lbServices.AccountCategory
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `AccountCategory` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "AccountCategory",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/AccountCategories/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use AccountCategory.subCategories.findById() instead.
            "prototype$__findById__subCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/AccountCategories/:id/subCategories/:fk",
              method: "GET",
            },

            // INTERNAL. Use AccountCategory.subCategories.destroyById() instead.
            "prototype$__destroyById__subCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/AccountCategories/:id/subCategories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use AccountCategory.subCategories.updateById() instead.
            "prototype$__updateById__subCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/AccountCategories/:id/subCategories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use AccountCategory.category() instead.
            "prototype$__get__category": {
              url: urlBase + "/AccountCategories/:id/category",
              method: "GET",
            },

            // INTERNAL. Use AccountCategory.accounts.findById() instead.
            "prototype$__findById__accounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/AccountCategories/:id/accounts/:fk",
              method: "GET",
            },

            // INTERNAL. Use AccountCategory.accounts.destroyById() instead.
            "prototype$__destroyById__accounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/AccountCategories/:id/accounts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use AccountCategory.accounts.updateById() instead.
            "prototype$__updateById__accounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/AccountCategories/:id/accounts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use AccountCategory.subCategories() instead.
            "prototype$__get__subCategories": {
              isArray: true,
              url: urlBase + "/AccountCategories/:id/subCategories",
              method: "GET",
            },

            // INTERNAL. Use AccountCategory.subCategories.create() instead.
            "prototype$__create__subCategories": {
              url: urlBase + "/AccountCategories/:id/subCategories",
              method: "POST",
            },

            // INTERNAL. Use AccountCategory.subCategories.destroyAll() instead.
            "prototype$__delete__subCategories": {
              url: urlBase + "/AccountCategories/:id/subCategories",
              method: "DELETE",
            },

            // INTERNAL. Use AccountCategory.subCategories.count() instead.
            "prototype$__count__subCategories": {
              url: urlBase + "/AccountCategories/:id/subCategories/count",
              method: "GET",
            },

            // INTERNAL. Use AccountCategory.accounts() instead.
            "prototype$__get__accounts": {
              isArray: true,
              url: urlBase + "/AccountCategories/:id/accounts",
              method: "GET",
            },

            // INTERNAL. Use AccountCategory.accounts.create() instead.
            "prototype$__create__accounts": {
              url: urlBase + "/AccountCategories/:id/accounts",
              method: "POST",
            },

            // INTERNAL. Use AccountCategory.accounts.destroyAll() instead.
            "prototype$__delete__accounts": {
              url: urlBase + "/AccountCategories/:id/accounts",
              method: "DELETE",
            },

            // INTERNAL. Use AccountCategory.accounts.count() instead.
            "prototype$__count__accounts": {
              url: urlBase + "/AccountCategories/:id/accounts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#__get__balance
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Queries balance of AccountCategory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
            "__get__balance": {
              isArray: true,
              url: urlBase + "/AccountCategories/balance",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#__create__balance
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Creates a new instance in balance of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
            "__create__balance": {
              url: urlBase + "/AccountCategories/balance",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#__delete__balance
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Deletes all balance of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "__delete__balance": {
              url: urlBase + "/AccountCategories/balance",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#__count__balance
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Counts balance of AccountCategory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "__count__balance": {
              url: urlBase + "/AccountCategories/balance/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#create
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/AccountCategories",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#patchOrCreate
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/AccountCategories",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#replaceOrCreate
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/AccountCategories/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#upsertWithWhere
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/AccountCategories/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#exists
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/AccountCategories/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#findById
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/AccountCategories/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#replaceById
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/AccountCategories/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#find
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/AccountCategories",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#findOne
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/AccountCategories/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#updateAll
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/AccountCategories/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#deleteById
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/AccountCategories/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#count
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/AccountCategories/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#prototype$patchAttributes
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/AccountCategories/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#createChangeStream
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/AccountCategories/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#createMany
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/AccountCategories",
              method: "POST",
            },

            // INTERNAL. Use Account.subCategory() instead.
            "::get::Account::subCategory": {
              url: urlBase + "/Accounts/:id/subCategory",
              method: "GET",
            },

            // INTERNAL. Use AccountCategory.subCategories.findById() instead.
            "::findById::AccountCategory::subCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/AccountCategories/:id/subCategories/:fk",
              method: "GET",
            },

            // INTERNAL. Use AccountCategory.subCategories.destroyById() instead.
            "::destroyById::AccountCategory::subCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/AccountCategories/:id/subCategories/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use AccountCategory.subCategories.updateById() instead.
            "::updateById::AccountCategory::subCategories": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/AccountCategories/:id/subCategories/:fk",
              method: "PUT",
            },

            // INTERNAL. Use AccountCategory.category() instead.
            "::get::AccountCategory::category": {
              url: urlBase + "/AccountCategories/:id/category",
              method: "GET",
            },

            // INTERNAL. Use AccountCategory.subCategories() instead.
            "::get::AccountCategory::subCategories": {
              isArray: true,
              url: urlBase + "/AccountCategories/:id/subCategories",
              method: "GET",
            },

            // INTERNAL. Use AccountCategory.subCategories.create() instead.
            "::create::AccountCategory::subCategories": {
              url: urlBase + "/AccountCategories/:id/subCategories",
              method: "POST",
            },

            // INTERNAL. Use AccountCategory.subCategories.createMany() instead.
            "::createMany::AccountCategory::subCategories": {
              isArray: true,
              url: urlBase + "/AccountCategories/:id/subCategories",
              method: "POST",
            },

            // INTERNAL. Use AccountCategory.subCategories.destroyAll() instead.
            "::delete::AccountCategory::subCategories": {
              url: urlBase + "/AccountCategories/:id/subCategories",
              method: "DELETE",
            },

            // INTERNAL. Use AccountCategory.subCategories.count() instead.
            "::count::AccountCategory::subCategories": {
              url: urlBase + "/AccountCategories/:id/subCategories/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#upsert
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#updateOrCreate
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#patchOrCreateWithWhere
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#update
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#destroyById
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#removeById
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#prototype$updateAttributes
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.AccountCategory#modelName
        * @propertyOf lbServices.AccountCategory
        * @description
        * The name of the model represented by this $resource,
        * i.e. `AccountCategory`.
        */
        R.modelName = "AccountCategory";

    /**
     * @ngdoc object
     * @name lbServices.AccountCategory.subCategories
     * @header lbServices.AccountCategory.subCategories
     * @object
     * @description
     *
     * The object `AccountCategory.subCategories` groups methods
     * manipulating `AccountCategory` instances related to `AccountCategory`.
     *
     * Call {@link lbServices.AccountCategory#subCategories AccountCategory.subCategories()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#subCategories
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Queries subCategories of AccountCategory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
        R.subCategories = function() {
          var TargetResource = $injector.get("AccountCategory");
          var action = TargetResource["::get::AccountCategory::subCategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory.subCategories#count
             * @methodOf lbServices.AccountCategory.subCategories
             *
             * @description
             *
             * Counts subCategories of AccountCategory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.subCategories.count = function() {
          var TargetResource = $injector.get("AccountCategory");
          var action = TargetResource["::count::AccountCategory::subCategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory.subCategories#create
             * @methodOf lbServices.AccountCategory.subCategories
             *
             * @description
             *
             * Creates a new instance in subCategories of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
        R.subCategories.create = function() {
          var TargetResource = $injector.get("AccountCategory");
          var action = TargetResource["::create::AccountCategory::subCategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory.subCategories#createMany
             * @methodOf lbServices.AccountCategory.subCategories
             *
             * @description
             *
             * Creates a new instance in subCategories of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
        R.subCategories.createMany = function() {
          var TargetResource = $injector.get("AccountCategory");
          var action = TargetResource["::createMany::AccountCategory::subCategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory.subCategories#destroyAll
             * @methodOf lbServices.AccountCategory.subCategories
             *
             * @description
             *
             * Deletes all subCategories of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subCategories.destroyAll = function() {
          var TargetResource = $injector.get("AccountCategory");
          var action = TargetResource["::delete::AccountCategory::subCategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory.subCategories#destroyById
             * @methodOf lbServices.AccountCategory.subCategories
             *
             * @description
             *
             * Delete a related item by id for subCategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subCategories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.subCategories.destroyById = function() {
          var TargetResource = $injector.get("AccountCategory");
          var action = TargetResource["::destroyById::AccountCategory::subCategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory.subCategories#findById
             * @methodOf lbServices.AccountCategory.subCategories
             *
             * @description
             *
             * Find a related item by id for subCategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for subCategories
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
        R.subCategories.findById = function() {
          var TargetResource = $injector.get("AccountCategory");
          var action = TargetResource["::findById::AccountCategory::subCategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory.subCategories#updateById
             * @methodOf lbServices.AccountCategory.subCategories
             *
             * @description
             *
             * Update a related item by id for subCategories.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             *  - `fk` – `{*}` - Foreign key for subCategories
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
        R.subCategories.updateById = function() {
          var TargetResource = $injector.get("AccountCategory");
          var action = TargetResource["::updateById::AccountCategory::subCategories"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#category
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Fetches belongsTo relation category.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `AccountCategory` object.)
             * </em>
             */
        R.category = function() {
          var TargetResource = $injector.get("AccountCategory");
          var action = TargetResource["::get::AccountCategory::category"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.AccountCategory.accounts
     * @header lbServices.AccountCategory.accounts
     * @object
     * @description
     *
     * The object `AccountCategory.accounts` groups methods
     * manipulating `Account` instances related to `AccountCategory`.
     *
     * Call {@link lbServices.AccountCategory#accounts AccountCategory.accounts()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.AccountCategory#accounts
             * @methodOf lbServices.AccountCategory
             *
             * @description
             *
             * Queries accounts of AccountCategory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R.accounts = function() {
          var TargetResource = $injector.get("Account");
          var action = TargetResource["::get::AccountCategory::accounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory.accounts#count
             * @methodOf lbServices.AccountCategory.accounts
             *
             * @description
             *
             * Counts accounts of AccountCategory.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.accounts.count = function() {
          var TargetResource = $injector.get("Account");
          var action = TargetResource["::count::AccountCategory::accounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory.accounts#create
             * @methodOf lbServices.AccountCategory.accounts
             *
             * @description
             *
             * Creates a new instance in accounts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R.accounts.create = function() {
          var TargetResource = $injector.get("Account");
          var action = TargetResource["::create::AccountCategory::accounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory.accounts#createMany
             * @methodOf lbServices.AccountCategory.accounts
             *
             * @description
             *
             * Creates a new instance in accounts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R.accounts.createMany = function() {
          var TargetResource = $injector.get("Account");
          var action = TargetResource["::createMany::AccountCategory::accounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory.accounts#destroyAll
             * @methodOf lbServices.AccountCategory.accounts
             *
             * @description
             *
             * Deletes all accounts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.accounts.destroyAll = function() {
          var TargetResource = $injector.get("Account");
          var action = TargetResource["::delete::AccountCategory::accounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory.accounts#destroyById
             * @methodOf lbServices.AccountCategory.accounts
             *
             * @description
             *
             * Delete a related item by id for accounts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accounts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.accounts.destroyById = function() {
          var TargetResource = $injector.get("Account");
          var action = TargetResource["::destroyById::AccountCategory::accounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory.accounts#findById
             * @methodOf lbServices.AccountCategory.accounts
             *
             * @description
             *
             * Find a related item by id for accounts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for accounts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R.accounts.findById = function() {
          var TargetResource = $injector.get("Account");
          var action = TargetResource["::findById::AccountCategory::accounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.AccountCategory.accounts#updateById
             * @methodOf lbServices.AccountCategory.accounts
             *
             * @description
             *
             * Update a related item by id for accounts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - AccountCategory id
             *
             *  - `fk` – `{*}` - Foreign key for accounts
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R.accounts.updateById = function() {
          var TargetResource = $injector.get("Account");
          var action = TargetResource["::updateById::AccountCategory::accounts"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Attachment
 * @header lbServices.Attachment
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Attachment` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Attachment",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Attachments/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Attachment#prototype$__get__transaction
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Fetches belongsTo relation transaction.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Attachment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
            "prototype$__get__transaction": {
              url: urlBase + "/Attachments/:id/transaction",
              method: "GET",
            },

            // INTERNAL. Use Attachment.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/Attachments/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Attachment.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Attachments/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attachment#create
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Attachments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attachment#patchOrCreate
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Attachments",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attachment#replaceOrCreate
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Attachments/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attachment#upsertWithWhere
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Attachments/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attachment#exists
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Attachments/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attachment#findById
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Attachments/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attachment#replaceById
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Attachments/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attachment#find
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Attachments",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attachment#findOne
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Attachments/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attachment#deleteById
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Attachments/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attachment#count
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Attachments/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attachment#prototype$patchAttributes
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Attachment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Attachments/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attachment#download
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `res` – `{object=}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             *  - `format` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "download": {
              url: urlBase + "/Attachments/:id/download",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attachment#uploadRemote
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `attachment` – `{object=}` -
             */
            "uploadRemote": {
              url: urlBase + "/Attachments/upload",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Attachment#createMany
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Attachments",
              method: "POST",
            },

            // INTERNAL. Use TransactionBase.Attachment() instead.
            "::get::TransactionBase::Attachment": {
              url: urlBase + "/TransactionBases/:id/Attachment",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.Attachment.create() instead.
            "::create::TransactionBase::Attachment": {
              url: urlBase + "/TransactionBases/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use TransactionBase.Attachment.createMany() instead.
            "::createMany::TransactionBase::Attachment": {
              isArray: true,
              url: urlBase + "/TransactionBases/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use TransactionBase.Attachment.update() instead.
            "::update::TransactionBase::Attachment": {
              url: urlBase + "/TransactionBases/:id/Attachment",
              method: "PUT",
            },

            // INTERNAL. Use TransactionBase.Attachment.destroy() instead.
            "::destroy::TransactionBase::Attachment": {
              url: urlBase + "/TransactionBases/:id/Attachment",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.Attachment() instead.
            "::get::BankTransaction::Attachment": {
              url: urlBase + "/BankTransactions/:id/Attachment",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.Attachment.create() instead.
            "::create::BankTransaction::Attachment": {
              url: urlBase + "/BankTransactions/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.Attachment.createMany() instead.
            "::createMany::BankTransaction::Attachment": {
              isArray: true,
              url: urlBase + "/BankTransactions/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.Attachment.update() instead.
            "::update::BankTransaction::Attachment": {
              url: urlBase + "/BankTransactions/:id/Attachment",
              method: "PUT",
            },

            // INTERNAL. Use BankTransaction.Attachment.destroy() instead.
            "::destroy::BankTransaction::Attachment": {
              url: urlBase + "/BankTransactions/:id/Attachment",
              method: "DELETE",
            },

            // INTERNAL. Use Invoice.Attachment() instead.
            "::get::Invoice::Attachment": {
              url: urlBase + "/Invoices/:id/Attachment",
              method: "GET",
            },

            // INTERNAL. Use Invoice.Attachment.create() instead.
            "::create::Invoice::Attachment": {
              url: urlBase + "/Invoices/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use Invoice.Attachment.createMany() instead.
            "::createMany::Invoice::Attachment": {
              isArray: true,
              url: urlBase + "/Invoices/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use Invoice.Attachment.update() instead.
            "::update::Invoice::Attachment": {
              url: urlBase + "/Invoices/:id/Attachment",
              method: "PUT",
            },

            // INTERNAL. Use Invoice.Attachment.destroy() instead.
            "::destroy::Invoice::Attachment": {
              url: urlBase + "/Invoices/:id/Attachment",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.Attachment() instead.
            "::get::Purchase::Attachment": {
              url: urlBase + "/Purchases/:id/Attachment",
              method: "GET",
            },

            // INTERNAL. Use Purchase.Attachment.create() instead.
            "::create::Purchase::Attachment": {
              url: urlBase + "/Purchases/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use Purchase.Attachment.createMany() instead.
            "::createMany::Purchase::Attachment": {
              isArray: true,
              url: urlBase + "/Purchases/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use Purchase.Attachment.update() instead.
            "::update::Purchase::Attachment": {
              url: urlBase + "/Purchases/:id/Attachment",
              method: "PUT",
            },

            // INTERNAL. Use Purchase.Attachment.destroy() instead.
            "::destroy::Purchase::Attachment": {
              url: urlBase + "/Purchases/:id/Attachment",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.Attachment() instead.
            "::get::Sale::Attachment": {
              url: urlBase + "/Sales/:id/Attachment",
              method: "GET",
            },

            // INTERNAL. Use Sale.Attachment.create() instead.
            "::create::Sale::Attachment": {
              url: urlBase + "/Sales/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use Sale.Attachment.createMany() instead.
            "::createMany::Sale::Attachment": {
              isArray: true,
              url: urlBase + "/Sales/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use Sale.Attachment.update() instead.
            "::update::Sale::Attachment": {
              url: urlBase + "/Sales/:id/Attachment",
              method: "PUT",
            },

            // INTERNAL. Use Sale.Attachment.destroy() instead.
            "::destroy::Sale::Attachment": {
              url: urlBase + "/Sales/:id/Attachment",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.Attachment() instead.
            "::get::JournalEntry::Attachment": {
              url: urlBase + "/JournalEntries/:id/Attachment",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.Attachment.create() instead.
            "::create::JournalEntry::Attachment": {
              url: urlBase + "/JournalEntries/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use JournalEntry.Attachment.createMany() instead.
            "::createMany::JournalEntry::Attachment": {
              isArray: true,
              url: urlBase + "/JournalEntries/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use JournalEntry.Attachment.update() instead.
            "::update::JournalEntry::Attachment": {
              url: urlBase + "/JournalEntries/:id/Attachment",
              method: "PUT",
            },

            // INTERNAL. Use JournalEntry.Attachment.destroy() instead.
            "::destroy::JournalEntry::Attachment": {
              url: urlBase + "/JournalEntries/:id/Attachment",
              method: "DELETE",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Attachment#upsert
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Attachment#updateOrCreate
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Attachment#patchOrCreateWithWhere
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Attachment#destroyById
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Attachment#removeById
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Attachment#prototype$updateAttributes
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Attachment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Attachment#modelName
        * @propertyOf lbServices.Attachment
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Attachment`.
        */
        R.modelName = "Attachment";


            /**
             * @ngdoc method
             * @name lbServices.Attachment#company
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Attachment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::Attachment::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Attachment#user
             * @methodOf lbServices.Attachment
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Attachment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Attachment::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Bank
 * @header lbServices.Bank
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Bank` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Bank",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Banks/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Bank#replaceOrCreate
             * @methodOf lbServices.Bank
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bank` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Banks/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bank#upsertWithWhere
             * @methodOf lbServices.Bank
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bank` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Banks/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bank#exists
             * @methodOf lbServices.Bank
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Banks/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bank#findById
             * @methodOf lbServices.Bank
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bank` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Banks/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bank#replaceById
             * @methodOf lbServices.Bank
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bank` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Banks/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bank#find
             * @methodOf lbServices.Bank
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bank` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Banks",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bank#findOne
             * @methodOf lbServices.Bank
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bank` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Banks/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bank#count
             * @methodOf lbServices.Bank
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Banks/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Bank#prototype$patchAttributes
             * @methodOf lbServices.Bank
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bank id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bank` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Banks/:id",
              method: "PATCH",
            },

            // INTERNAL. Use BankAccount.bank() instead.
            "::get::BankAccount::bank": {
              url: urlBase + "/BankAccounts/:id/bank",
              method: "GET",
            },

            // INTERNAL. Use KlarnaConnection.bank() instead.
            "::get::KlarnaConnection::bank": {
              url: urlBase + "/klarna-connections/:id/bank",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Bank#patchOrCreateWithWhere
             * @methodOf lbServices.Bank
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bank` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Bank#prototype$updateAttributes
             * @methodOf lbServices.Bank
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Bank id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bank` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Bank#modelName
        * @propertyOf lbServices.Bank
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Bank`.
        */
        R.modelName = "Bank";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.BankAccount
 * @header lbServices.BankAccount
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `BankAccount` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "BankAccount",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/BankAccounts/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use BankAccount.bank() instead.
            "prototype$__get__bank": {
              url: urlBase + "/BankAccounts/:id/bank",
              method: "GET",
            },

            // INTERNAL. Use BankAccount.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/BankAccounts/:id/company",
              method: "GET",
            },

            // INTERNAL. Use BankAccount.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/BankAccounts/:id/user",
              method: "GET",
            },

            // INTERNAL. Use BankAccount.klarnaConnection() instead.
            "prototype$__get__klarnaConnection": {
              url: urlBase + "/BankAccounts/:id/klarnaConnection",
              method: "GET",
            },

            // INTERNAL. Use BankAccount.bankTransactions.findById() instead.
            "prototype$__findById__bankTransactions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankAccounts/:id/bankTransactions/:fk",
              method: "GET",
            },

            // INTERNAL. Use BankAccount.bankTransactions.destroyById() instead.
            "prototype$__destroyById__bankTransactions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankAccounts/:id/bankTransactions/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use BankAccount.bankTransactions.updateById() instead.
            "prototype$__updateById__bankTransactions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankAccounts/:id/bankTransactions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use BankAccount.bankTransactions() instead.
            "prototype$__get__bankTransactions": {
              isArray: true,
              url: urlBase + "/BankAccounts/:id/bankTransactions",
              method: "GET",
            },

            // INTERNAL. Use BankAccount.bankTransactions.create() instead.
            "prototype$__create__bankTransactions": {
              url: urlBase + "/BankAccounts/:id/bankTransactions",
              method: "POST",
            },

            // INTERNAL. Use BankAccount.bankTransactions.destroyAll() instead.
            "prototype$__delete__bankTransactions": {
              url: urlBase + "/BankAccounts/:id/bankTransactions",
              method: "DELETE",
            },

            // INTERNAL. Use BankAccount.bankTransactions.count() instead.
            "prototype$__count__bankTransactions": {
              url: urlBase + "/BankAccounts/:id/bankTransactions/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#create
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/BankAccounts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#patchOrCreate
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/BankAccounts",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#replaceOrCreate
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/BankAccounts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#upsertWithWhere
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/BankAccounts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#exists
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/BankAccounts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#findById
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/BankAccounts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#replaceById
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/BankAccounts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#find
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/BankAccounts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#findOne
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/BankAccounts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#deleteById
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/BankAccounts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#count
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/BankAccounts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#prototype$patchAttributes
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/BankAccounts/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#autoImportStatus
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `status` – `{string=}` -
             */
            "autoImportStatus": {
              url: urlBase + "/BankAccounts/:id/autoImport",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#autoImport
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `status` – `{string=}` -
             */
            "autoImport": {
              url: urlBase + "/BankAccounts/:id/autoImport",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#uploadBankStatement
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "uploadBankStatement": {
              url: urlBase + "/BankAccounts/:id/uploadBankStatement",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#autoMatch
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `id` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `status` – `{string=}` -
             */
            "autoMatch": {
              url: urlBase + "/BankAccounts/:id/autoMatch",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#createMany
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/BankAccounts",
              method: "POST",
            },

            // INTERNAL. Use Company.bankAccounts.findById() instead.
            "::findById::Company::bankAccounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/bankAccounts/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.bankAccounts.destroyById() instead.
            "::destroyById::Company::bankAccounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/bankAccounts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.bankAccounts.updateById() instead.
            "::updateById::Company::bankAccounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/bankAccounts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.bankAccounts() instead.
            "::get::Company::bankAccounts": {
              isArray: true,
              url: urlBase + "/Companies/:id/bankAccounts",
              method: "GET",
            },

            // INTERNAL. Use Company.bankAccounts.create() instead.
            "::create::Company::bankAccounts": {
              url: urlBase + "/Companies/:id/bankAccounts",
              method: "POST",
            },

            // INTERNAL. Use Company.bankAccounts.createMany() instead.
            "::createMany::Company::bankAccounts": {
              isArray: true,
              url: urlBase + "/Companies/:id/bankAccounts",
              method: "POST",
            },

            // INTERNAL. Use Company.bankAccounts.destroyAll() instead.
            "::delete::Company::bankAccounts": {
              url: urlBase + "/Companies/:id/bankAccounts",
              method: "DELETE",
            },

            // INTERNAL. Use Company.bankAccounts.count() instead.
            "::count::Company::bankAccounts": {
              url: urlBase + "/Companies/:id/bankAccounts/count",
              method: "GET",
            },

            // INTERNAL. Use KlarnaConnection.bankAccounts.findById() instead.
            "::findById::KlarnaConnection::bankAccounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/klarna-connections/:id/bank-accounts/:fk",
              method: "GET",
            },

            // INTERNAL. Use KlarnaConnection.bankAccounts.destroyById() instead.
            "::destroyById::KlarnaConnection::bankAccounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/klarna-connections/:id/bank-accounts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use KlarnaConnection.bankAccounts.updateById() instead.
            "::updateById::KlarnaConnection::bankAccounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/klarna-connections/:id/bank-accounts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use KlarnaConnection.bankAccounts() instead.
            "::get::KlarnaConnection::bankAccounts": {
              isArray: true,
              url: urlBase + "/klarna-connections/:id/bank-accounts",
              method: "GET",
            },

            // INTERNAL. Use KlarnaConnection.bankAccounts.create() instead.
            "::create::KlarnaConnection::bankAccounts": {
              url: urlBase + "/klarna-connections/:id/bank-accounts",
              method: "POST",
            },

            // INTERNAL. Use KlarnaConnection.bankAccounts.createMany() instead.
            "::createMany::KlarnaConnection::bankAccounts": {
              isArray: true,
              url: urlBase + "/klarna-connections/:id/bank-accounts",
              method: "POST",
            },

            // INTERNAL. Use KlarnaConnection.bankAccounts.destroyAll() instead.
            "::delete::KlarnaConnection::bankAccounts": {
              url: urlBase + "/klarna-connections/:id/bank-accounts",
              method: "DELETE",
            },

            // INTERNAL. Use KlarnaConnection.bankAccounts.count() instead.
            "::count::KlarnaConnection::bankAccounts": {
              url: urlBase + "/klarna-connections/:id/bank-accounts/count",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.bankAccount() instead.
            "::get::BankTransaction::bankAccount": {
              url: urlBase + "/BankTransactions/:id/bankAccount",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.BankAccount#upsert
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#updateOrCreate
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#patchOrCreateWithWhere
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#destroyById
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#removeById
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#prototype$updateAttributes
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.BankAccount#modelName
        * @propertyOf lbServices.BankAccount
        * @description
        * The name of the model represented by this $resource,
        * i.e. `BankAccount`.
        */
        R.modelName = "BankAccount";


            /**
             * @ngdoc method
             * @name lbServices.BankAccount#bank
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Fetches belongsTo relation bank.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bank` object.)
             * </em>
             */
        R.bank = function() {
          var TargetResource = $injector.get("Bank");
          var action = TargetResource["::get::BankAccount::bank"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#company
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::BankAccount::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#user
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::BankAccount::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankAccount#klarnaConnection
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Fetches belongsTo relation klarnaConnection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
        R.klarnaConnection = function() {
          var TargetResource = $injector.get("KlarnaConnection");
          var action = TargetResource["::get::BankAccount::klarnaConnection"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.BankAccount.bankTransactions
     * @header lbServices.BankAccount.bankTransactions
     * @object
     * @description
     *
     * The object `BankAccount.bankTransactions` groups methods
     * manipulating `BankTransaction` instances related to `BankAccount`.
     *
     * Call {@link lbServices.BankAccount#bankTransactions BankAccount.bankTransactions()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.BankAccount#bankTransactions
             * @methodOf lbServices.BankAccount
             *
             * @description
             *
             * Queries bankTransactions of BankAccount.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
        R.bankTransactions = function() {
          var TargetResource = $injector.get("BankTransaction");
          var action = TargetResource["::get::BankAccount::bankTransactions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankAccount.bankTransactions#count
             * @methodOf lbServices.BankAccount.bankTransactions
             *
             * @description
             *
             * Counts bankTransactions of BankAccount.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.bankTransactions.count = function() {
          var TargetResource = $injector.get("BankTransaction");
          var action = TargetResource["::count::BankAccount::bankTransactions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankAccount.bankTransactions#create
             * @methodOf lbServices.BankAccount.bankTransactions
             *
             * @description
             *
             * Creates a new instance in bankTransactions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankAccount id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
        R.bankTransactions.create = function() {
          var TargetResource = $injector.get("BankTransaction");
          var action = TargetResource["::create::BankAccount::bankTransactions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankAccount.bankTransactions#createMany
             * @methodOf lbServices.BankAccount.bankTransactions
             *
             * @description
             *
             * Creates a new instance in bankTransactions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankAccount id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
        R.bankTransactions.createMany = function() {
          var TargetResource = $injector.get("BankTransaction");
          var action = TargetResource["::createMany::BankAccount::bankTransactions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankAccount.bankTransactions#destroyAll
             * @methodOf lbServices.BankAccount.bankTransactions
             *
             * @description
             *
             * Deletes all bankTransactions of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bankTransactions.destroyAll = function() {
          var TargetResource = $injector.get("BankTransaction");
          var action = TargetResource["::delete::BankAccount::bankTransactions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankAccount.bankTransactions#destroyById
             * @methodOf lbServices.BankAccount.bankTransactions
             *
             * @description
             *
             * Delete a related item by id for bankTransactions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bankTransactions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bankTransactions.destroyById = function() {
          var TargetResource = $injector.get("BankTransaction");
          var action = TargetResource["::destroyById::BankAccount::bankTransactions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankAccount.bankTransactions#findById
             * @methodOf lbServices.BankAccount.bankTransactions
             *
             * @description
             *
             * Find a related item by id for bankTransactions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankAccount id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bankTransactions
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
        R.bankTransactions.findById = function() {
          var TargetResource = $injector.get("BankTransaction");
          var action = TargetResource["::findById::BankAccount::bankTransactions"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankAccount.bankTransactions#updateById
             * @methodOf lbServices.BankAccount.bankTransactions
             *
             * @description
             *
             * Update a related item by id for bankTransactions.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankAccount id
             *
             *  - `fk` – `{*}` - Foreign key for bankTransactions
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
        R.bankTransactions.updateById = function() {
          var TargetResource = $injector.get("BankTransaction");
          var action = TargetResource["::updateById::BankAccount::bankTransactions"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.KlarnaConnection
 * @header lbServices.KlarnaConnection
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `KlarnaConnection` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "KlarnaConnection",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/klarna-connections/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use KlarnaConnection.bank() instead.
            "prototype$__get__bank": {
              url: urlBase + "/klarna-connections/:id/bank",
              method: "GET",
            },

            // INTERNAL. Use KlarnaConnection.bankAccounts.findById() instead.
            "prototype$__findById__bankAccounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/klarna-connections/:id/bank-accounts/:fk",
              method: "GET",
            },

            // INTERNAL. Use KlarnaConnection.bankAccounts.destroyById() instead.
            "prototype$__destroyById__bankAccounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/klarna-connections/:id/bank-accounts/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use KlarnaConnection.bankAccounts.updateById() instead.
            "prototype$__updateById__bankAccounts": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/klarna-connections/:id/bank-accounts/:fk",
              method: "PUT",
            },

            // INTERNAL. Use KlarnaConnection.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/klarna-connections/:id/company",
              method: "GET",
            },

            // INTERNAL. Use KlarnaConnection.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/klarna-connections/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#prototype$__findById__requests
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Find a related item by id for requests.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for requests
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "prototype$__findById__requests": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/klarna-connections/:id/requests/:fk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#prototype$__destroyById__requests
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Delete a related item by id for requests.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for requests
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__destroyById__requests": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/klarna-connections/:id/requests/:fk",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#prototype$__updateById__requests
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Update a related item by id for requests.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `fk` – `{*}` - Foreign key for requests
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "prototype$__updateById__requests": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/klarna-connections/:id/requests/:fk",
              method: "PUT",
            },

            // INTERNAL. Use KlarnaConnection.bankAccounts() instead.
            "prototype$__get__bankAccounts": {
              isArray: true,
              url: urlBase + "/klarna-connections/:id/bank-accounts",
              method: "GET",
            },

            // INTERNAL. Use KlarnaConnection.bankAccounts.create() instead.
            "prototype$__create__bankAccounts": {
              url: urlBase + "/klarna-connections/:id/bank-accounts",
              method: "POST",
            },

            // INTERNAL. Use KlarnaConnection.bankAccounts.destroyAll() instead.
            "prototype$__delete__bankAccounts": {
              url: urlBase + "/klarna-connections/:id/bank-accounts",
              method: "DELETE",
            },

            // INTERNAL. Use KlarnaConnection.bankAccounts.count() instead.
            "prototype$__count__bankAccounts": {
              url: urlBase + "/klarna-connections/:id/bank-accounts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#prototype$__get__requests
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Queries requests of KlarnaConnection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "prototype$__get__requests": {
              isArray: true,
              url: urlBase + "/klarna-connections/:id/requests",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#prototype$__create__requests
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Creates a new instance in requests of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "prototype$__create__requests": {
              url: urlBase + "/klarna-connections/:id/requests",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#prototype$__delete__requests
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Deletes all requests of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$__delete__requests": {
              url: urlBase + "/klarna-connections/:id/requests",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#prototype$__count__requests
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Counts requests of KlarnaConnection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "prototype$__count__requests": {
              url: urlBase + "/klarna-connections/:id/requests/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#create
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/klarna-connections",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#patchOrCreate
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/klarna-connections",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#replaceOrCreate
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/klarna-connections/replace-or-create",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#upsertWithWhere
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/klarna-connections/upsert-with-where",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#exists
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/klarna-connections/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#findById
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/klarna-connections/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#replaceById
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/klarna-connections/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#find
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/klarna-connections",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#findOne
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/klarna-connections/find-one",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#deleteById
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/klarna-connections/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#count
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/klarna-connections/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#prototype$patchAttributes
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/klarna-connections/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#prototype$refresh
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "prototype$refresh": {
              url: urlBase + "/klarna-connections/:id/refresh",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#initializeSession
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `bankCode` – `{string=}` -
             *
             *  - `language` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "initializeSession": {
              url: urlBase + "/klarna-connections/sessions",
              method: "PUT",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#closeSession
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `sessionId` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "closeSession": {
              url: urlBase + "/klarna-connections/sessions/:sessionId",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#setup
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "setup": {
              url: urlBase + "/klarna-connections/setup",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#createMany
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/klarna-connections",
              method: "POST",
            },

            // INTERNAL. Use BankAccount.klarnaConnection() instead.
            "::get::BankAccount::klarnaConnection": {
              url: urlBase + "/BankAccounts/:id/klarnaConnection",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#upsert
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#updateOrCreate
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#patchOrCreateWithWhere
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#destroyById
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#removeById
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#prototype$updateAttributes
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `KlarnaConnection` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.KlarnaConnection#modelName
        * @propertyOf lbServices.KlarnaConnection
        * @description
        * The name of the model represented by this $resource,
        * i.e. `KlarnaConnection`.
        */
        R.modelName = "KlarnaConnection";


            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#bank
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Fetches belongsTo relation bank.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Bank` object.)
             * </em>
             */
        R.bank = function() {
          var TargetResource = $injector.get("Bank");
          var action = TargetResource["::get::KlarnaConnection::bank"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.KlarnaConnection.bankAccounts
     * @header lbServices.KlarnaConnection.bankAccounts
     * @object
     * @description
     *
     * The object `KlarnaConnection.bankAccounts` groups methods
     * manipulating `BankAccount` instances related to `KlarnaConnection`.
     *
     * Call {@link lbServices.KlarnaConnection#bankAccounts KlarnaConnection.bankAccounts()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#bankAccounts
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Queries bankAccounts of KlarnaConnection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R.bankAccounts = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::get::KlarnaConnection::bankAccounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection.bankAccounts#count
             * @methodOf lbServices.KlarnaConnection.bankAccounts
             *
             * @description
             *
             * Counts bankAccounts of KlarnaConnection.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.bankAccounts.count = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::count::KlarnaConnection::bankAccounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection.bankAccounts#create
             * @methodOf lbServices.KlarnaConnection.bankAccounts
             *
             * @description
             *
             * Creates a new instance in bankAccounts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R.bankAccounts.create = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::create::KlarnaConnection::bankAccounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection.bankAccounts#createMany
             * @methodOf lbServices.KlarnaConnection.bankAccounts
             *
             * @description
             *
             * Creates a new instance in bankAccounts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R.bankAccounts.createMany = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::createMany::KlarnaConnection::bankAccounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection.bankAccounts#destroyAll
             * @methodOf lbServices.KlarnaConnection.bankAccounts
             *
             * @description
             *
             * Deletes all bankAccounts of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bankAccounts.destroyAll = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::delete::KlarnaConnection::bankAccounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection.bankAccounts#destroyById
             * @methodOf lbServices.KlarnaConnection.bankAccounts
             *
             * @description
             *
             * Delete a related item by id for bankAccounts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bankAccounts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.bankAccounts.destroyById = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::destroyById::KlarnaConnection::bankAccounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection.bankAccounts#findById
             * @methodOf lbServices.KlarnaConnection.bankAccounts
             *
             * @description
             *
             * Find a related item by id for bankAccounts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for bankAccounts
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R.bankAccounts.findById = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::findById::KlarnaConnection::bankAccounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection.bankAccounts#updateById
             * @methodOf lbServices.KlarnaConnection.bankAccounts
             *
             * @description
             *
             * Update a related item by id for bankAccounts.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `fk` – `{*}` - Foreign key for bankAccounts
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R.bankAccounts.updateById = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::updateById::KlarnaConnection::bankAccounts"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#company
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::KlarnaConnection::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.KlarnaConnection#user
             * @methodOf lbServices.KlarnaConnection
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - KlarnaConnection id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::KlarnaConnection::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.TransactionBase
 * @header lbServices.TransactionBase
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `TransactionBase` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "TransactionBase",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/TransactionBases/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use TransactionBase.journal() instead.
            "prototype$__get__journal": {
              url: urlBase + "/TransactionBases/:id/journal",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.journal.create() instead.
            "prototype$__create__journal": {
              url: urlBase + "/TransactionBases/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use TransactionBase.journal.update() instead.
            "prototype$__update__journal": {
              url: urlBase + "/TransactionBases/:id/journal",
              method: "PUT",
            },

            // INTERNAL. Use TransactionBase.journal.destroy() instead.
            "prototype$__destroy__journal": {
              url: urlBase + "/TransactionBases/:id/journal",
              method: "DELETE",
            },

            // INTERNAL. Use TransactionBase.journals.findById() instead.
            "prototype$__findById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/TransactionBases/:id/journals/:fk",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.journals.destroyById() instead.
            "prototype$__destroyById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/TransactionBases/:id/journals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use TransactionBase.journals.updateById() instead.
            "prototype$__updateById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/TransactionBases/:id/journals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use TransactionBase.Attachment() instead.
            "prototype$__get__Attachment": {
              url: urlBase + "/TransactionBases/:id/Attachment",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.Attachment.create() instead.
            "prototype$__create__Attachment": {
              url: urlBase + "/TransactionBases/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use TransactionBase.Attachment.update() instead.
            "prototype$__update__Attachment": {
              url: urlBase + "/TransactionBases/:id/Attachment",
              method: "PUT",
            },

            // INTERNAL. Use TransactionBase.Attachment.destroy() instead.
            "prototype$__destroy__Attachment": {
              url: urlBase + "/TransactionBases/:id/Attachment",
              method: "DELETE",
            },

            // INTERNAL. Use TransactionBase.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/TransactionBases/:id/company",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/TransactionBases/:id/user",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.events.findById() instead.
            "prototype$__findById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/TransactionBases/:id/events/:fk",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.events.destroyById() instead.
            "prototype$__destroyById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/TransactionBases/:id/events/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use TransactionBase.events.updateById() instead.
            "prototype$__updateById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/TransactionBases/:id/events/:fk",
              method: "PUT",
            },

            // INTERNAL. Use TransactionBase.journals() instead.
            "prototype$__get__journals": {
              isArray: true,
              url: urlBase + "/TransactionBases/:id/journals",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.journals.create() instead.
            "prototype$__create__journals": {
              url: urlBase + "/TransactionBases/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use TransactionBase.journals.destroyAll() instead.
            "prototype$__delete__journals": {
              url: urlBase + "/TransactionBases/:id/journals",
              method: "DELETE",
            },

            // INTERNAL. Use TransactionBase.journals.count() instead.
            "prototype$__count__journals": {
              url: urlBase + "/TransactionBases/:id/journals/count",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.events() instead.
            "prototype$__get__events": {
              isArray: true,
              url: urlBase + "/TransactionBases/:id/events",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.events.create() instead.
            "prototype$__create__events": {
              url: urlBase + "/TransactionBases/:id/events",
              method: "POST",
            },

            // INTERNAL. Use TransactionBase.events.destroyAll() instead.
            "prototype$__delete__events": {
              url: urlBase + "/TransactionBases/:id/events",
              method: "DELETE",
            },

            // INTERNAL. Use TransactionBase.events.count() instead.
            "prototype$__count__events": {
              url: urlBase + "/TransactionBases/:id/events/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#create
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/TransactionBases",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#patchOrCreate
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/TransactionBases",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#replaceOrCreate
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/TransactionBases/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#upsertWithWhere
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/TransactionBases/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#exists
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/TransactionBases/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#findById
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/TransactionBases/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#replaceById
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/TransactionBases/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#find
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/TransactionBases",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#findOne
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/TransactionBases/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#deleteById
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/TransactionBases/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#count
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/TransactionBases/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#prototype$patchAttributes
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/TransactionBases/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#createMany
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/TransactionBases",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#upsert
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#updateOrCreate
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#patchOrCreateWithWhere
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#destroyById
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#removeById
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#prototype$updateAttributes
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `TransactionBase` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.TransactionBase#modelName
        * @propertyOf lbServices.TransactionBase
        * @description
        * The name of the model represented by this $resource,
        * i.e. `TransactionBase`.
        */
        R.modelName = "TransactionBase";

    /**
     * @ngdoc object
     * @name lbServices.TransactionBase.journal
     * @header lbServices.TransactionBase.journal
     * @object
     * @description
     *
     * The object `TransactionBase.journal` groups methods
     * manipulating `Journal` instances related to `TransactionBase`.
     *
     * Call {@link lbServices.TransactionBase#journal TransactionBase.journal()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#journal
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Fetches hasOne relation journal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::get::TransactionBase::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.journal#create
             * @methodOf lbServices.TransactionBase.journal
             *
             * @description
             *
             * Creates a new instance in journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.create = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::create::TransactionBase::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.journal#createMany
             * @methodOf lbServices.TransactionBase.journal
             *
             * @description
             *
             * Creates a new instance in journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.createMany = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::createMany::TransactionBase::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.journal#destroy
             * @methodOf lbServices.TransactionBase.journal
             *
             * @description
             *
             * Deletes journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journal.destroy = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::destroy::TransactionBase::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.journal#update
             * @methodOf lbServices.TransactionBase.journal
             *
             * @description
             *
             * Update journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.update = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::update::TransactionBase::journal"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.TransactionBase.journals
     * @header lbServices.TransactionBase.journals
     * @object
     * @description
     *
     * The object `TransactionBase.journals` groups methods
     * manipulating `Journal` instances related to `TransactionBase`.
     *
     * Call {@link lbServices.TransactionBase#journals TransactionBase.journals()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#journals
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Queries journals of TransactionBase.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::get::TransactionBase::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.journals#count
             * @methodOf lbServices.TransactionBase.journals
             *
             * @description
             *
             * Counts journals of TransactionBase.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.journals.count = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::count::TransactionBase::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.journals#create
             * @methodOf lbServices.TransactionBase.journals
             *
             * @description
             *
             * Creates a new instance in journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.create = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::create::TransactionBase::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.journals#createMany
             * @methodOf lbServices.TransactionBase.journals
             *
             * @description
             *
             * Creates a new instance in journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.createMany = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::createMany::TransactionBase::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.journals#destroyAll
             * @methodOf lbServices.TransactionBase.journals
             *
             * @description
             *
             * Deletes all journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journals.destroyAll = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::delete::TransactionBase::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.journals#destroyById
             * @methodOf lbServices.TransactionBase.journals
             *
             * @description
             *
             * Delete a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journals.destroyById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::destroyById::TransactionBase::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.journals#findById
             * @methodOf lbServices.TransactionBase.journals
             *
             * @description
             *
             * Find a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.findById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::findById::TransactionBase::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.journals#updateById
             * @methodOf lbServices.TransactionBase.journals
             *
             * @description
             *
             * Update a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.updateById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::updateById::TransactionBase::journals"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.TransactionBase.Attachment
     * @header lbServices.TransactionBase.Attachment
     * @object
     * @description
     *
     * The object `TransactionBase.Attachment` groups methods
     * manipulating `Attachment` instances related to `TransactionBase`.
     *
     * Call {@link lbServices.TransactionBase#Attachment TransactionBase.Attachment()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#Attachment
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Fetches hasOne relation Attachment.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::get::TransactionBase::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.Attachment#create
             * @methodOf lbServices.TransactionBase.Attachment
             *
             * @description
             *
             * Creates a new instance in Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.create = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::create::TransactionBase::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.Attachment#createMany
             * @methodOf lbServices.TransactionBase.Attachment
             *
             * @description
             *
             * Creates a new instance in Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.createMany = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::createMany::TransactionBase::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.Attachment#destroy
             * @methodOf lbServices.TransactionBase.Attachment
             *
             * @description
             *
             * Deletes Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.Attachment.destroy = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::destroy::TransactionBase::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.Attachment#update
             * @methodOf lbServices.TransactionBase.Attachment
             *
             * @description
             *
             * Update Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.update = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::update::TransactionBase::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#company
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::TransactionBase::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#user
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::TransactionBase::user"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.TransactionBase.events
     * @header lbServices.TransactionBase.events
     * @object
     * @description
     *
     * The object `TransactionBase.events` groups methods
     * manipulating `Event` instances related to `TransactionBase`.
     *
     * Call {@link lbServices.TransactionBase#events TransactionBase.events()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.TransactionBase#events
             * @methodOf lbServices.TransactionBase
             *
             * @description
             *
             * Queries events of TransactionBase.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::get::TransactionBase::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.events#count
             * @methodOf lbServices.TransactionBase.events
             *
             * @description
             *
             * Counts events of TransactionBase.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.events.count = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::count::TransactionBase::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.events#create
             * @methodOf lbServices.TransactionBase.events
             *
             * @description
             *
             * Creates a new instance in events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.create = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::create::TransactionBase::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.events#createMany
             * @methodOf lbServices.TransactionBase.events
             *
             * @description
             *
             * Creates a new instance in events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.createMany = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::createMany::TransactionBase::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.events#destroyAll
             * @methodOf lbServices.TransactionBase.events
             *
             * @description
             *
             * Deletes all events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.events.destroyAll = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::delete::TransactionBase::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.events#destroyById
             * @methodOf lbServices.TransactionBase.events
             *
             * @description
             *
             * Delete a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.events.destroyById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::destroyById::TransactionBase::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.events#findById
             * @methodOf lbServices.TransactionBase.events
             *
             * @description
             *
             * Find a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.findById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::findById::TransactionBase::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.TransactionBase.events#updateById
             * @methodOf lbServices.TransactionBase.events
             *
             * @description
             *
             * Update a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - TransactionBase id
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.updateById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::updateById::TransactionBase::events"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.BankTransaction
 * @header lbServices.BankTransaction
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `BankTransaction` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "BankTransaction",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/BankTransactions/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use BankTransaction.journal() instead.
            "prototype$__get__journal": {
              url: urlBase + "/BankTransactions/:id/journal",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.journal.create() instead.
            "prototype$__create__journal": {
              url: urlBase + "/BankTransactions/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.journal.update() instead.
            "prototype$__update__journal": {
              url: urlBase + "/BankTransactions/:id/journal",
              method: "PUT",
            },

            // INTERNAL. Use BankTransaction.journal.destroy() instead.
            "prototype$__destroy__journal": {
              url: urlBase + "/BankTransactions/:id/journal",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.journals.findById() instead.
            "prototype$__findById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/journals/:fk",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.journals.destroyById() instead.
            "prototype$__destroyById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/journals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.journals.updateById() instead.
            "prototype$__updateById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/journals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use BankTransaction.Attachment() instead.
            "prototype$__get__Attachment": {
              url: urlBase + "/BankTransactions/:id/Attachment",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.Attachment.create() instead.
            "prototype$__create__Attachment": {
              url: urlBase + "/BankTransactions/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.Attachment.update() instead.
            "prototype$__update__Attachment": {
              url: urlBase + "/BankTransactions/:id/Attachment",
              method: "PUT",
            },

            // INTERNAL. Use BankTransaction.Attachment.destroy() instead.
            "prototype$__destroy__Attachment": {
              url: urlBase + "/BankTransactions/:id/Attachment",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.bankAccount() instead.
            "prototype$__get__bankAccount": {
              url: urlBase + "/BankTransactions/:id/bankAccount",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/BankTransactions/:id/company",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/BankTransactions/:id/user",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.payments.findById() instead.
            "prototype$__findById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/payments/:fk",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.payments.destroyById() instead.
            "prototype$__destroyById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/payments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.payments.updateById() instead.
            "prototype$__updateById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/payments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use BankTransaction.bankRule() instead.
            "prototype$__get__bankRule": {
              url: urlBase + "/BankTransactions/:id/bankRule",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.events.findById() instead.
            "prototype$__findById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/events/:fk",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.events.destroyById() instead.
            "prototype$__destroyById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/events/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.events.updateById() instead.
            "prototype$__updateById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/events/:fk",
              method: "PUT",
            },

            // INTERNAL. Use BankTransaction.journals() instead.
            "prototype$__get__journals": {
              isArray: true,
              url: urlBase + "/BankTransactions/:id/journals",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.journals.create() instead.
            "prototype$__create__journals": {
              url: urlBase + "/BankTransactions/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.journals.destroyAll() instead.
            "prototype$__delete__journals": {
              url: urlBase + "/BankTransactions/:id/journals",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.journals.count() instead.
            "prototype$__count__journals": {
              url: urlBase + "/BankTransactions/:id/journals/count",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.payments() instead.
            "prototype$__get__payments": {
              isArray: true,
              url: urlBase + "/BankTransactions/:id/payments",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.payments.create() instead.
            "prototype$__create__payments": {
              url: urlBase + "/BankTransactions/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.payments.destroyAll() instead.
            "prototype$__delete__payments": {
              url: urlBase + "/BankTransactions/:id/payments",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.payments.count() instead.
            "prototype$__count__payments": {
              url: urlBase + "/BankTransactions/:id/payments/count",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.events() instead.
            "prototype$__get__events": {
              isArray: true,
              url: urlBase + "/BankTransactions/:id/events",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.events.create() instead.
            "prototype$__create__events": {
              url: urlBase + "/BankTransactions/:id/events",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.events.destroyAll() instead.
            "prototype$__delete__events": {
              url: urlBase + "/BankTransactions/:id/events",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.events.count() instead.
            "prototype$__count__events": {
              url: urlBase + "/BankTransactions/:id/events/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#create
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/BankTransactions",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#patchOrCreate
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/BankTransactions",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#replaceOrCreate
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/BankTransactions/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#upsertWithWhere
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/BankTransactions/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#exists
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/BankTransactions/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#findById
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/BankTransactions/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#replaceById
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/BankTransactions/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#find
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/BankTransactions",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#findOne
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/BankTransactions/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#deleteById
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/BankTransactions/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#count
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/BankTransactions/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#prototype$patchAttributes
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/BankTransactions/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#removePermanent
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `res` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "removePermanent": {
              url: urlBase + "/BankTransactions/:id/permanent",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#createMany
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/BankTransactions",
              method: "POST",
            },

            // INTERNAL. Use BankAccount.bankTransactions.findById() instead.
            "::findById::BankAccount::bankTransactions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankAccounts/:id/bankTransactions/:fk",
              method: "GET",
            },

            // INTERNAL. Use BankAccount.bankTransactions.destroyById() instead.
            "::destroyById::BankAccount::bankTransactions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankAccounts/:id/bankTransactions/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use BankAccount.bankTransactions.updateById() instead.
            "::updateById::BankAccount::bankTransactions": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankAccounts/:id/bankTransactions/:fk",
              method: "PUT",
            },

            // INTERNAL. Use BankAccount.bankTransactions() instead.
            "::get::BankAccount::bankTransactions": {
              isArray: true,
              url: urlBase + "/BankAccounts/:id/bankTransactions",
              method: "GET",
            },

            // INTERNAL. Use BankAccount.bankTransactions.create() instead.
            "::create::BankAccount::bankTransactions": {
              url: urlBase + "/BankAccounts/:id/bankTransactions",
              method: "POST",
            },

            // INTERNAL. Use BankAccount.bankTransactions.createMany() instead.
            "::createMany::BankAccount::bankTransactions": {
              isArray: true,
              url: urlBase + "/BankAccounts/:id/bankTransactions",
              method: "POST",
            },

            // INTERNAL. Use BankAccount.bankTransactions.destroyAll() instead.
            "::delete::BankAccount::bankTransactions": {
              url: urlBase + "/BankAccounts/:id/bankTransactions",
              method: "DELETE",
            },

            // INTERNAL. Use BankAccount.bankTransactions.count() instead.
            "::count::BankAccount::bankTransactions": {
              url: urlBase + "/BankAccounts/:id/bankTransactions/count",
              method: "GET",
            },

            // INTERNAL. Use Payment.bankTransaction() instead.
            "::get::Payment::bankTransaction": {
              url: urlBase + "/Payments/:id/bankTransaction",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#upsert
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#updateOrCreate
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#patchOrCreateWithWhere
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#destroyById
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#removeById
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#prototype$updateAttributes
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.BankTransaction#modelName
        * @propertyOf lbServices.BankTransaction
        * @description
        * The name of the model represented by this $resource,
        * i.e. `BankTransaction`.
        */
        R.modelName = "BankTransaction";

    /**
     * @ngdoc object
     * @name lbServices.BankTransaction.journal
     * @header lbServices.BankTransaction.journal
     * @object
     * @description
     *
     * The object `BankTransaction.journal` groups methods
     * manipulating `Journal` instances related to `BankTransaction`.
     *
     * Call {@link lbServices.BankTransaction#journal BankTransaction.journal()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#journal
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Fetches hasOne relation journal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::get::BankTransaction::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.journal#create
             * @methodOf lbServices.BankTransaction.journal
             *
             * @description
             *
             * Creates a new instance in journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.create = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::create::BankTransaction::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.journal#createMany
             * @methodOf lbServices.BankTransaction.journal
             *
             * @description
             *
             * Creates a new instance in journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.createMany = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::createMany::BankTransaction::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.journal#destroy
             * @methodOf lbServices.BankTransaction.journal
             *
             * @description
             *
             * Deletes journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journal.destroy = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::destroy::BankTransaction::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.journal#update
             * @methodOf lbServices.BankTransaction.journal
             *
             * @description
             *
             * Update journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.update = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::update::BankTransaction::journal"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.BankTransaction.journals
     * @header lbServices.BankTransaction.journals
     * @object
     * @description
     *
     * The object `BankTransaction.journals` groups methods
     * manipulating `Journal` instances related to `BankTransaction`.
     *
     * Call {@link lbServices.BankTransaction#journals BankTransaction.journals()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#journals
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Queries journals of BankTransaction.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::get::BankTransaction::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.journals#count
             * @methodOf lbServices.BankTransaction.journals
             *
             * @description
             *
             * Counts journals of BankTransaction.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.journals.count = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::count::BankTransaction::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.journals#create
             * @methodOf lbServices.BankTransaction.journals
             *
             * @description
             *
             * Creates a new instance in journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.create = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::create::BankTransaction::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.journals#createMany
             * @methodOf lbServices.BankTransaction.journals
             *
             * @description
             *
             * Creates a new instance in journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.createMany = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::createMany::BankTransaction::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.journals#destroyAll
             * @methodOf lbServices.BankTransaction.journals
             *
             * @description
             *
             * Deletes all journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journals.destroyAll = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::delete::BankTransaction::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.journals#destroyById
             * @methodOf lbServices.BankTransaction.journals
             *
             * @description
             *
             * Delete a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journals.destroyById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::destroyById::BankTransaction::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.journals#findById
             * @methodOf lbServices.BankTransaction.journals
             *
             * @description
             *
             * Find a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.findById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::findById::BankTransaction::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.journals#updateById
             * @methodOf lbServices.BankTransaction.journals
             *
             * @description
             *
             * Update a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.updateById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::updateById::BankTransaction::journals"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.BankTransaction.Attachment
     * @header lbServices.BankTransaction.Attachment
     * @object
     * @description
     *
     * The object `BankTransaction.Attachment` groups methods
     * manipulating `Attachment` instances related to `BankTransaction`.
     *
     * Call {@link lbServices.BankTransaction#Attachment BankTransaction.Attachment()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#Attachment
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Fetches hasOne relation Attachment.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::get::BankTransaction::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.Attachment#create
             * @methodOf lbServices.BankTransaction.Attachment
             *
             * @description
             *
             * Creates a new instance in Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.create = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::create::BankTransaction::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.Attachment#createMany
             * @methodOf lbServices.BankTransaction.Attachment
             *
             * @description
             *
             * Creates a new instance in Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.createMany = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::createMany::BankTransaction::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.Attachment#destroy
             * @methodOf lbServices.BankTransaction.Attachment
             *
             * @description
             *
             * Deletes Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.Attachment.destroy = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::destroy::BankTransaction::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.Attachment#update
             * @methodOf lbServices.BankTransaction.Attachment
             *
             * @description
             *
             * Update Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.update = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::update::BankTransaction::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#bankAccount
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Fetches belongsTo relation bankAccount.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankAccount` object.)
             * </em>
             */
        R.bankAccount = function() {
          var TargetResource = $injector.get("BankAccount");
          var action = TargetResource["::get::BankTransaction::bankAccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#company
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::BankTransaction::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#user
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::BankTransaction::user"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.BankTransaction.payments
     * @header lbServices.BankTransaction.payments
     * @object
     * @description
     *
     * The object `BankTransaction.payments` groups methods
     * manipulating `Payment` instances related to `BankTransaction`.
     *
     * Call {@link lbServices.BankTransaction#payments BankTransaction.payments()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#payments
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Queries payments of BankTransaction.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::get::BankTransaction::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.payments#count
             * @methodOf lbServices.BankTransaction.payments
             *
             * @description
             *
             * Counts payments of BankTransaction.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.payments.count = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::count::BankTransaction::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.payments#create
             * @methodOf lbServices.BankTransaction.payments
             *
             * @description
             *
             * Creates a new instance in payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.create = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::create::BankTransaction::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.payments#createMany
             * @methodOf lbServices.BankTransaction.payments
             *
             * @description
             *
             * Creates a new instance in payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.createMany = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::createMany::BankTransaction::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.payments#destroyAll
             * @methodOf lbServices.BankTransaction.payments
             *
             * @description
             *
             * Deletes all payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.payments.destroyAll = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::delete::BankTransaction::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.payments#destroyById
             * @methodOf lbServices.BankTransaction.payments
             *
             * @description
             *
             * Delete a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.payments.destroyById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::destroyById::BankTransaction::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.payments#findById
             * @methodOf lbServices.BankTransaction.payments
             *
             * @description
             *
             * Find a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.findById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::findById::BankTransaction::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.payments#updateById
             * @methodOf lbServices.BankTransaction.payments
             *
             * @description
             *
             * Update a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.updateById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::updateById::BankTransaction::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#bankRule
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Fetches belongsTo relation bankRule.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
        R.bankRule = function() {
          var TargetResource = $injector.get("BankRule");
          var action = TargetResource["::get::BankTransaction::bankRule"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.BankTransaction.events
     * @header lbServices.BankTransaction.events
     * @object
     * @description
     *
     * The object `BankTransaction.events` groups methods
     * manipulating `Event` instances related to `BankTransaction`.
     *
     * Call {@link lbServices.BankTransaction#events BankTransaction.events()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.BankTransaction#events
             * @methodOf lbServices.BankTransaction
             *
             * @description
             *
             * Queries events of BankTransaction.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::get::BankTransaction::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.events#count
             * @methodOf lbServices.BankTransaction.events
             *
             * @description
             *
             * Counts events of BankTransaction.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.events.count = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::count::BankTransaction::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.events#create
             * @methodOf lbServices.BankTransaction.events
             *
             * @description
             *
             * Creates a new instance in events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.create = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::create::BankTransaction::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.events#createMany
             * @methodOf lbServices.BankTransaction.events
             *
             * @description
             *
             * Creates a new instance in events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.createMany = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::createMany::BankTransaction::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.events#destroyAll
             * @methodOf lbServices.BankTransaction.events
             *
             * @description
             *
             * Deletes all events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.events.destroyAll = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::delete::BankTransaction::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.events#destroyById
             * @methodOf lbServices.BankTransaction.events
             *
             * @description
             *
             * Delete a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.events.destroyById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::destroyById::BankTransaction::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.events#findById
             * @methodOf lbServices.BankTransaction.events
             *
             * @description
             *
             * Find a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.findById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::findById::BankTransaction::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankTransaction.events#updateById
             * @methodOf lbServices.BankTransaction.events
             *
             * @description
             *
             * Update a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankTransaction id
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.updateById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::updateById::BankTransaction::events"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Invoice
 * @header lbServices.Invoice
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Invoice` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Invoice",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Invoices/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Invoice.journal() instead.
            "prototype$__get__journal": {
              url: urlBase + "/Invoices/:id/journal",
              method: "GET",
            },

            // INTERNAL. Use Invoice.journal.create() instead.
            "prototype$__create__journal": {
              url: urlBase + "/Invoices/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use Invoice.journal.update() instead.
            "prototype$__update__journal": {
              url: urlBase + "/Invoices/:id/journal",
              method: "PUT",
            },

            // INTERNAL. Use Invoice.journal.destroy() instead.
            "prototype$__destroy__journal": {
              url: urlBase + "/Invoices/:id/journal",
              method: "DELETE",
            },

            // INTERNAL. Use Invoice.journals.findById() instead.
            "prototype$__findById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Invoices/:id/journals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Invoice.journals.destroyById() instead.
            "prototype$__destroyById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Invoices/:id/journals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Invoice.journals.updateById() instead.
            "prototype$__updateById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Invoices/:id/journals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Invoice.Attachment() instead.
            "prototype$__get__Attachment": {
              url: urlBase + "/Invoices/:id/Attachment",
              method: "GET",
            },

            // INTERNAL. Use Invoice.Attachment.create() instead.
            "prototype$__create__Attachment": {
              url: urlBase + "/Invoices/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use Invoice.Attachment.update() instead.
            "prototype$__update__Attachment": {
              url: urlBase + "/Invoices/:id/Attachment",
              method: "PUT",
            },

            // INTERNAL. Use Invoice.Attachment.destroy() instead.
            "prototype$__destroy__Attachment": {
              url: urlBase + "/Invoices/:id/Attachment",
              method: "DELETE",
            },

            // INTERNAL. Use Invoice.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/Invoices/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Invoice.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Invoices/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Invoice.events.findById() instead.
            "prototype$__findById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Invoices/:id/events/:fk",
              method: "GET",
            },

            // INTERNAL. Use Invoice.events.destroyById() instead.
            "prototype$__destroyById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Invoices/:id/events/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Invoice.events.updateById() instead.
            "prototype$__updateById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Invoices/:id/events/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Invoice.journals() instead.
            "prototype$__get__journals": {
              isArray: true,
              url: urlBase + "/Invoices/:id/journals",
              method: "GET",
            },

            // INTERNAL. Use Invoice.journals.create() instead.
            "prototype$__create__journals": {
              url: urlBase + "/Invoices/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use Invoice.journals.destroyAll() instead.
            "prototype$__delete__journals": {
              url: urlBase + "/Invoices/:id/journals",
              method: "DELETE",
            },

            // INTERNAL. Use Invoice.journals.count() instead.
            "prototype$__count__journals": {
              url: urlBase + "/Invoices/:id/journals/count",
              method: "GET",
            },

            // INTERNAL. Use Invoice.events() instead.
            "prototype$__get__events": {
              isArray: true,
              url: urlBase + "/Invoices/:id/events",
              method: "GET",
            },

            // INTERNAL. Use Invoice.events.create() instead.
            "prototype$__create__events": {
              url: urlBase + "/Invoices/:id/events",
              method: "POST",
            },

            // INTERNAL. Use Invoice.events.destroyAll() instead.
            "prototype$__delete__events": {
              url: urlBase + "/Invoices/:id/events",
              method: "DELETE",
            },

            // INTERNAL. Use Invoice.events.count() instead.
            "prototype$__count__events": {
              url: urlBase + "/Invoices/:id/events/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#create
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Invoices",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#patchOrCreate
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Invoices",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#replaceOrCreate
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Invoices/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#upsertWithWhere
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Invoices/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#exists
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Invoices/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#findById
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Invoices/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#replaceById
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Invoices/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#find
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Invoices",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#findOne
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Invoices/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#deleteById
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Invoices/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#count
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Invoices/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#prototype$patchAttributes
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Invoices/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#removePermanent
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `res` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "removePermanent": {
              url: urlBase + "/Invoices/:id/permanent",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Invoice#createMany
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Invoices",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Invoice#upsert
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#updateOrCreate
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#patchOrCreateWithWhere
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#destroyById
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#removeById
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Invoice#prototype$updateAttributes
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Invoice` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Invoice#modelName
        * @propertyOf lbServices.Invoice
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Invoice`.
        */
        R.modelName = "Invoice";

    /**
     * @ngdoc object
     * @name lbServices.Invoice.journal
     * @header lbServices.Invoice.journal
     * @object
     * @description
     *
     * The object `Invoice.journal` groups methods
     * manipulating `Journal` instances related to `Invoice`.
     *
     * Call {@link lbServices.Invoice#journal Invoice.journal()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Invoice#journal
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Fetches hasOne relation journal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::get::Invoice::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.journal#create
             * @methodOf lbServices.Invoice.journal
             *
             * @description
             *
             * Creates a new instance in journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.create = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::create::Invoice::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.journal#createMany
             * @methodOf lbServices.Invoice.journal
             *
             * @description
             *
             * Creates a new instance in journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.createMany = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::createMany::Invoice::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.journal#destroy
             * @methodOf lbServices.Invoice.journal
             *
             * @description
             *
             * Deletes journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journal.destroy = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::destroy::Invoice::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.journal#update
             * @methodOf lbServices.Invoice.journal
             *
             * @description
             *
             * Update journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.update = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::update::Invoice::journal"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Invoice.journals
     * @header lbServices.Invoice.journals
     * @object
     * @description
     *
     * The object `Invoice.journals` groups methods
     * manipulating `Journal` instances related to `Invoice`.
     *
     * Call {@link lbServices.Invoice#journals Invoice.journals()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Invoice#journals
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Queries journals of Invoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::get::Invoice::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.journals#count
             * @methodOf lbServices.Invoice.journals
             *
             * @description
             *
             * Counts journals of Invoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.journals.count = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::count::Invoice::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.journals#create
             * @methodOf lbServices.Invoice.journals
             *
             * @description
             *
             * Creates a new instance in journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.create = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::create::Invoice::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.journals#createMany
             * @methodOf lbServices.Invoice.journals
             *
             * @description
             *
             * Creates a new instance in journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.createMany = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::createMany::Invoice::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.journals#destroyAll
             * @methodOf lbServices.Invoice.journals
             *
             * @description
             *
             * Deletes all journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journals.destroyAll = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::delete::Invoice::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.journals#destroyById
             * @methodOf lbServices.Invoice.journals
             *
             * @description
             *
             * Delete a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journals.destroyById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::destroyById::Invoice::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.journals#findById
             * @methodOf lbServices.Invoice.journals
             *
             * @description
             *
             * Find a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.findById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::findById::Invoice::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.journals#updateById
             * @methodOf lbServices.Invoice.journals
             *
             * @description
             *
             * Update a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.updateById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::updateById::Invoice::journals"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Invoice.Attachment
     * @header lbServices.Invoice.Attachment
     * @object
     * @description
     *
     * The object `Invoice.Attachment` groups methods
     * manipulating `Attachment` instances related to `Invoice`.
     *
     * Call {@link lbServices.Invoice#Attachment Invoice.Attachment()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Invoice#Attachment
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Fetches hasOne relation Attachment.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::get::Invoice::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.Attachment#create
             * @methodOf lbServices.Invoice.Attachment
             *
             * @description
             *
             * Creates a new instance in Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.create = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::create::Invoice::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.Attachment#createMany
             * @methodOf lbServices.Invoice.Attachment
             *
             * @description
             *
             * Creates a new instance in Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.createMany = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::createMany::Invoice::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.Attachment#destroy
             * @methodOf lbServices.Invoice.Attachment
             *
             * @description
             *
             * Deletes Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.Attachment.destroy = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::destroy::Invoice::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.Attachment#update
             * @methodOf lbServices.Invoice.Attachment
             *
             * @description
             *
             * Update Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.update = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::update::Invoice::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice#company
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::Invoice::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice#user
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Invoice::user"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Invoice.events
     * @header lbServices.Invoice.events
     * @object
     * @description
     *
     * The object `Invoice.events` groups methods
     * manipulating `Event` instances related to `Invoice`.
     *
     * Call {@link lbServices.Invoice#events Invoice.events()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Invoice#events
             * @methodOf lbServices.Invoice
             *
             * @description
             *
             * Queries events of Invoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::get::Invoice::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.events#count
             * @methodOf lbServices.Invoice.events
             *
             * @description
             *
             * Counts events of Invoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.events.count = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::count::Invoice::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.events#create
             * @methodOf lbServices.Invoice.events
             *
             * @description
             *
             * Creates a new instance in events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.create = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::create::Invoice::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.events#createMany
             * @methodOf lbServices.Invoice.events
             *
             * @description
             *
             * Creates a new instance in events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.createMany = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::createMany::Invoice::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.events#destroyAll
             * @methodOf lbServices.Invoice.events
             *
             * @description
             *
             * Deletes all events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.events.destroyAll = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::delete::Invoice::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.events#destroyById
             * @methodOf lbServices.Invoice.events
             *
             * @description
             *
             * Delete a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.events.destroyById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::destroyById::Invoice::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.events#findById
             * @methodOf lbServices.Invoice.events
             *
             * @description
             *
             * Find a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.findById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::findById::Invoice::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Invoice.events#updateById
             * @methodOf lbServices.Invoice.events
             *
             * @description
             *
             * Update a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Invoice id
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.updateById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::updateById::Invoice::events"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Purchase
 * @header lbServices.Purchase
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Purchase` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Purchase",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Purchases/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Purchase.journal() instead.
            "prototype$__get__journal": {
              url: urlBase + "/Purchases/:id/journal",
              method: "GET",
            },

            // INTERNAL. Use Purchase.journal.create() instead.
            "prototype$__create__journal": {
              url: urlBase + "/Purchases/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use Purchase.journal.update() instead.
            "prototype$__update__journal": {
              url: urlBase + "/Purchases/:id/journal",
              method: "PUT",
            },

            // INTERNAL. Use Purchase.journal.destroy() instead.
            "prototype$__destroy__journal": {
              url: urlBase + "/Purchases/:id/journal",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.journals.findById() instead.
            "prototype$__findById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/journals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Purchase.journals.destroyById() instead.
            "prototype$__destroyById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/journals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.journals.updateById() instead.
            "prototype$__updateById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/journals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Purchase.Attachment() instead.
            "prototype$__get__Attachment": {
              url: urlBase + "/Purchases/:id/Attachment",
              method: "GET",
            },

            // INTERNAL. Use Purchase.Attachment.create() instead.
            "prototype$__create__Attachment": {
              url: urlBase + "/Purchases/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use Purchase.Attachment.update() instead.
            "prototype$__update__Attachment": {
              url: urlBase + "/Purchases/:id/Attachment",
              method: "PUT",
            },

            // INTERNAL. Use Purchase.Attachment.destroy() instead.
            "prototype$__destroy__Attachment": {
              url: urlBase + "/Purchases/:id/Attachment",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/Purchases/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Purchase.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Purchases/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Purchase.payments.findById() instead.
            "prototype$__findById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/payments/:fk",
              method: "GET",
            },

            // INTERNAL. Use Purchase.payments.destroyById() instead.
            "prototype$__destroyById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/payments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.payments.updateById() instead.
            "prototype$__updateById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/payments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Purchase.customer() instead.
            "prototype$__get__customer": {
              url: urlBase + "/Purchases/:id/customer",
              method: "GET",
            },

            // INTERNAL. Use Purchase.vendor() instead.
            "prototype$__get__vendor": {
              url: urlBase + "/Purchases/:id/vendor",
              method: "GET",
            },

            // INTERNAL. Use Purchase.oldVendor() instead.
            "prototype$__get__oldVendor": {
              url: urlBase + "/Purchases/:id/oldVendor",
              method: "GET",
            },

            // INTERNAL. Use Purchase.events.findById() instead.
            "prototype$__findById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/events/:fk",
              method: "GET",
            },

            // INTERNAL. Use Purchase.events.destroyById() instead.
            "prototype$__destroyById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/events/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.events.updateById() instead.
            "prototype$__updateById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/events/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Purchase.journals() instead.
            "prototype$__get__journals": {
              isArray: true,
              url: urlBase + "/Purchases/:id/journals",
              method: "GET",
            },

            // INTERNAL. Use Purchase.journals.create() instead.
            "prototype$__create__journals": {
              url: urlBase + "/Purchases/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use Purchase.journals.destroyAll() instead.
            "prototype$__delete__journals": {
              url: urlBase + "/Purchases/:id/journals",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.journals.count() instead.
            "prototype$__count__journals": {
              url: urlBase + "/Purchases/:id/journals/count",
              method: "GET",
            },

            // INTERNAL. Use Purchase.payments() instead.
            "prototype$__get__payments": {
              isArray: true,
              url: urlBase + "/Purchases/:id/payments",
              method: "GET",
            },

            // INTERNAL. Use Purchase.payments.create() instead.
            "prototype$__create__payments": {
              url: urlBase + "/Purchases/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use Purchase.payments.destroyAll() instead.
            "prototype$__delete__payments": {
              url: urlBase + "/Purchases/:id/payments",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.payments.count() instead.
            "prototype$__count__payments": {
              url: urlBase + "/Purchases/:id/payments/count",
              method: "GET",
            },

            // INTERNAL. Use Purchase.events() instead.
            "prototype$__get__events": {
              isArray: true,
              url: urlBase + "/Purchases/:id/events",
              method: "GET",
            },

            // INTERNAL. Use Purchase.events.create() instead.
            "prototype$__create__events": {
              url: urlBase + "/Purchases/:id/events",
              method: "POST",
            },

            // INTERNAL. Use Purchase.events.destroyAll() instead.
            "prototype$__delete__events": {
              url: urlBase + "/Purchases/:id/events",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.events.count() instead.
            "prototype$__count__events": {
              url: urlBase + "/Purchases/:id/events/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#create
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Purchases",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#patchOrCreate
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Purchases",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#replaceOrCreate
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Purchases/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#upsertWithWhere
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Purchases/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#exists
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Purchases/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#findById
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Purchases/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#replaceById
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Purchases/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#find
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Purchases",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#findOne
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Purchases/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#deleteById
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Purchases/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#count
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Purchases/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#prototype$patchAttributes
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Purchases/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#removePermanent
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `res` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "removePermanent": {
              url: urlBase + "/Purchases/:id/permanent",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#search
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `query` – `{string=}` -
             *
             *  - `invoiceDate` – `{object=}` -
             *
             *  - `status` – `{*=}` -
             *
             *  - `order` – `{string=}` -
             *
             *  - `limit` – `{number=}` -
             *
             *  - `page` – `{number=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "search": {
              url: urlBase + "/Purchases/search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Purchase#createMany
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Purchases",
              method: "POST",
            },

            // INTERNAL. Use Company.purchases.findById() instead.
            "::findById::Company::purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/purchases/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.purchases.destroyById() instead.
            "::destroyById::Company::purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/purchases/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.purchases.updateById() instead.
            "::updateById::Company::purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/purchases/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.purchases() instead.
            "::get::Company::purchases": {
              isArray: true,
              url: urlBase + "/Companies/:id/purchases",
              method: "GET",
            },

            // INTERNAL. Use Company.purchases.create() instead.
            "::create::Company::purchases": {
              url: urlBase + "/Companies/:id/purchases",
              method: "POST",
            },

            // INTERNAL. Use Company.purchases.createMany() instead.
            "::createMany::Company::purchases": {
              isArray: true,
              url: urlBase + "/Companies/:id/purchases",
              method: "POST",
            },

            // INTERNAL. Use Company.purchases.destroyAll() instead.
            "::delete::Company::purchases": {
              url: urlBase + "/Companies/:id/purchases",
              method: "DELETE",
            },

            // INTERNAL. Use Company.purchases.count() instead.
            "::count::Company::purchases": {
              url: urlBase + "/Companies/:id/purchases/count",
              method: "GET",
            },

            // INTERNAL. Use Vendor.purchases.findById() instead.
            "::findById::Vendor::purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vendors/:id/purchases/:fk",
              method: "GET",
            },

            // INTERNAL. Use Vendor.purchases.destroyById() instead.
            "::destroyById::Vendor::purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vendors/:id/purchases/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Vendor.purchases.updateById() instead.
            "::updateById::Vendor::purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vendors/:id/purchases/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Vendor.purchases() instead.
            "::get::Vendor::purchases": {
              isArray: true,
              url: urlBase + "/Vendors/:id/purchases",
              method: "GET",
            },

            // INTERNAL. Use Vendor.purchases.create() instead.
            "::create::Vendor::purchases": {
              url: urlBase + "/Vendors/:id/purchases",
              method: "POST",
            },

            // INTERNAL. Use Vendor.purchases.createMany() instead.
            "::createMany::Vendor::purchases": {
              isArray: true,
              url: urlBase + "/Vendors/:id/purchases",
              method: "POST",
            },

            // INTERNAL. Use Vendor.purchases.destroyAll() instead.
            "::delete::Vendor::purchases": {
              url: urlBase + "/Vendors/:id/purchases",
              method: "DELETE",
            },

            // INTERNAL. Use Vendor.purchases.count() instead.
            "::count::Vendor::purchases": {
              url: urlBase + "/Vendors/:id/purchases/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Purchase#upsert
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Purchase#updateOrCreate
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Purchase#patchOrCreateWithWhere
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Purchase#destroyById
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Purchase#removeById
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Purchase#prototype$updateAttributes
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Purchase#modelName
        * @propertyOf lbServices.Purchase
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Purchase`.
        */
        R.modelName = "Purchase";

    /**
     * @ngdoc object
     * @name lbServices.Purchase.journal
     * @header lbServices.Purchase.journal
     * @object
     * @description
     *
     * The object `Purchase.journal` groups methods
     * manipulating `Journal` instances related to `Purchase`.
     *
     * Call {@link lbServices.Purchase#journal Purchase.journal()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Purchase#journal
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Fetches hasOne relation journal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::get::Purchase::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.journal#create
             * @methodOf lbServices.Purchase.journal
             *
             * @description
             *
             * Creates a new instance in journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.create = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::create::Purchase::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.journal#createMany
             * @methodOf lbServices.Purchase.journal
             *
             * @description
             *
             * Creates a new instance in journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.createMany = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::createMany::Purchase::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.journal#destroy
             * @methodOf lbServices.Purchase.journal
             *
             * @description
             *
             * Deletes journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journal.destroy = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::destroy::Purchase::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.journal#update
             * @methodOf lbServices.Purchase.journal
             *
             * @description
             *
             * Update journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.update = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::update::Purchase::journal"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Purchase.journals
     * @header lbServices.Purchase.journals
     * @object
     * @description
     *
     * The object `Purchase.journals` groups methods
     * manipulating `Journal` instances related to `Purchase`.
     *
     * Call {@link lbServices.Purchase#journals Purchase.journals()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Purchase#journals
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Queries journals of Purchase.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::get::Purchase::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.journals#count
             * @methodOf lbServices.Purchase.journals
             *
             * @description
             *
             * Counts journals of Purchase.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.journals.count = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::count::Purchase::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.journals#create
             * @methodOf lbServices.Purchase.journals
             *
             * @description
             *
             * Creates a new instance in journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.create = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::create::Purchase::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.journals#createMany
             * @methodOf lbServices.Purchase.journals
             *
             * @description
             *
             * Creates a new instance in journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.createMany = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::createMany::Purchase::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.journals#destroyAll
             * @methodOf lbServices.Purchase.journals
             *
             * @description
             *
             * Deletes all journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journals.destroyAll = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::delete::Purchase::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.journals#destroyById
             * @methodOf lbServices.Purchase.journals
             *
             * @description
             *
             * Delete a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journals.destroyById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::destroyById::Purchase::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.journals#findById
             * @methodOf lbServices.Purchase.journals
             *
             * @description
             *
             * Find a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.findById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::findById::Purchase::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.journals#updateById
             * @methodOf lbServices.Purchase.journals
             *
             * @description
             *
             * Update a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.updateById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::updateById::Purchase::journals"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Purchase.Attachment
     * @header lbServices.Purchase.Attachment
     * @object
     * @description
     *
     * The object `Purchase.Attachment` groups methods
     * manipulating `Attachment` instances related to `Purchase`.
     *
     * Call {@link lbServices.Purchase#Attachment Purchase.Attachment()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Purchase#Attachment
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Fetches hasOne relation Attachment.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::get::Purchase::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.Attachment#create
             * @methodOf lbServices.Purchase.Attachment
             *
             * @description
             *
             * Creates a new instance in Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.create = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::create::Purchase::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.Attachment#createMany
             * @methodOf lbServices.Purchase.Attachment
             *
             * @description
             *
             * Creates a new instance in Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.createMany = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::createMany::Purchase::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.Attachment#destroy
             * @methodOf lbServices.Purchase.Attachment
             *
             * @description
             *
             * Deletes Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.Attachment.destroy = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::destroy::Purchase::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.Attachment#update
             * @methodOf lbServices.Purchase.Attachment
             *
             * @description
             *
             * Update Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.update = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::update::Purchase::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase#company
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::Purchase::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase#user
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Purchase::user"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Purchase.payments
     * @header lbServices.Purchase.payments
     * @object
     * @description
     *
     * The object `Purchase.payments` groups methods
     * manipulating `Payment` instances related to `Purchase`.
     *
     * Call {@link lbServices.Purchase#payments Purchase.payments()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Purchase#payments
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Queries payments of Purchase.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::get::Purchase::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.payments#count
             * @methodOf lbServices.Purchase.payments
             *
             * @description
             *
             * Counts payments of Purchase.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.payments.count = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::count::Purchase::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.payments#create
             * @methodOf lbServices.Purchase.payments
             *
             * @description
             *
             * Creates a new instance in payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.create = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::create::Purchase::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.payments#createMany
             * @methodOf lbServices.Purchase.payments
             *
             * @description
             *
             * Creates a new instance in payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.createMany = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::createMany::Purchase::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.payments#destroyAll
             * @methodOf lbServices.Purchase.payments
             *
             * @description
             *
             * Deletes all payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.payments.destroyAll = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::delete::Purchase::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.payments#destroyById
             * @methodOf lbServices.Purchase.payments
             *
             * @description
             *
             * Delete a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.payments.destroyById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::destroyById::Purchase::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.payments#findById
             * @methodOf lbServices.Purchase.payments
             *
             * @description
             *
             * Find a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.findById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::findById::Purchase::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.payments#updateById
             * @methodOf lbServices.Purchase.payments
             *
             * @description
             *
             * Update a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.updateById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::updateById::Purchase::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase#customer
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Fetches belongsTo relation customer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R.customer = function() {
          var TargetResource = $injector.get("Customer");
          var action = TargetResource["::get::Purchase::customer"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase#vendor
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Fetches belongsTo relation vendor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
        R.vendor = function() {
          var TargetResource = $injector.get("Vendor");
          var action = TargetResource["::get::Purchase::vendor"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase#oldVendor
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Fetches belongsTo relation oldVendor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
        R.oldVendor = function() {
          var TargetResource = $injector.get("Vendor");
          var action = TargetResource["::get::Purchase::oldVendor"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Purchase.events
     * @header lbServices.Purchase.events
     * @object
     * @description
     *
     * The object `Purchase.events` groups methods
     * manipulating `Event` instances related to `Purchase`.
     *
     * Call {@link lbServices.Purchase#events Purchase.events()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Purchase#events
             * @methodOf lbServices.Purchase
             *
             * @description
             *
             * Queries events of Purchase.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::get::Purchase::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.events#count
             * @methodOf lbServices.Purchase.events
             *
             * @description
             *
             * Counts events of Purchase.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.events.count = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::count::Purchase::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.events#create
             * @methodOf lbServices.Purchase.events
             *
             * @description
             *
             * Creates a new instance in events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.create = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::create::Purchase::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.events#createMany
             * @methodOf lbServices.Purchase.events
             *
             * @description
             *
             * Creates a new instance in events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.createMany = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::createMany::Purchase::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.events#destroyAll
             * @methodOf lbServices.Purchase.events
             *
             * @description
             *
             * Deletes all events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.events.destroyAll = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::delete::Purchase::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.events#destroyById
             * @methodOf lbServices.Purchase.events
             *
             * @description
             *
             * Delete a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.events.destroyById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::destroyById::Purchase::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.events#findById
             * @methodOf lbServices.Purchase.events
             *
             * @description
             *
             * Find a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.findById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::findById::Purchase::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Purchase.events#updateById
             * @methodOf lbServices.Purchase.events
             *
             * @description
             *
             * Update a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Purchase id
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.updateById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::updateById::Purchase::events"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Sale
 * @header lbServices.Sale
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Sale` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Sale",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Sales/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Sale.journal() instead.
            "prototype$__get__journal": {
              url: urlBase + "/Sales/:id/journal",
              method: "GET",
            },

            // INTERNAL. Use Sale.journal.create() instead.
            "prototype$__create__journal": {
              url: urlBase + "/Sales/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use Sale.journal.update() instead.
            "prototype$__update__journal": {
              url: urlBase + "/Sales/:id/journal",
              method: "PUT",
            },

            // INTERNAL. Use Sale.journal.destroy() instead.
            "prototype$__destroy__journal": {
              url: urlBase + "/Sales/:id/journal",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.journals.findById() instead.
            "prototype$__findById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/journals/:fk",
              method: "GET",
            },

            // INTERNAL. Use Sale.journals.destroyById() instead.
            "prototype$__destroyById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/journals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.journals.updateById() instead.
            "prototype$__updateById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/journals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Sale.Attachment() instead.
            "prototype$__get__Attachment": {
              url: urlBase + "/Sales/:id/Attachment",
              method: "GET",
            },

            // INTERNAL. Use Sale.Attachment.create() instead.
            "prototype$__create__Attachment": {
              url: urlBase + "/Sales/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use Sale.Attachment.update() instead.
            "prototype$__update__Attachment": {
              url: urlBase + "/Sales/:id/Attachment",
              method: "PUT",
            },

            // INTERNAL. Use Sale.Attachment.destroy() instead.
            "prototype$__destroy__Attachment": {
              url: urlBase + "/Sales/:id/Attachment",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.originalSale() instead.
            "prototype$__get__originalSale": {
              url: urlBase + "/Sales/:id/originalSale",
              method: "GET",
            },

            // INTERNAL. Use Sale.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/Sales/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Sale.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Sales/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Sale.recurringSale() instead.
            "prototype$__get__recurringSale": {
              url: urlBase + "/Sales/:id/recurringSale",
              method: "GET",
            },

            // INTERNAL. Use Sale.saleLines.findById() instead.
            "prototype$__findById__saleLines": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/saleLines/:fk",
              method: "GET",
            },

            // INTERNAL. Use Sale.saleLines.destroyById() instead.
            "prototype$__destroyById__saleLines": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/saleLines/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.saleLines.updateById() instead.
            "prototype$__updateById__saleLines": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/saleLines/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Sale.payments.findById() instead.
            "prototype$__findById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/payments/:fk",
              method: "GET",
            },

            // INTERNAL. Use Sale.payments.destroyById() instead.
            "prototype$__destroyById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/payments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.payments.updateById() instead.
            "prototype$__updateById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/payments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Sale.customer() instead.
            "prototype$__get__customer": {
              url: urlBase + "/Sales/:id/customer",
              method: "GET",
            },

            // INTERNAL. Use Sale.oldCustomer() instead.
            "prototype$__get__oldCustomer": {
              url: urlBase + "/Sales/:id/oldCustomer",
              method: "GET",
            },

            // INTERNAL. Use Sale.vendor() instead.
            "prototype$__get__vendor": {
              url: urlBase + "/Sales/:id/vendor",
              method: "GET",
            },

            // INTERNAL. Use Sale.events.findById() instead.
            "prototype$__findById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/events/:fk",
              method: "GET",
            },

            // INTERNAL. Use Sale.events.destroyById() instead.
            "prototype$__destroyById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/events/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.events.updateById() instead.
            "prototype$__updateById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/events/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Sale.journals() instead.
            "prototype$__get__journals": {
              isArray: true,
              url: urlBase + "/Sales/:id/journals",
              method: "GET",
            },

            // INTERNAL. Use Sale.journals.create() instead.
            "prototype$__create__journals": {
              url: urlBase + "/Sales/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use Sale.journals.destroyAll() instead.
            "prototype$__delete__journals": {
              url: urlBase + "/Sales/:id/journals",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.journals.count() instead.
            "prototype$__count__journals": {
              url: urlBase + "/Sales/:id/journals/count",
              method: "GET",
            },

            // INTERNAL. Use Sale.saleLines() instead.
            "prototype$__get__saleLines": {
              isArray: true,
              url: urlBase + "/Sales/:id/saleLines",
              method: "GET",
            },

            // INTERNAL. Use Sale.saleLines.create() instead.
            "prototype$__create__saleLines": {
              url: urlBase + "/Sales/:id/saleLines",
              method: "POST",
            },

            // INTERNAL. Use Sale.saleLines.destroyAll() instead.
            "prototype$__delete__saleLines": {
              url: urlBase + "/Sales/:id/saleLines",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.saleLines.count() instead.
            "prototype$__count__saleLines": {
              url: urlBase + "/Sales/:id/saleLines/count",
              method: "GET",
            },

            // INTERNAL. Use Sale.payments() instead.
            "prototype$__get__payments": {
              isArray: true,
              url: urlBase + "/Sales/:id/payments",
              method: "GET",
            },

            // INTERNAL. Use Sale.payments.create() instead.
            "prototype$__create__payments": {
              url: urlBase + "/Sales/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use Sale.payments.destroyAll() instead.
            "prototype$__delete__payments": {
              url: urlBase + "/Sales/:id/payments",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.payments.count() instead.
            "prototype$__count__payments": {
              url: urlBase + "/Sales/:id/payments/count",
              method: "GET",
            },

            // INTERNAL. Use Sale.events() instead.
            "prototype$__get__events": {
              isArray: true,
              url: urlBase + "/Sales/:id/events",
              method: "GET",
            },

            // INTERNAL. Use Sale.events.create() instead.
            "prototype$__create__events": {
              url: urlBase + "/Sales/:id/events",
              method: "POST",
            },

            // INTERNAL. Use Sale.events.destroyAll() instead.
            "prototype$__delete__events": {
              url: urlBase + "/Sales/:id/events",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.events.count() instead.
            "prototype$__count__events": {
              url: urlBase + "/Sales/:id/events/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#create
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Sales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#patchOrCreate
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Sales",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#replaceOrCreate
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Sales/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#upsertWithWhere
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Sales/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#exists
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Sales/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#findById
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Sales/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#replaceById
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Sales/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#find
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Sales",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#findOne
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Sales/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#deleteById
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Sales/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#count
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Sales/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#prototype$patchAttributes
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Sales/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#removePermanent
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `res` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "removePermanent": {
              url: urlBase + "/Sales/:id/permanent",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#generateInvoiceNumber
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "generateInvoiceNumber": {
              url: urlBase + "/Sales/invoice-numbers/next",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#prototype$duplicate
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "prototype$duplicate": {
              url: urlBase + "/Sales/:id/duplicate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#prototype$credit
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "prototype$credit": {
              url: urlBase + "/Sales/:id/credit",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#prototype$export
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "prototype$export": {
              url: urlBase + "/Sales/:id/export",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#prototype$downloadPdf
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "prototype$downloadPdf": {
              url: urlBase + "/Sales/:id/pdf",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#prototype$generateEmailProposal
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "prototype$generateEmailProposal": {
              url: urlBase + "/Sales/:id/email-proposal",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#prototype$email
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "prototype$email": {
              url: urlBase + "/Sales/:id/email",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#prototype$markSent
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "prototype$markSent": {
              url: urlBase + "/Sales/:id/mark-sent",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#generateSepaBatch
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `res` – `{object=}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `ids` – `{*}` -
             *
             *  - `executionDate` – `{date=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "generateSepaBatch": {
              url: urlBase + "/Sales/sepa-batch",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#search
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `query` – `{string=}` -
             *
             *  - `invoiceDate` – `{object=}` -
             *
             *  - `status` – `{*=}` -
             *
             *  - `order` – `{string=}` -
             *
             *  - `limit` – `{number=}` -
             *
             *  - `page` – `{number=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "search": {
              url: urlBase + "/Sales/search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Sale#createMany
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Sales",
              method: "POST",
            },

            // INTERNAL. Use Company.sales.findById() instead.
            "::findById::Company::sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/sales/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.sales.destroyById() instead.
            "::destroyById::Company::sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/sales/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.sales.updateById() instead.
            "::updateById::Company::sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/sales/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.sales() instead.
            "::get::Company::sales": {
              isArray: true,
              url: urlBase + "/Companies/:id/sales",
              method: "GET",
            },

            // INTERNAL. Use Company.sales.create() instead.
            "::create::Company::sales": {
              url: urlBase + "/Companies/:id/sales",
              method: "POST",
            },

            // INTERNAL. Use Company.sales.createMany() instead.
            "::createMany::Company::sales": {
              isArray: true,
              url: urlBase + "/Companies/:id/sales",
              method: "POST",
            },

            // INTERNAL. Use Company.sales.destroyAll() instead.
            "::delete::Company::sales": {
              url: urlBase + "/Companies/:id/sales",
              method: "DELETE",
            },

            // INTERNAL. Use Company.sales.count() instead.
            "::count::Company::sales": {
              url: urlBase + "/Companies/:id/sales/count",
              method: "GET",
            },

            // INTERNAL. Use Sale.originalSale() instead.
            "::get::Sale::originalSale": {
              url: urlBase + "/Sales/:id/originalSale",
              method: "GET",
            },

            // INTERNAL. Use RecurringSale.sales.findById() instead.
            "::findById::RecurringSale::sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/recurring-sales/:id/sales/:fk",
              method: "GET",
            },

            // INTERNAL. Use RecurringSale.sales.destroyById() instead.
            "::destroyById::RecurringSale::sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/recurring-sales/:id/sales/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use RecurringSale.sales.updateById() instead.
            "::updateById::RecurringSale::sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/recurring-sales/:id/sales/:fk",
              method: "PUT",
            },

            // INTERNAL. Use RecurringSale.sales() instead.
            "::get::RecurringSale::sales": {
              isArray: true,
              url: urlBase + "/recurring-sales/:id/sales",
              method: "GET",
            },

            // INTERNAL. Use RecurringSale.sales.create() instead.
            "::create::RecurringSale::sales": {
              url: urlBase + "/recurring-sales/:id/sales",
              method: "POST",
            },

            // INTERNAL. Use RecurringSale.sales.createMany() instead.
            "::createMany::RecurringSale::sales": {
              isArray: true,
              url: urlBase + "/recurring-sales/:id/sales",
              method: "POST",
            },

            // INTERNAL. Use RecurringSale.sales.destroyAll() instead.
            "::delete::RecurringSale::sales": {
              url: urlBase + "/recurring-sales/:id/sales",
              method: "DELETE",
            },

            // INTERNAL. Use RecurringSale.sales.count() instead.
            "::count::RecurringSale::sales": {
              url: urlBase + "/recurring-sales/:id/sales/count",
              method: "GET",
            },

            // INTERNAL. Use Customer.sales.findById() instead.
            "::findById::Customer::sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Customers/:id/sales/:fk",
              method: "GET",
            },

            // INTERNAL. Use Customer.sales.destroyById() instead.
            "::destroyById::Customer::sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Customers/:id/sales/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Customer.sales.updateById() instead.
            "::updateById::Customer::sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Customers/:id/sales/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Customer.sales() instead.
            "::get::Customer::sales": {
              isArray: true,
              url: urlBase + "/Customers/:id/sales",
              method: "GET",
            },

            // INTERNAL. Use Customer.sales.create() instead.
            "::create::Customer::sales": {
              url: urlBase + "/Customers/:id/sales",
              method: "POST",
            },

            // INTERNAL. Use Customer.sales.createMany() instead.
            "::createMany::Customer::sales": {
              isArray: true,
              url: urlBase + "/Customers/:id/sales",
              method: "POST",
            },

            // INTERNAL. Use Customer.sales.destroyAll() instead.
            "::delete::Customer::sales": {
              url: urlBase + "/Customers/:id/sales",
              method: "DELETE",
            },

            // INTERNAL. Use Customer.sales.count() instead.
            "::count::Customer::sales": {
              url: urlBase + "/Customers/:id/sales/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Sale#upsert
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Sale#updateOrCreate
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Sale#patchOrCreateWithWhere
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Sale#destroyById
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Sale#removeById
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Sale#prototype$updateAttributes
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Sale#modelName
        * @propertyOf lbServices.Sale
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Sale`.
        */
        R.modelName = "Sale";

    /**
     * @ngdoc object
     * @name lbServices.Sale.journal
     * @header lbServices.Sale.journal
     * @object
     * @description
     *
     * The object `Sale.journal` groups methods
     * manipulating `Journal` instances related to `Sale`.
     *
     * Call {@link lbServices.Sale#journal Sale.journal()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Sale#journal
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Fetches hasOne relation journal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::get::Sale::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.journal#create
             * @methodOf lbServices.Sale.journal
             *
             * @description
             *
             * Creates a new instance in journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.create = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::create::Sale::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.journal#createMany
             * @methodOf lbServices.Sale.journal
             *
             * @description
             *
             * Creates a new instance in journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.createMany = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::createMany::Sale::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.journal#destroy
             * @methodOf lbServices.Sale.journal
             *
             * @description
             *
             * Deletes journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journal.destroy = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::destroy::Sale::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.journal#update
             * @methodOf lbServices.Sale.journal
             *
             * @description
             *
             * Update journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.update = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::update::Sale::journal"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Sale.journals
     * @header lbServices.Sale.journals
     * @object
     * @description
     *
     * The object `Sale.journals` groups methods
     * manipulating `Journal` instances related to `Sale`.
     *
     * Call {@link lbServices.Sale#journals Sale.journals()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Sale#journals
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Queries journals of Sale.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::get::Sale::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.journals#count
             * @methodOf lbServices.Sale.journals
             *
             * @description
             *
             * Counts journals of Sale.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.journals.count = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::count::Sale::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.journals#create
             * @methodOf lbServices.Sale.journals
             *
             * @description
             *
             * Creates a new instance in journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.create = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::create::Sale::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.journals#createMany
             * @methodOf lbServices.Sale.journals
             *
             * @description
             *
             * Creates a new instance in journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.createMany = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::createMany::Sale::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.journals#destroyAll
             * @methodOf lbServices.Sale.journals
             *
             * @description
             *
             * Deletes all journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journals.destroyAll = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::delete::Sale::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.journals#destroyById
             * @methodOf lbServices.Sale.journals
             *
             * @description
             *
             * Delete a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journals.destroyById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::destroyById::Sale::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.journals#findById
             * @methodOf lbServices.Sale.journals
             *
             * @description
             *
             * Find a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.findById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::findById::Sale::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.journals#updateById
             * @methodOf lbServices.Sale.journals
             *
             * @description
             *
             * Update a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.updateById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::updateById::Sale::journals"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Sale.Attachment
     * @header lbServices.Sale.Attachment
     * @object
     * @description
     *
     * The object `Sale.Attachment` groups methods
     * manipulating `Attachment` instances related to `Sale`.
     *
     * Call {@link lbServices.Sale#Attachment Sale.Attachment()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Sale#Attachment
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Fetches hasOne relation Attachment.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::get::Sale::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.Attachment#create
             * @methodOf lbServices.Sale.Attachment
             *
             * @description
             *
             * Creates a new instance in Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.create = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::create::Sale::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.Attachment#createMany
             * @methodOf lbServices.Sale.Attachment
             *
             * @description
             *
             * Creates a new instance in Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.createMany = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::createMany::Sale::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.Attachment#destroy
             * @methodOf lbServices.Sale.Attachment
             *
             * @description
             *
             * Deletes Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.Attachment.destroy = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::destroy::Sale::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.Attachment#update
             * @methodOf lbServices.Sale.Attachment
             *
             * @description
             *
             * Update Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.update = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::update::Sale::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale#originalSale
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Fetches belongsTo relation originalSale.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.originalSale = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::get::Sale::originalSale"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale#company
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::Sale::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale#user
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Sale::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale#recurringSale
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Fetches belongsTo relation recurringSale.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
        R.recurringSale = function() {
          var TargetResource = $injector.get("RecurringSale");
          var action = TargetResource["::get::Sale::recurringSale"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Sale.saleLines
     * @header lbServices.Sale.saleLines
     * @object
     * @description
     *
     * The object `Sale.saleLines` groups methods
     * manipulating `InvoiceLine` instances related to `Sale`.
     *
     * Call {@link lbServices.Sale#saleLines Sale.saleLines()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Sale#saleLines
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Queries saleLines of Sale.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceLine` object.)
             * </em>
             */
        R.saleLines = function() {
          var TargetResource = $injector.get("InvoiceLine");
          var action = TargetResource["::get::Sale::saleLines"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.saleLines#count
             * @methodOf lbServices.Sale.saleLines
             *
             * @description
             *
             * Counts saleLines of Sale.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.saleLines.count = function() {
          var TargetResource = $injector.get("InvoiceLine");
          var action = TargetResource["::count::Sale::saleLines"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.saleLines#create
             * @methodOf lbServices.Sale.saleLines
             *
             * @description
             *
             * Creates a new instance in saleLines of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceLine` object.)
             * </em>
             */
        R.saleLines.create = function() {
          var TargetResource = $injector.get("InvoiceLine");
          var action = TargetResource["::create::Sale::saleLines"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.saleLines#createMany
             * @methodOf lbServices.Sale.saleLines
             *
             * @description
             *
             * Creates a new instance in saleLines of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceLine` object.)
             * </em>
             */
        R.saleLines.createMany = function() {
          var TargetResource = $injector.get("InvoiceLine");
          var action = TargetResource["::createMany::Sale::saleLines"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.saleLines#destroyAll
             * @methodOf lbServices.Sale.saleLines
             *
             * @description
             *
             * Deletes all saleLines of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.saleLines.destroyAll = function() {
          var TargetResource = $injector.get("InvoiceLine");
          var action = TargetResource["::delete::Sale::saleLines"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.saleLines#destroyById
             * @methodOf lbServices.Sale.saleLines
             *
             * @description
             *
             * Delete a related item by id for saleLines.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for saleLines
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.saleLines.destroyById = function() {
          var TargetResource = $injector.get("InvoiceLine");
          var action = TargetResource["::destroyById::Sale::saleLines"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.saleLines#findById
             * @methodOf lbServices.Sale.saleLines
             *
             * @description
             *
             * Find a related item by id for saleLines.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for saleLines
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceLine` object.)
             * </em>
             */
        R.saleLines.findById = function() {
          var TargetResource = $injector.get("InvoiceLine");
          var action = TargetResource["::findById::Sale::saleLines"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.saleLines#updateById
             * @methodOf lbServices.Sale.saleLines
             *
             * @description
             *
             * Update a related item by id for saleLines.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `fk` – `{*}` - Foreign key for saleLines
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `InvoiceLine` object.)
             * </em>
             */
        R.saleLines.updateById = function() {
          var TargetResource = $injector.get("InvoiceLine");
          var action = TargetResource["::updateById::Sale::saleLines"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Sale.payments
     * @header lbServices.Sale.payments
     * @object
     * @description
     *
     * The object `Sale.payments` groups methods
     * manipulating `Payment` instances related to `Sale`.
     *
     * Call {@link lbServices.Sale#payments Sale.payments()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Sale#payments
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Queries payments of Sale.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::get::Sale::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.payments#count
             * @methodOf lbServices.Sale.payments
             *
             * @description
             *
             * Counts payments of Sale.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.payments.count = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::count::Sale::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.payments#create
             * @methodOf lbServices.Sale.payments
             *
             * @description
             *
             * Creates a new instance in payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.create = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::create::Sale::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.payments#createMany
             * @methodOf lbServices.Sale.payments
             *
             * @description
             *
             * Creates a new instance in payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.createMany = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::createMany::Sale::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.payments#destroyAll
             * @methodOf lbServices.Sale.payments
             *
             * @description
             *
             * Deletes all payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.payments.destroyAll = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::delete::Sale::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.payments#destroyById
             * @methodOf lbServices.Sale.payments
             *
             * @description
             *
             * Delete a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.payments.destroyById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::destroyById::Sale::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.payments#findById
             * @methodOf lbServices.Sale.payments
             *
             * @description
             *
             * Find a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.findById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::findById::Sale::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.payments#updateById
             * @methodOf lbServices.Sale.payments
             *
             * @description
             *
             * Update a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.updateById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::updateById::Sale::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale#customer
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Fetches belongsTo relation customer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R.customer = function() {
          var TargetResource = $injector.get("Customer");
          var action = TargetResource["::get::Sale::customer"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale#oldCustomer
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Fetches belongsTo relation oldCustomer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R.oldCustomer = function() {
          var TargetResource = $injector.get("Customer");
          var action = TargetResource["::get::Sale::oldCustomer"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale#vendor
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Fetches belongsTo relation vendor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
        R.vendor = function() {
          var TargetResource = $injector.get("Vendor");
          var action = TargetResource["::get::Sale::vendor"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.Sale.events
     * @header lbServices.Sale.events
     * @object
     * @description
     *
     * The object `Sale.events` groups methods
     * manipulating `Event` instances related to `Sale`.
     *
     * Call {@link lbServices.Sale#events Sale.events()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Sale#events
             * @methodOf lbServices.Sale
             *
             * @description
             *
             * Queries events of Sale.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::get::Sale::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.events#count
             * @methodOf lbServices.Sale.events
             *
             * @description
             *
             * Counts events of Sale.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.events.count = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::count::Sale::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.events#create
             * @methodOf lbServices.Sale.events
             *
             * @description
             *
             * Creates a new instance in events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.create = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::create::Sale::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.events#createMany
             * @methodOf lbServices.Sale.events
             *
             * @description
             *
             * Creates a new instance in events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.createMany = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::createMany::Sale::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.events#destroyAll
             * @methodOf lbServices.Sale.events
             *
             * @description
             *
             * Deletes all events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.events.destroyAll = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::delete::Sale::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.events#destroyById
             * @methodOf lbServices.Sale.events
             *
             * @description
             *
             * Delete a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.events.destroyById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::destroyById::Sale::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.events#findById
             * @methodOf lbServices.Sale.events
             *
             * @description
             *
             * Find a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.findById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::findById::Sale::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Sale.events#updateById
             * @methodOf lbServices.Sale.events
             *
             * @description
             *
             * Update a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Sale id
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.updateById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::updateById::Sale::events"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.RecurringSale
 * @header lbServices.RecurringSale
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `RecurringSale` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "RecurringSale",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/recurring-sales/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use RecurringSale.sales.findById() instead.
            "prototype$__findById__sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/recurring-sales/:id/sales/:fk",
              method: "GET",
            },

            // INTERNAL. Use RecurringSale.sales.destroyById() instead.
            "prototype$__destroyById__sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/recurring-sales/:id/sales/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use RecurringSale.sales.updateById() instead.
            "prototype$__updateById__sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/recurring-sales/:id/sales/:fk",
              method: "PUT",
            },

            // INTERNAL. Use RecurringSale.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/recurring-sales/:id/company",
              method: "GET",
            },

            // INTERNAL. Use RecurringSale.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/recurring-sales/:id/user",
              method: "GET",
            },

            // INTERNAL. Use RecurringSale.customer() instead.
            "prototype$__get__customer": {
              url: urlBase + "/recurring-sales/:id/customer",
              method: "GET",
            },

            // INTERNAL. Use RecurringSale.sales() instead.
            "prototype$__get__sales": {
              isArray: true,
              url: urlBase + "/recurring-sales/:id/sales",
              method: "GET",
            },

            // INTERNAL. Use RecurringSale.sales.create() instead.
            "prototype$__create__sales": {
              url: urlBase + "/recurring-sales/:id/sales",
              method: "POST",
            },

            // INTERNAL. Use RecurringSale.sales.destroyAll() instead.
            "prototype$__delete__sales": {
              url: urlBase + "/recurring-sales/:id/sales",
              method: "DELETE",
            },

            // INTERNAL. Use RecurringSale.sales.count() instead.
            "prototype$__count__sales": {
              url: urlBase + "/recurring-sales/:id/sales/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#create
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/recurring-sales",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#patchOrCreate
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/recurring-sales",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#replaceOrCreate
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/recurring-sales/replace-or-create",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#upsertWithWhere
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/recurring-sales/upsert-with-where",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#exists
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/recurring-sales/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#findById
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/recurring-sales/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#replaceById
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/recurring-sales/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#find
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/recurring-sales",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#findOne
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/recurring-sales/find-one",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#deleteById
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/recurring-sales/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#count
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/recurring-sales/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#prototype$patchAttributes
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RecurringSale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/recurring-sales/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#search
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `query` – `{string=}` -
             *
             *  - `invoiceDate` – `{object=}` -
             *
             *  - `status` – `{*=}` -
             *
             *  - `order` – `{string=}` -
             *
             *  - `limit` – `{number=}` -
             *
             *  - `page` – `{number=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
            "search": {
              url: urlBase + "/recurring-sales/search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#createMany
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/recurring-sales",
              method: "POST",
            },

            // INTERNAL. Use Sale.recurringSale() instead.
            "::get::Sale::recurringSale": {
              url: urlBase + "/Sales/:id/recurringSale",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#upsert
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#updateOrCreate
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#patchOrCreateWithWhere
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#destroyById
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#removeById
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#prototype$updateAttributes
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RecurringSale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `RecurringSale` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.RecurringSale#modelName
        * @propertyOf lbServices.RecurringSale
        * @description
        * The name of the model represented by this $resource,
        * i.e. `RecurringSale`.
        */
        R.modelName = "RecurringSale";

    /**
     * @ngdoc object
     * @name lbServices.RecurringSale.sales
     * @header lbServices.RecurringSale.sales
     * @object
     * @description
     *
     * The object `RecurringSale.sales` groups methods
     * manipulating `Sale` instances related to `RecurringSale`.
     *
     * Call {@link lbServices.RecurringSale#sales RecurringSale.sales()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#sales
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Queries sales of RecurringSale.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RecurringSale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.sales = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::get::RecurringSale::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale.sales#count
             * @methodOf lbServices.RecurringSale.sales
             *
             * @description
             *
             * Counts sales of RecurringSale.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RecurringSale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.sales.count = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::count::RecurringSale::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale.sales#create
             * @methodOf lbServices.RecurringSale.sales
             *
             * @description
             *
             * Creates a new instance in sales of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RecurringSale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.sales.create = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::create::RecurringSale::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale.sales#createMany
             * @methodOf lbServices.RecurringSale.sales
             *
             * @description
             *
             * Creates a new instance in sales of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RecurringSale id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.sales.createMany = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::createMany::RecurringSale::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale.sales#destroyAll
             * @methodOf lbServices.RecurringSale.sales
             *
             * @description
             *
             * Deletes all sales of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RecurringSale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sales.destroyAll = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::delete::RecurringSale::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale.sales#destroyById
             * @methodOf lbServices.RecurringSale.sales
             *
             * @description
             *
             * Delete a related item by id for sales.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RecurringSale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for sales
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sales.destroyById = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::destroyById::RecurringSale::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale.sales#findById
             * @methodOf lbServices.RecurringSale.sales
             *
             * @description
             *
             * Find a related item by id for sales.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RecurringSale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for sales
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.sales.findById = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::findById::RecurringSale::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale.sales#updateById
             * @methodOf lbServices.RecurringSale.sales
             *
             * @description
             *
             * Update a related item by id for sales.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RecurringSale id
             *
             *  - `fk` – `{*}` - Foreign key for sales
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.sales.updateById = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::updateById::RecurringSale::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#company
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RecurringSale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::RecurringSale::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#user
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RecurringSale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::RecurringSale::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.RecurringSale#customer
             * @methodOf lbServices.RecurringSale
             *
             * @description
             *
             * Fetches belongsTo relation customer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - RecurringSale id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R.customer = function() {
          var TargetResource = $injector.get("Customer");
          var action = TargetResource["::get::RecurringSale::customer"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.InvoiceLine
 * @header lbServices.InvoiceLine
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `InvoiceLine` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "InvoiceLine",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/invoice-lines/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Sale.saleLines.findById() instead.
            "::findById::Sale::saleLines": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/saleLines/:fk",
              method: "GET",
            },

            // INTERNAL. Use Sale.saleLines.destroyById() instead.
            "::destroyById::Sale::saleLines": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/saleLines/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.saleLines.updateById() instead.
            "::updateById::Sale::saleLines": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/saleLines/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Sale.saleLines() instead.
            "::get::Sale::saleLines": {
              isArray: true,
              url: urlBase + "/Sales/:id/saleLines",
              method: "GET",
            },

            // INTERNAL. Use Sale.saleLines.create() instead.
            "::create::Sale::saleLines": {
              url: urlBase + "/Sales/:id/saleLines",
              method: "POST",
            },

            // INTERNAL. Use Sale.saleLines.createMany() instead.
            "::createMany::Sale::saleLines": {
              isArray: true,
              url: urlBase + "/Sales/:id/saleLines",
              method: "POST",
            },

            // INTERNAL. Use Sale.saleLines.destroyAll() instead.
            "::delete::Sale::saleLines": {
              url: urlBase + "/Sales/:id/saleLines",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.saleLines.count() instead.
            "::count::Sale::saleLines": {
              url: urlBase + "/Sales/:id/saleLines/count",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.InvoiceLine#modelName
        * @propertyOf lbServices.InvoiceLine
        * @description
        * The name of the model represented by this $resource,
        * i.e. `InvoiceLine`.
        */
        R.modelName = "InvoiceLine";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.JournalEntryLine
 * @header lbServices.JournalEntryLine
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `JournalEntryLine` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "JournalEntryLine",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/journal-entry-lines/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.JournalEntryLine#modelName
        * @propertyOf lbServices.JournalEntryLine
        * @description
        * The name of the model represented by this $resource,
        * i.e. `JournalEntryLine`.
        */
        R.modelName = "JournalEntryLine";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.SaleItem
 * @header lbServices.SaleItem
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `SaleItem` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "SaleItem",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/sale-items/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use SaleItem.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/sale-items/:id/company",
              method: "GET",
            },

            // INTERNAL. Use SaleItem.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/sale-items/:id/user",
              method: "GET",
            },

            // INTERNAL. Use SaleItem.vatCode() instead.
            "prototype$__get__vatCode": {
              url: urlBase + "/sale-items/:id/vat-code",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#create
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/sale-items",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#patchOrCreate
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/sale-items",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#replaceOrCreate
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/sale-items/replace-or-create",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#upsertWithWhere
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/sale-items/upsert-with-where",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#exists
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/sale-items/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#findById
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/sale-items/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#replaceById
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/sale-items/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#find
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/sale-items",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#findOne
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/sale-items/find-one",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#deleteById
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/sale-items/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#count
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/sale-items/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#prototype$patchAttributes
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SaleItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/sale-items/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#createMany
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/sale-items",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.SaleItem#upsert
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#updateOrCreate
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#patchOrCreateWithWhere
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#destroyById
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#removeById
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#prototype$updateAttributes
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SaleItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SaleItem` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.SaleItem#modelName
        * @propertyOf lbServices.SaleItem
        * @description
        * The name of the model represented by this $resource,
        * i.e. `SaleItem`.
        */
        R.modelName = "SaleItem";


            /**
             * @ngdoc method
             * @name lbServices.SaleItem#company
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SaleItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::SaleItem::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#user
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SaleItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::SaleItem::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.SaleItem#vatCode
             * @methodOf lbServices.SaleItem
             *
             * @description
             *
             * Fetches belongsTo relation vatCode.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - SaleItem id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
        R.vatCode = function() {
          var TargetResource = $injector.get("VatCode");
          var action = TargetResource["::get::SaleItem::vatCode"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.JournalEntry
 * @header lbServices.JournalEntry
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `JournalEntry` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "JournalEntry",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/JournalEntries/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use JournalEntry.journal() instead.
            "prototype$__get__journal": {
              url: urlBase + "/JournalEntries/:id/journal",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.journal.create() instead.
            "prototype$__create__journal": {
              url: urlBase + "/JournalEntries/:id/journal",
              method: "POST",
            },

            // INTERNAL. Use JournalEntry.journal.update() instead.
            "prototype$__update__journal": {
              url: urlBase + "/JournalEntries/:id/journal",
              method: "PUT",
            },

            // INTERNAL. Use JournalEntry.journal.destroy() instead.
            "prototype$__destroy__journal": {
              url: urlBase + "/JournalEntries/:id/journal",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.journals.findById() instead.
            "prototype$__findById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/journals/:fk",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.journals.destroyById() instead.
            "prototype$__destroyById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/journals/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.journals.updateById() instead.
            "prototype$__updateById__journals": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/journals/:fk",
              method: "PUT",
            },

            // INTERNAL. Use JournalEntry.Attachment() instead.
            "prototype$__get__Attachment": {
              url: urlBase + "/JournalEntries/:id/Attachment",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.Attachment.create() instead.
            "prototype$__create__Attachment": {
              url: urlBase + "/JournalEntries/:id/Attachment",
              method: "POST",
            },

            // INTERNAL. Use JournalEntry.Attachment.update() instead.
            "prototype$__update__Attachment": {
              url: urlBase + "/JournalEntries/:id/Attachment",
              method: "PUT",
            },

            // INTERNAL. Use JournalEntry.Attachment.destroy() instead.
            "prototype$__destroy__Attachment": {
              url: urlBase + "/JournalEntries/:id/Attachment",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/JournalEntries/:id/company",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/JournalEntries/:id/user",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.payments.findById() instead.
            "prototype$__findById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/payments/:fk",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.payments.destroyById() instead.
            "prototype$__destroyById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/payments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.payments.updateById() instead.
            "prototype$__updateById__payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/payments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use JournalEntry.events.findById() instead.
            "prototype$__findById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/events/:fk",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.events.destroyById() instead.
            "prototype$__destroyById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/events/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.events.updateById() instead.
            "prototype$__updateById__events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/events/:fk",
              method: "PUT",
            },

            // INTERNAL. Use JournalEntry.journals() instead.
            "prototype$__get__journals": {
              isArray: true,
              url: urlBase + "/JournalEntries/:id/journals",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.journals.create() instead.
            "prototype$__create__journals": {
              url: urlBase + "/JournalEntries/:id/journals",
              method: "POST",
            },

            // INTERNAL. Use JournalEntry.journals.destroyAll() instead.
            "prototype$__delete__journals": {
              url: urlBase + "/JournalEntries/:id/journals",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.journals.count() instead.
            "prototype$__count__journals": {
              url: urlBase + "/JournalEntries/:id/journals/count",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.payments() instead.
            "prototype$__get__payments": {
              isArray: true,
              url: urlBase + "/JournalEntries/:id/payments",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.payments.create() instead.
            "prototype$__create__payments": {
              url: urlBase + "/JournalEntries/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use JournalEntry.payments.destroyAll() instead.
            "prototype$__delete__payments": {
              url: urlBase + "/JournalEntries/:id/payments",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.payments.count() instead.
            "prototype$__count__payments": {
              url: urlBase + "/JournalEntries/:id/payments/count",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.events() instead.
            "prototype$__get__events": {
              isArray: true,
              url: urlBase + "/JournalEntries/:id/events",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.events.create() instead.
            "prototype$__create__events": {
              url: urlBase + "/JournalEntries/:id/events",
              method: "POST",
            },

            // INTERNAL. Use JournalEntry.events.destroyAll() instead.
            "prototype$__delete__events": {
              url: urlBase + "/JournalEntries/:id/events",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.events.count() instead.
            "prototype$__count__events": {
              url: urlBase + "/JournalEntries/:id/events/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#create
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/JournalEntries",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#patchOrCreate
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/JournalEntries",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#replaceOrCreate
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/JournalEntries/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#upsertWithWhere
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/JournalEntries/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#exists
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/JournalEntries/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#findById
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/JournalEntries/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#replaceById
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/JournalEntries/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#find
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/JournalEntries",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#findOne
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/JournalEntries/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#deleteById
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/JournalEntries/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#count
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/JournalEntries/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#prototype$patchAttributes
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/JournalEntries/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#removePermanent
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `res` – `{object=}` -
             *
             *  - `id` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "removePermanent": {
              url: urlBase + "/JournalEntries/:id/permanent",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#yearClosure
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `year` – `{string}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `yearClosure` – `{object=}` -
             */
            "yearClosure": {
              url: urlBase + "/JournalEntries/yearClosure",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#createMany
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/JournalEntries",
              method: "POST",
            },

            // INTERNAL. Use Company.journalEntries.findById() instead.
            "::findById::Company::journalEntries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/journalEntries/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.journalEntries.destroyById() instead.
            "::destroyById::Company::journalEntries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/journalEntries/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.journalEntries.updateById() instead.
            "::updateById::Company::journalEntries": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/journalEntries/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.journalEntries() instead.
            "::get::Company::journalEntries": {
              isArray: true,
              url: urlBase + "/Companies/:id/journalEntries",
              method: "GET",
            },

            // INTERNAL. Use Company.journalEntries.create() instead.
            "::create::Company::journalEntries": {
              url: urlBase + "/Companies/:id/journalEntries",
              method: "POST",
            },

            // INTERNAL. Use Company.journalEntries.createMany() instead.
            "::createMany::Company::journalEntries": {
              isArray: true,
              url: urlBase + "/Companies/:id/journalEntries",
              method: "POST",
            },

            // INTERNAL. Use Company.journalEntries.destroyAll() instead.
            "::delete::Company::journalEntries": {
              url: urlBase + "/Companies/:id/journalEntries",
              method: "DELETE",
            },

            // INTERNAL. Use Company.journalEntries.count() instead.
            "::count::Company::journalEntries": {
              url: urlBase + "/Companies/:id/journalEntries/count",
              method: "GET",
            },

            // INTERNAL. Use Payment.journalEntry() instead.
            "::get::Payment::journalEntry": {
              url: urlBase + "/Payments/:id/journalEntry",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#upsert
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#updateOrCreate
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#patchOrCreateWithWhere
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#destroyById
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#removeById
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#prototype$updateAttributes
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.JournalEntry#modelName
        * @propertyOf lbServices.JournalEntry
        * @description
        * The name of the model represented by this $resource,
        * i.e. `JournalEntry`.
        */
        R.modelName = "JournalEntry";

    /**
     * @ngdoc object
     * @name lbServices.JournalEntry.journal
     * @header lbServices.JournalEntry.journal
     * @object
     * @description
     *
     * The object `JournalEntry.journal` groups methods
     * manipulating `Journal` instances related to `JournalEntry`.
     *
     * Call {@link lbServices.JournalEntry#journal JournalEntry.journal()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#journal
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Fetches hasOne relation journal.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::get::JournalEntry::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.journal#create
             * @methodOf lbServices.JournalEntry.journal
             *
             * @description
             *
             * Creates a new instance in journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.create = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::create::JournalEntry::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.journal#createMany
             * @methodOf lbServices.JournalEntry.journal
             *
             * @description
             *
             * Creates a new instance in journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.createMany = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::createMany::JournalEntry::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.journal#destroy
             * @methodOf lbServices.JournalEntry.journal
             *
             * @description
             *
             * Deletes journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journal.destroy = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::destroy::JournalEntry::journal"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.journal#update
             * @methodOf lbServices.JournalEntry.journal
             *
             * @description
             *
             * Update journal of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journal.update = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::update::JournalEntry::journal"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.JournalEntry.journals
     * @header lbServices.JournalEntry.journals
     * @object
     * @description
     *
     * The object `JournalEntry.journals` groups methods
     * manipulating `Journal` instances related to `JournalEntry`.
     *
     * Call {@link lbServices.JournalEntry#journals JournalEntry.journals()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#journals
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Queries journals of JournalEntry.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::get::JournalEntry::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.journals#count
             * @methodOf lbServices.JournalEntry.journals
             *
             * @description
             *
             * Counts journals of JournalEntry.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.journals.count = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::count::JournalEntry::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.journals#create
             * @methodOf lbServices.JournalEntry.journals
             *
             * @description
             *
             * Creates a new instance in journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.create = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::create::JournalEntry::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.journals#createMany
             * @methodOf lbServices.JournalEntry.journals
             *
             * @description
             *
             * Creates a new instance in journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.createMany = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::createMany::JournalEntry::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.journals#destroyAll
             * @methodOf lbServices.JournalEntry.journals
             *
             * @description
             *
             * Deletes all journals of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journals.destroyAll = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::delete::JournalEntry::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.journals#destroyById
             * @methodOf lbServices.JournalEntry.journals
             *
             * @description
             *
             * Delete a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.journals.destroyById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::destroyById::JournalEntry::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.journals#findById
             * @methodOf lbServices.JournalEntry.journals
             *
             * @description
             *
             * Find a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.findById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::findById::JournalEntry::journals"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.journals#updateById
             * @methodOf lbServices.JournalEntry.journals
             *
             * @description
             *
             * Update a related item by id for journals.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `fk` – `{*}` - Foreign key for journals
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Journal` object.)
             * </em>
             */
        R.journals.updateById = function() {
          var TargetResource = $injector.get("Journal");
          var action = TargetResource["::updateById::JournalEntry::journals"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.JournalEntry.Attachment
     * @header lbServices.JournalEntry.Attachment
     * @object
     * @description
     *
     * The object `JournalEntry.Attachment` groups methods
     * manipulating `Attachment` instances related to `JournalEntry`.
     *
     * Call {@link lbServices.JournalEntry#Attachment JournalEntry.Attachment()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#Attachment
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Fetches hasOne relation Attachment.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::get::JournalEntry::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.Attachment#create
             * @methodOf lbServices.JournalEntry.Attachment
             *
             * @description
             *
             * Creates a new instance in Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.create = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::create::JournalEntry::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.Attachment#createMany
             * @methodOf lbServices.JournalEntry.Attachment
             *
             * @description
             *
             * Creates a new instance in Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.createMany = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::createMany::JournalEntry::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.Attachment#destroy
             * @methodOf lbServices.JournalEntry.Attachment
             *
             * @description
             *
             * Deletes Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.Attachment.destroy = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::destroy::JournalEntry::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.Attachment#update
             * @methodOf lbServices.JournalEntry.Attachment
             *
             * @description
             *
             * Update Attachment of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Attachment` object.)
             * </em>
             */
        R.Attachment.update = function() {
          var TargetResource = $injector.get("Attachment");
          var action = TargetResource["::update::JournalEntry::Attachment"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#company
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::JournalEntry::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#user
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::JournalEntry::user"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.JournalEntry.payments
     * @header lbServices.JournalEntry.payments
     * @object
     * @description
     *
     * The object `JournalEntry.payments` groups methods
     * manipulating `Payment` instances related to `JournalEntry`.
     *
     * Call {@link lbServices.JournalEntry#payments JournalEntry.payments()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#payments
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Queries payments of JournalEntry.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::get::JournalEntry::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.payments#count
             * @methodOf lbServices.JournalEntry.payments
             *
             * @description
             *
             * Counts payments of JournalEntry.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.payments.count = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::count::JournalEntry::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.payments#create
             * @methodOf lbServices.JournalEntry.payments
             *
             * @description
             *
             * Creates a new instance in payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.create = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::create::JournalEntry::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.payments#createMany
             * @methodOf lbServices.JournalEntry.payments
             *
             * @description
             *
             * Creates a new instance in payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.createMany = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::createMany::JournalEntry::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.payments#destroyAll
             * @methodOf lbServices.JournalEntry.payments
             *
             * @description
             *
             * Deletes all payments of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.payments.destroyAll = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::delete::JournalEntry::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.payments#destroyById
             * @methodOf lbServices.JournalEntry.payments
             *
             * @description
             *
             * Delete a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.payments.destroyById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::destroyById::JournalEntry::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.payments#findById
             * @methodOf lbServices.JournalEntry.payments
             *
             * @description
             *
             * Find a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.findById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::findById::JournalEntry::payments"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.payments#updateById
             * @methodOf lbServices.JournalEntry.payments
             *
             * @description
             *
             * Update a related item by id for payments.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `fk` – `{*}` - Foreign key for payments
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R.payments.updateById = function() {
          var TargetResource = $injector.get("Payment");
          var action = TargetResource["::updateById::JournalEntry::payments"];
          return action.apply(R, arguments);
        };
    /**
     * @ngdoc object
     * @name lbServices.JournalEntry.events
     * @header lbServices.JournalEntry.events
     * @object
     * @description
     *
     * The object `JournalEntry.events` groups methods
     * manipulating `Event` instances related to `JournalEntry`.
     *
     * Call {@link lbServices.JournalEntry#events JournalEntry.events()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.JournalEntry#events
             * @methodOf lbServices.JournalEntry
             *
             * @description
             *
             * Queries events of JournalEntry.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::get::JournalEntry::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.events#count
             * @methodOf lbServices.JournalEntry.events
             *
             * @description
             *
             * Counts events of JournalEntry.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.events.count = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::count::JournalEntry::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.events#create
             * @methodOf lbServices.JournalEntry.events
             *
             * @description
             *
             * Creates a new instance in events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.create = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::create::JournalEntry::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.events#createMany
             * @methodOf lbServices.JournalEntry.events
             *
             * @description
             *
             * Creates a new instance in events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.createMany = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::createMany::JournalEntry::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.events#destroyAll
             * @methodOf lbServices.JournalEntry.events
             *
             * @description
             *
             * Deletes all events of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.events.destroyAll = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::delete::JournalEntry::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.events#destroyById
             * @methodOf lbServices.JournalEntry.events
             *
             * @description
             *
             * Delete a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.events.destroyById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::destroyById::JournalEntry::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.events#findById
             * @methodOf lbServices.JournalEntry.events
             *
             * @description
             *
             * Find a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.findById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::findById::JournalEntry::events"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.JournalEntry.events#updateById
             * @methodOf lbServices.JournalEntry.events
             *
             * @description
             *
             * Update a related item by id for events.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - JournalEntry id
             *
             *  - `fk` – `{*}` - Foreign key for events
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R.events.updateById = function() {
          var TargetResource = $injector.get("Event");
          var action = TargetResource["::updateById::JournalEntry::events"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Payment
 * @header lbServices.Payment
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Payment` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Payment",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Payments/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Payment.bankTransaction() instead.
            "prototype$__get__bankTransaction": {
              url: urlBase + "/Payments/:id/bankTransaction",
              method: "GET",
            },

            // INTERNAL. Use Payment.journalEntry() instead.
            "prototype$__get__journalEntry": {
              url: urlBase + "/Payments/:id/journalEntry",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#prototype$__get__invoice
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Fetches belongsTo relation invoice.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "prototype$__get__invoice": {
              url: urlBase + "/Payments/:id/invoice",
              method: "GET",
            },

            // INTERNAL. Use Payment.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/Payments/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Payment.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Payments/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#create
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Payments",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#patchOrCreate
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Payments",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#replaceOrCreate
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Payments/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#upsertWithWhere
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Payments/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#exists
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Payments/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#findById
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Payments/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#replaceById
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Payments/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#find
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Payments",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#findOne
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Payments/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#deleteById
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Payments/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#count
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Payments/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#prototype$patchAttributes
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Payments/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Payment#createMany
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Payments",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.payments.findById() instead.
            "::findById::BankTransaction::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/payments/:fk",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.payments.destroyById() instead.
            "::destroyById::BankTransaction::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/payments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.payments.updateById() instead.
            "::updateById::BankTransaction::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/payments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use BankTransaction.payments() instead.
            "::get::BankTransaction::payments": {
              isArray: true,
              url: urlBase + "/BankTransactions/:id/payments",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.payments.create() instead.
            "::create::BankTransaction::payments": {
              url: urlBase + "/BankTransactions/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.payments.createMany() instead.
            "::createMany::BankTransaction::payments": {
              isArray: true,
              url: urlBase + "/BankTransactions/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.payments.destroyAll() instead.
            "::delete::BankTransaction::payments": {
              url: urlBase + "/BankTransactions/:id/payments",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.payments.count() instead.
            "::count::BankTransaction::payments": {
              url: urlBase + "/BankTransactions/:id/payments/count",
              method: "GET",
            },

            // INTERNAL. Use Purchase.payments.findById() instead.
            "::findById::Purchase::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/payments/:fk",
              method: "GET",
            },

            // INTERNAL. Use Purchase.payments.destroyById() instead.
            "::destroyById::Purchase::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/payments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.payments.updateById() instead.
            "::updateById::Purchase::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/payments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Purchase.payments() instead.
            "::get::Purchase::payments": {
              isArray: true,
              url: urlBase + "/Purchases/:id/payments",
              method: "GET",
            },

            // INTERNAL. Use Purchase.payments.create() instead.
            "::create::Purchase::payments": {
              url: urlBase + "/Purchases/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use Purchase.payments.createMany() instead.
            "::createMany::Purchase::payments": {
              isArray: true,
              url: urlBase + "/Purchases/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use Purchase.payments.destroyAll() instead.
            "::delete::Purchase::payments": {
              url: urlBase + "/Purchases/:id/payments",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.payments.count() instead.
            "::count::Purchase::payments": {
              url: urlBase + "/Purchases/:id/payments/count",
              method: "GET",
            },

            // INTERNAL. Use Sale.payments.findById() instead.
            "::findById::Sale::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/payments/:fk",
              method: "GET",
            },

            // INTERNAL. Use Sale.payments.destroyById() instead.
            "::destroyById::Sale::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/payments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.payments.updateById() instead.
            "::updateById::Sale::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/payments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Sale.payments() instead.
            "::get::Sale::payments": {
              isArray: true,
              url: urlBase + "/Sales/:id/payments",
              method: "GET",
            },

            // INTERNAL. Use Sale.payments.create() instead.
            "::create::Sale::payments": {
              url: urlBase + "/Sales/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use Sale.payments.createMany() instead.
            "::createMany::Sale::payments": {
              isArray: true,
              url: urlBase + "/Sales/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use Sale.payments.destroyAll() instead.
            "::delete::Sale::payments": {
              url: urlBase + "/Sales/:id/payments",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.payments.count() instead.
            "::count::Sale::payments": {
              url: urlBase + "/Sales/:id/payments/count",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.payments.findById() instead.
            "::findById::JournalEntry::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/payments/:fk",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.payments.destroyById() instead.
            "::destroyById::JournalEntry::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/payments/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.payments.updateById() instead.
            "::updateById::JournalEntry::payments": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/payments/:fk",
              method: "PUT",
            },

            // INTERNAL. Use JournalEntry.payments() instead.
            "::get::JournalEntry::payments": {
              isArray: true,
              url: urlBase + "/JournalEntries/:id/payments",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.payments.create() instead.
            "::create::JournalEntry::payments": {
              url: urlBase + "/JournalEntries/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use JournalEntry.payments.createMany() instead.
            "::createMany::JournalEntry::payments": {
              isArray: true,
              url: urlBase + "/JournalEntries/:id/payments",
              method: "POST",
            },

            // INTERNAL. Use JournalEntry.payments.destroyAll() instead.
            "::delete::JournalEntry::payments": {
              url: urlBase + "/JournalEntries/:id/payments",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.payments.count() instead.
            "::count::JournalEntry::payments": {
              url: urlBase + "/JournalEntries/:id/payments/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Payment#upsert
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#updateOrCreate
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#patchOrCreateWithWhere
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#destroyById
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#removeById
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Payment#prototype$updateAttributes
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Payment` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Payment#modelName
        * @propertyOf lbServices.Payment
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Payment`.
        */
        R.modelName = "Payment";


            /**
             * @ngdoc method
             * @name lbServices.Payment#bankTransaction
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Fetches belongsTo relation bankTransaction.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankTransaction` object.)
             * </em>
             */
        R.bankTransaction = function() {
          var TargetResource = $injector.get("BankTransaction");
          var action = TargetResource["::get::Payment::bankTransaction"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Payment#journalEntry
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Fetches belongsTo relation journalEntry.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `JournalEntry` object.)
             * </em>
             */
        R.journalEntry = function() {
          var TargetResource = $injector.get("JournalEntry");
          var action = TargetResource["::get::Payment::journalEntry"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Payment#company
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::Payment::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Payment#user
             * @methodOf lbServices.Payment
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Payment id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Payment::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Contact
 * @header lbServices.Contact
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Contact` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Contact",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Contacts/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Contact#create
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Contacts",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact#patchOrCreate
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Contacts",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact#replaceOrCreate
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Contacts/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact#upsertWithWhere
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Contacts/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact#exists
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Contacts/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact#findById
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Contacts/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact#replaceById
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Contacts/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact#find
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Contacts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact#findOne
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Contacts/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact#updateAll
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Contacts/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact#deleteById
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Contacts/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact#count
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Contacts/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact#prototype$patchAttributes
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Contact id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Contacts/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact#createChangeStream
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Contacts/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Contact#createMany
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Contacts",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Contact#upsert
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Contact#updateOrCreate
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Contact#patchOrCreateWithWhere
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Contact#update
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Contact#destroyById
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Contact#removeById
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Contact#prototype$updateAttributes
             * @methodOf lbServices.Contact
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Contact id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Contact` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Contact#modelName
        * @propertyOf lbServices.Contact
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Contact`.
        */
        R.modelName = "Contact";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Customer
 * @header lbServices.Customer
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Customer` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Customer",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Customers/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Customer.sales.findById() instead.
            "prototype$__findById__sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Customers/:id/sales/:fk",
              method: "GET",
            },

            // INTERNAL. Use Customer.sales.destroyById() instead.
            "prototype$__destroyById__sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Customers/:id/sales/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Customer.sales.updateById() instead.
            "prototype$__updateById__sales": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Customers/:id/sales/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Customer.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/Customers/:id/company",
              method: "GET",
            },

            // INTERNAL. Use Customer.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/Customers/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Customer.sales() instead.
            "prototype$__get__sales": {
              isArray: true,
              url: urlBase + "/Customers/:id/sales",
              method: "GET",
            },

            // INTERNAL. Use Customer.sales.create() instead.
            "prototype$__create__sales": {
              url: urlBase + "/Customers/:id/sales",
              method: "POST",
            },

            // INTERNAL. Use Customer.sales.destroyAll() instead.
            "prototype$__delete__sales": {
              url: urlBase + "/Customers/:id/sales",
              method: "DELETE",
            },

            // INTERNAL. Use Customer.sales.count() instead.
            "prototype$__count__sales": {
              url: urlBase + "/Customers/:id/sales/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#create
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Customers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#patchOrCreate
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Customers",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#replaceOrCreate
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Customers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#upsertWithWhere
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Customers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#exists
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Customers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#findById
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Customers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#replaceById
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Customers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#find
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Customers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#findOne
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Customers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#deleteById
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Customers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#count
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Customers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#prototype$patchAttributes
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Customers/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Customer#createMany
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Customers",
              method: "POST",
            },

            // INTERNAL. Use Company.customers.findById() instead.
            "::findById::Company::customers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/customers/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.customers.destroyById() instead.
            "::destroyById::Company::customers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/customers/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.customers.updateById() instead.
            "::updateById::Company::customers": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/customers/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.customers() instead.
            "::get::Company::customers": {
              isArray: true,
              url: urlBase + "/Companies/:id/customers",
              method: "GET",
            },

            // INTERNAL. Use Company.customers.create() instead.
            "::create::Company::customers": {
              url: urlBase + "/Companies/:id/customers",
              method: "POST",
            },

            // INTERNAL. Use Company.customers.createMany() instead.
            "::createMany::Company::customers": {
              isArray: true,
              url: urlBase + "/Companies/:id/customers",
              method: "POST",
            },

            // INTERNAL. Use Company.customers.destroyAll() instead.
            "::delete::Company::customers": {
              url: urlBase + "/Companies/:id/customers",
              method: "DELETE",
            },

            // INTERNAL. Use Company.customers.count() instead.
            "::count::Company::customers": {
              url: urlBase + "/Companies/:id/customers/count",
              method: "GET",
            },

            // INTERNAL. Use Purchase.customer() instead.
            "::get::Purchase::customer": {
              url: urlBase + "/Purchases/:id/customer",
              method: "GET",
            },

            // INTERNAL. Use Sale.customer() instead.
            "::get::Sale::customer": {
              url: urlBase + "/Sales/:id/customer",
              method: "GET",
            },

            // INTERNAL. Use Sale.oldCustomer() instead.
            "::get::Sale::oldCustomer": {
              url: urlBase + "/Sales/:id/oldCustomer",
              method: "GET",
            },

            // INTERNAL. Use RecurringSale.customer() instead.
            "::get::RecurringSale::customer": {
              url: urlBase + "/recurring-sales/:id/customer",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Customer#upsert
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Customer#updateOrCreate
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Customer#patchOrCreateWithWhere
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Customer#destroyById
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Customer#removeById
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Customer#prototype$updateAttributes
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Customer` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Customer#modelName
        * @propertyOf lbServices.Customer
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Customer`.
        */
        R.modelName = "Customer";

    /**
     * @ngdoc object
     * @name lbServices.Customer.sales
     * @header lbServices.Customer.sales
     * @object
     * @description
     *
     * The object `Customer.sales` groups methods
     * manipulating `Sale` instances related to `Customer`.
     *
     * Call {@link lbServices.Customer#sales Customer.sales()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Customer#sales
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Queries sales of Customer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.sales = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::get::Customer::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer.sales#count
             * @methodOf lbServices.Customer.sales
             *
             * @description
             *
             * Counts sales of Customer.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.sales.count = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::count::Customer::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer.sales#create
             * @methodOf lbServices.Customer.sales
             *
             * @description
             *
             * Creates a new instance in sales of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.sales.create = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::create::Customer::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer.sales#createMany
             * @methodOf lbServices.Customer.sales
             *
             * @description
             *
             * Creates a new instance in sales of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.sales.createMany = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::createMany::Customer::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer.sales#destroyAll
             * @methodOf lbServices.Customer.sales
             *
             * @description
             *
             * Deletes all sales of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sales.destroyAll = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::delete::Customer::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer.sales#destroyById
             * @methodOf lbServices.Customer.sales
             *
             * @description
             *
             * Delete a related item by id for sales.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for sales
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.sales.destroyById = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::destroyById::Customer::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer.sales#findById
             * @methodOf lbServices.Customer.sales
             *
             * @description
             *
             * Find a related item by id for sales.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for sales
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.sales.findById = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::findById::Customer::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer.sales#updateById
             * @methodOf lbServices.Customer.sales
             *
             * @description
             *
             * Update a related item by id for sales.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `fk` – `{*}` - Foreign key for sales
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Sale` object.)
             * </em>
             */
        R.sales.updateById = function() {
          var TargetResource = $injector.get("Sale");
          var action = TargetResource["::updateById::Customer::sales"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer#company
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::Customer::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Customer#user
             * @methodOf lbServices.Customer
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Customer id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Customer::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Vendor
 * @header lbServices.Vendor
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Vendor` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Vendor",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Vendors/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use Vendor.purchases.findById() instead.
            "prototype$__findById__purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vendors/:id/purchases/:fk",
              method: "GET",
            },

            // INTERNAL. Use Vendor.purchases.destroyById() instead.
            "prototype$__destroyById__purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vendors/:id/purchases/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Vendor.purchases.updateById() instead.
            "prototype$__updateById__purchases": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Vendors/:id/purchases/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Vendor.purchases() instead.
            "prototype$__get__purchases": {
              isArray: true,
              url: urlBase + "/Vendors/:id/purchases",
              method: "GET",
            },

            // INTERNAL. Use Vendor.purchases.create() instead.
            "prototype$__create__purchases": {
              url: urlBase + "/Vendors/:id/purchases",
              method: "POST",
            },

            // INTERNAL. Use Vendor.purchases.destroyAll() instead.
            "prototype$__delete__purchases": {
              url: urlBase + "/Vendors/:id/purchases",
              method: "DELETE",
            },

            // INTERNAL. Use Vendor.purchases.count() instead.
            "prototype$__count__purchases": {
              url: urlBase + "/Vendors/:id/purchases/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#create
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Vendors",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#patchOrCreate
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Vendors",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#replaceOrCreate
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Vendors/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#upsertWithWhere
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Vendors/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#exists
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Vendors/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#findById
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Vendors/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#replaceById
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Vendors/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#find
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Vendors",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#findOne
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Vendors/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#updateAll
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Vendors/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#deleteById
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Vendors/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#count
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Vendors/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#prototype$patchAttributes
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vendor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Vendors/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#createChangeStream
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Vendors/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#merge
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `ids` – `{*=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
            "merge": {
              url: urlBase + "/Vendors/merge",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#search
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `query` – `{string=}` -
             *
             *  - `type` – `{string=}` -
             *
             *  - `limit` – `{number=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
            "search": {
              isArray: true,
              url: urlBase + "/Vendors/search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#orderedAccounts
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `vendorId` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
            "orderedAccounts": {
              isArray: true,
              url: urlBase + "/Vendors/ordered-accounts",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Vendor#createMany
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Vendors",
              method: "POST",
            },

            // INTERNAL. Use Company.vendors.findById() instead.
            "::findById::Company::vendors": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/vendors/:fk",
              method: "GET",
            },

            // INTERNAL. Use Company.vendors.destroyById() instead.
            "::destroyById::Company::vendors": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/vendors/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Company.vendors.updateById() instead.
            "::updateById::Company::vendors": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Companies/:id/vendors/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Company.vendors() instead.
            "::get::Company::vendors": {
              isArray: true,
              url: urlBase + "/Companies/:id/vendors",
              method: "GET",
            },

            // INTERNAL. Use Company.vendors.create() instead.
            "::create::Company::vendors": {
              url: urlBase + "/Companies/:id/vendors",
              method: "POST",
            },

            // INTERNAL. Use Company.vendors.createMany() instead.
            "::createMany::Company::vendors": {
              isArray: true,
              url: urlBase + "/Companies/:id/vendors",
              method: "POST",
            },

            // INTERNAL. Use Company.vendors.destroyAll() instead.
            "::delete::Company::vendors": {
              url: urlBase + "/Companies/:id/vendors",
              method: "DELETE",
            },

            // INTERNAL. Use Company.vendors.count() instead.
            "::count::Company::vendors": {
              url: urlBase + "/Companies/:id/vendors/count",
              method: "GET",
            },

            // INTERNAL. Use Purchase.vendor() instead.
            "::get::Purchase::vendor": {
              url: urlBase + "/Purchases/:id/vendor",
              method: "GET",
            },

            // INTERNAL. Use Purchase.oldVendor() instead.
            "::get::Purchase::oldVendor": {
              url: urlBase + "/Purchases/:id/oldVendor",
              method: "GET",
            },

            // INTERNAL. Use Sale.vendor() instead.
            "::get::Sale::vendor": {
              url: urlBase + "/Sales/:id/vendor",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Vendor#upsert
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Vendor#updateOrCreate
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Vendor#patchOrCreateWithWhere
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Vendor#update
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Vendor#destroyById
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Vendor#removeById
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Vendor#prototype$updateAttributes
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vendor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Vendor` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Vendor#modelName
        * @propertyOf lbServices.Vendor
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Vendor`.
        */
        R.modelName = "Vendor";

    /**
     * @ngdoc object
     * @name lbServices.Vendor.purchases
     * @header lbServices.Vendor.purchases
     * @object
     * @description
     *
     * The object `Vendor.purchases` groups methods
     * manipulating `Purchase` instances related to `Vendor`.
     *
     * Call {@link lbServices.Vendor#purchases Vendor.purchases()}
     * to query all related instances.
     */


            /**
             * @ngdoc method
             * @name lbServices.Vendor#purchases
             * @methodOf lbServices.Vendor
             *
             * @description
             *
             * Queries purchases of Vendor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vendor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `filter` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R.purchases = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::get::Vendor::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vendor.purchases#count
             * @methodOf lbServices.Vendor.purchases
             *
             * @description
             *
             * Counts purchases of Vendor.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vendor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
        R.purchases.count = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::count::Vendor::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vendor.purchases#create
             * @methodOf lbServices.Vendor.purchases
             *
             * @description
             *
             * Creates a new instance in purchases of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vendor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R.purchases.create = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::create::Vendor::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vendor.purchases#createMany
             * @methodOf lbServices.Vendor.purchases
             *
             * @description
             *
             * Creates a new instance in purchases of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vendor id
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R.purchases.createMany = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::createMany::Vendor::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vendor.purchases#destroyAll
             * @methodOf lbServices.Vendor.purchases
             *
             * @description
             *
             * Deletes all purchases of this model.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vendor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `where` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.purchases.destroyAll = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::delete::Vendor::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vendor.purchases#destroyById
             * @methodOf lbServices.Vendor.purchases
             *
             * @description
             *
             * Delete a related item by id for purchases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vendor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for purchases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
        R.purchases.destroyById = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::destroyById::Vendor::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vendor.purchases#findById
             * @methodOf lbServices.Vendor.purchases
             *
             * @description
             *
             * Find a related item by id for purchases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vendor id
             *
             *  - `options` – `{object=}` -
             *
             *  - `fk` – `{*}` - Foreign key for purchases
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R.purchases.findById = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::findById::Vendor::purchases"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Vendor.purchases#updateById
             * @methodOf lbServices.Vendor.purchases
             *
             * @description
             *
             * Update a related item by id for purchases.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Vendor id
             *
             *  - `fk` – `{*}` - Foreign key for purchases
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Purchase` object.)
             * </em>
             */
        R.purchases.updateById = function() {
          var TargetResource = $injector.get("Purchase");
          var action = TargetResource["::updateById::Vendor::purchases"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Organisation
 * @header lbServices.Organisation
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Organisation` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Organisation",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Organisations/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Organisation#create
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/Organisations",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#patchOrCreate
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/Organisations",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#replaceOrCreate
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/Organisations/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#upsertWithWhere
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/Organisations/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#exists
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/Organisations/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#findById
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/Organisations/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#replaceById
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/Organisations/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#find
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/Organisations",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#findOne
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/Organisations/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#updateAll
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/Organisations/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#deleteById
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/Organisations/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#count
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/Organisations/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#prototype$patchAttributes
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organisation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/Organisations/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#createChangeStream
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/Organisations/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#search
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `query` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `organisations` – `{object=}` -
             */
            "search": {
              url: urlBase + "/Organisations/search",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#kvk
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `companyRegistrationNumber` – `{string=}` -
             *
             *  - `companyName` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `organisation` – `{object=}` -
             */
            "kvk": {
              url: urlBase + "/Organisations/kvk",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#validateVatIdentificationNumber
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `vatIdentificationNumber` – `{string=}` -
             *
             *  - `country` – `{string=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
            "validateVatIdentificationNumber": {
              url: urlBase + "/Organisations/validate-vat-identification-number",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Organisation#createMany
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/Organisations",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Organisation#upsert
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Organisation#updateOrCreate
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Organisation#patchOrCreateWithWhere
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Organisation#update
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Organisation#destroyById
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Organisation#removeById
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Organisation#prototype$updateAttributes
             * @methodOf lbServices.Organisation
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Organisation id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Organisation` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Organisation#modelName
        * @propertyOf lbServices.Organisation
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Organisation`.
        */
        R.modelName = "Organisation";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.VatCode
 * @header lbServices.VatCode
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `VatCode` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "VatCode",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/vat-codes/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.VatCode#create
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/vat-codes",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.VatCode#patchOrCreate
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/vat-codes",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.VatCode#replaceOrCreate
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/vat-codes/replace-or-create",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.VatCode#upsertWithWhere
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/vat-codes/upsert-with-where",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.VatCode#exists
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/vat-codes/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.VatCode#findById
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/vat-codes/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.VatCode#replaceById
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/vat-codes/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.VatCode#find
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/vat-codes",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.VatCode#findOne
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/vat-codes/find-one",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.VatCode#updateAll
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/vat-codes/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.VatCode#deleteById
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/vat-codes/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.VatCode#count
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/vat-codes/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.VatCode#prototype$patchAttributes
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - VatCode id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/vat-codes/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.VatCode#createChangeStream
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/vat-codes/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.VatCode#createMany
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/vat-codes",
              method: "POST",
            },

            // INTERNAL. Use SaleItem.vatCode() instead.
            "::get::SaleItem::vatCode": {
              url: urlBase + "/sale-items/:id/vat-code",
              method: "GET",
            },

            // INTERNAL. Use BankRule.vatCode() instead.
            "::get::BankRule::vatCode": {
              url: urlBase + "/BankRules/:id/vatCode",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.VatCode#upsert
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.VatCode#updateOrCreate
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.VatCode#patchOrCreateWithWhere
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.VatCode#update
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.VatCode#destroyById
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.VatCode#removeById
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.VatCode#prototype$updateAttributes
             * @methodOf lbServices.VatCode
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - VatCode id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.VatCode#modelName
        * @propertyOf lbServices.VatCode
        * @description
        * The name of the model represented by this $resource,
        * i.e. `VatCode`.
        */
        R.modelName = "VatCode";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Email
 * @header lbServices.Email
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Email` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Email",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Emails/:id",
          { 'id': '@id' },
          {
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Email#modelName
        * @propertyOf lbServices.Email
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Email`.
        */
        R.modelName = "Email";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Rapporting
 * @header lbServices.Rapporting
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Rapporting` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Rapporting",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/Rapporting/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Rapporting#dashboard
             * @methodOf lbServices.Rapporting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `year` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `rapporting` – `{object=}` -
             */
            "dashboard": {
              url: urlBase + "/Rapporting/dashboard",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rapporting#profit
             * @methodOf lbServices.Rapporting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `year` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `profit` – `{number=}` -
             */
            "profit": {
              url: urlBase + "/Rapporting/profit",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rapporting#expense
             * @methodOf lbServices.Rapporting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `year` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `expense` – `{number=}` -
             */
            "expense": {
              url: urlBase + "/Rapporting/expense",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rapporting#revenue
             * @methodOf lbServices.Rapporting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `year` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `revenue` – `{number=}` -
             */
            "revenue": {
              url: urlBase + "/Rapporting/revenue",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rapporting#balanceSheet
             * @methodOf lbServices.Rapporting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `beginDate` – `{Date=}` -
             *
             *  - `endDate` – `{Date=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `balance` – `{*=}` -
             */
            "balanceSheet": {
              url: urlBase + "/Rapporting/balanceSheet",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rapporting#plSheet
             * @methodOf lbServices.Rapporting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `year` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `profitloss` – `{*=}` -
             */
            "plSheet": {
              url: urlBase + "/Rapporting/plSheet",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rapporting#revenueAndExpense
             * @methodOf lbServices.Rapporting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `beginDate` – `{Date=}` -
             *
             *  - `endDate` – `{Date=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `revenueAndExpense` – `{*=}` -
             */
            "revenueAndExpense": {
              url: urlBase + "/Rapporting/revenueAndExpense",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rapporting#
             * @methodOf lbServices.Rapporting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             *  - `year` – `{string=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `profitloss` – `{*=}` -
             */
            "": {
              url: urlBase + "/Rapporting/plSheet",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rapporting#generatVatReturnBooking
             * @methodOf lbServices.Rapporting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `beginDate` – `{Date}` -
             *
             *  - `endDate` – `{Date}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `journalEntry` – `{object=}` -
             */
            "generatVatReturnBooking": {
              url: urlBase + "/Rapporting/generatVatReturnBooking",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rapporting#vatReturn
             * @methodOf lbServices.Rapporting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `beginDate` – `{Date=}` -
             *
             *  - `endDate` – `{Date=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `vatReturn` – `{*=}` -
             */
            "vatReturn": {
              url: urlBase + "/Rapporting/vatReturn",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rapporting#openDebit
             * @methodOf lbServices.Rapporting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `date` – `{Date}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `openDebit` – `{object=}` -
             */
            "openDebit": {
              url: urlBase + "/Rapporting/open-debit",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rapporting#openCredit
             * @methodOf lbServices.Rapporting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `date` – `{Date}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `openCredit` – `{object=}` -
             */
            "openCredit": {
              url: urlBase + "/Rapporting/open-credit",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Rapporting#tAccounts
             * @methodOf lbServices.Rapporting
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `beginDate` – `{Date}` -
             *
             *  - `endDate` – `{Date}` -
             *
             *  - `accountFrom` – `{number}` -
             *
             *  - `accountTo` – `{number}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `tAccounts` – `{*=}` -
             */
            "tAccounts": {
              url: urlBase + "/Rapporting/tAccounts",
              method: "GET",
            },
          }
        );




        /**
        * @ngdoc property
        * @name lbServices.Rapporting#modelName
        * @propertyOf lbServices.Rapporting
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Rapporting`.
        */
        R.modelName = "Rapporting";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.BankRule
 * @header lbServices.BankRule
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `BankRule` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "BankRule",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/BankRules/:id",
          { 'id': '@id' },
          {

            // INTERNAL. Use BankRule.account() instead.
            "prototype$__get__account": {
              url: urlBase + "/BankRules/:id/account",
              method: "GET",
            },

            // INTERNAL. Use BankRule.subAccount() instead.
            "prototype$__get__subAccount": {
              url: urlBase + "/BankRules/:id/subAccount",
              method: "GET",
            },

            // INTERNAL. Use BankRule.vatCode() instead.
            "prototype$__get__vatCode": {
              url: urlBase + "/BankRules/:id/vatCode",
              method: "GET",
            },

            // INTERNAL. Use BankRule.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/BankRules/:id/company",
              method: "GET",
            },

            // INTERNAL. Use BankRule.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/BankRules/:id/user",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankRule#create
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/BankRules",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankRule#patchOrCreate
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/BankRules",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankRule#replaceOrCreate
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/BankRules/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankRule#upsertWithWhere
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/BankRules/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankRule#exists
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/BankRules/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankRule#findById
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/BankRules/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankRule#replaceById
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/BankRules/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankRule#find
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/BankRules",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankRule#findOne
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/BankRules/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankRule#deleteById
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/BankRules/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankRule#count
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/BankRules/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankRule#prototype$patchAttributes
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankRule id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/BankRules/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.BankRule#createMany
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/BankRules",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.bankRule() instead.
            "::get::BankTransaction::bankRule": {
              url: urlBase + "/BankTransactions/:id/bankRule",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.BankRule#upsert
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.BankRule#updateOrCreate
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.BankRule#patchOrCreateWithWhere
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.BankRule#destroyById
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BankRule#removeById
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.BankRule#prototype$updateAttributes
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankRule id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `BankRule` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.BankRule#modelName
        * @propertyOf lbServices.BankRule
        * @description
        * The name of the model represented by this $resource,
        * i.e. `BankRule`.
        */
        R.modelName = "BankRule";


            /**
             * @ngdoc method
             * @name lbServices.BankRule#account
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Fetches belongsTo relation account.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankRule id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Account` object.)
             * </em>
             */
        R.account = function() {
          var TargetResource = $injector.get("Account");
          var action = TargetResource["::get::BankRule::account"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankRule#subAccount
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Fetches belongsTo relation subAccount.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankRule id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `SubAccount` object.)
             * </em>
             */
        R.subAccount = function() {
          var TargetResource = $injector.get("SubAccount");
          var action = TargetResource["::get::BankRule::subAccount"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankRule#vatCode
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Fetches belongsTo relation vatCode.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankRule id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `VatCode` object.)
             * </em>
             */
        R.vatCode = function() {
          var TargetResource = $injector.get("VatCode");
          var action = TargetResource["::get::BankRule::vatCode"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankRule#company
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankRule id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::BankRule::company"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.BankRule#user
             * @methodOf lbServices.BankRule
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - BankRule id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::BankRule::user"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.ExchangeRate
 * @header lbServices.ExchangeRate
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `ExchangeRate` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "ExchangeRate",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/exchange-rates/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#create
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/exchange-rates",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#patchOrCreate
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/exchange-rates",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#replaceOrCreate
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/exchange-rates/replace-or-create",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#upsertWithWhere
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/exchange-rates/upsert-with-where",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#exists
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/exchange-rates/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#findById
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/exchange-rates/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#replaceById
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/exchange-rates/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#find
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/exchange-rates",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#findOne
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/exchange-rates/find-one",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#updateAll
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/exchange-rates/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#deleteById
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/exchange-rates/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#count
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/exchange-rates/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#prototype$patchAttributes
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ExchangeRate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/exchange-rates/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#createChangeStream
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/exchange-rates/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#createMany
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/exchange-rates",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#upsert
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#updateOrCreate
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#patchOrCreateWithWhere
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#update
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#destroyById
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#removeById
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.ExchangeRate#prototype$updateAttributes
             * @methodOf lbServices.ExchangeRate
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - ExchangeRate id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `ExchangeRate` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.ExchangeRate#modelName
        * @propertyOf lbServices.ExchangeRate
        * @description
        * The name of the model represented by this $resource,
        * i.e. `ExchangeRate`.
        */
        R.modelName = "ExchangeRate";



        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Event
 * @header lbServices.Event
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Event` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Event",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/events/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Event#prototype$__get__source
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Fetches belongsTo relation source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Event id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
            "prototype$__get__source": {
              url: urlBase + "/events/:id/source",
              method: "GET",
            },

            // INTERNAL. Use Event.user() instead.
            "prototype$__get__user": {
              url: urlBase + "/events/:id/user",
              method: "GET",
            },

            // INTERNAL. Use Event.company() instead.
            "prototype$__get__company": {
              url: urlBase + "/events/:id/company",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Event#create
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/events",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Event#patchOrCreate
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/events",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Event#replaceOrCreate
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/events/replace-or-create",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Event#upsertWithWhere
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/events/upsert-with-where",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Event#exists
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/events/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Event#findById
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/events/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Event#replaceById
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/events/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Event#find
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/events",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Event#findOne
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/events/find-one",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Event#deleteById
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/events/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Event#count
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/events/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Event#prototype$patchAttributes
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Event id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/events/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Event#createMany
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/events",
              method: "POST",
            },

            // INTERNAL. Use TransactionBase.events.findById() instead.
            "::findById::TransactionBase::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/TransactionBases/:id/events/:fk",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.events.destroyById() instead.
            "::destroyById::TransactionBase::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/TransactionBases/:id/events/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use TransactionBase.events.updateById() instead.
            "::updateById::TransactionBase::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/TransactionBases/:id/events/:fk",
              method: "PUT",
            },

            // INTERNAL. Use TransactionBase.events() instead.
            "::get::TransactionBase::events": {
              isArray: true,
              url: urlBase + "/TransactionBases/:id/events",
              method: "GET",
            },

            // INTERNAL. Use TransactionBase.events.create() instead.
            "::create::TransactionBase::events": {
              url: urlBase + "/TransactionBases/:id/events",
              method: "POST",
            },

            // INTERNAL. Use TransactionBase.events.createMany() instead.
            "::createMany::TransactionBase::events": {
              isArray: true,
              url: urlBase + "/TransactionBases/:id/events",
              method: "POST",
            },

            // INTERNAL. Use TransactionBase.events.destroyAll() instead.
            "::delete::TransactionBase::events": {
              url: urlBase + "/TransactionBases/:id/events",
              method: "DELETE",
            },

            // INTERNAL. Use TransactionBase.events.count() instead.
            "::count::TransactionBase::events": {
              url: urlBase + "/TransactionBases/:id/events/count",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.events.findById() instead.
            "::findById::BankTransaction::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/events/:fk",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.events.destroyById() instead.
            "::destroyById::BankTransaction::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/events/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.events.updateById() instead.
            "::updateById::BankTransaction::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/BankTransactions/:id/events/:fk",
              method: "PUT",
            },

            // INTERNAL. Use BankTransaction.events() instead.
            "::get::BankTransaction::events": {
              isArray: true,
              url: urlBase + "/BankTransactions/:id/events",
              method: "GET",
            },

            // INTERNAL. Use BankTransaction.events.create() instead.
            "::create::BankTransaction::events": {
              url: urlBase + "/BankTransactions/:id/events",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.events.createMany() instead.
            "::createMany::BankTransaction::events": {
              isArray: true,
              url: urlBase + "/BankTransactions/:id/events",
              method: "POST",
            },

            // INTERNAL. Use BankTransaction.events.destroyAll() instead.
            "::delete::BankTransaction::events": {
              url: urlBase + "/BankTransactions/:id/events",
              method: "DELETE",
            },

            // INTERNAL. Use BankTransaction.events.count() instead.
            "::count::BankTransaction::events": {
              url: urlBase + "/BankTransactions/:id/events/count",
              method: "GET",
            },

            // INTERNAL. Use Invoice.events.findById() instead.
            "::findById::Invoice::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Invoices/:id/events/:fk",
              method: "GET",
            },

            // INTERNAL. Use Invoice.events.destroyById() instead.
            "::destroyById::Invoice::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Invoices/:id/events/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Invoice.events.updateById() instead.
            "::updateById::Invoice::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Invoices/:id/events/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Invoice.events() instead.
            "::get::Invoice::events": {
              isArray: true,
              url: urlBase + "/Invoices/:id/events",
              method: "GET",
            },

            // INTERNAL. Use Invoice.events.create() instead.
            "::create::Invoice::events": {
              url: urlBase + "/Invoices/:id/events",
              method: "POST",
            },

            // INTERNAL. Use Invoice.events.createMany() instead.
            "::createMany::Invoice::events": {
              isArray: true,
              url: urlBase + "/Invoices/:id/events",
              method: "POST",
            },

            // INTERNAL. Use Invoice.events.destroyAll() instead.
            "::delete::Invoice::events": {
              url: urlBase + "/Invoices/:id/events",
              method: "DELETE",
            },

            // INTERNAL. Use Invoice.events.count() instead.
            "::count::Invoice::events": {
              url: urlBase + "/Invoices/:id/events/count",
              method: "GET",
            },

            // INTERNAL. Use Purchase.events.findById() instead.
            "::findById::Purchase::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/events/:fk",
              method: "GET",
            },

            // INTERNAL. Use Purchase.events.destroyById() instead.
            "::destroyById::Purchase::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/events/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.events.updateById() instead.
            "::updateById::Purchase::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Purchases/:id/events/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Purchase.events() instead.
            "::get::Purchase::events": {
              isArray: true,
              url: urlBase + "/Purchases/:id/events",
              method: "GET",
            },

            // INTERNAL. Use Purchase.events.create() instead.
            "::create::Purchase::events": {
              url: urlBase + "/Purchases/:id/events",
              method: "POST",
            },

            // INTERNAL. Use Purchase.events.createMany() instead.
            "::createMany::Purchase::events": {
              isArray: true,
              url: urlBase + "/Purchases/:id/events",
              method: "POST",
            },

            // INTERNAL. Use Purchase.events.destroyAll() instead.
            "::delete::Purchase::events": {
              url: urlBase + "/Purchases/:id/events",
              method: "DELETE",
            },

            // INTERNAL. Use Purchase.events.count() instead.
            "::count::Purchase::events": {
              url: urlBase + "/Purchases/:id/events/count",
              method: "GET",
            },

            // INTERNAL. Use Sale.events.findById() instead.
            "::findById::Sale::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/events/:fk",
              method: "GET",
            },

            // INTERNAL. Use Sale.events.destroyById() instead.
            "::destroyById::Sale::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/events/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.events.updateById() instead.
            "::updateById::Sale::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/Sales/:id/events/:fk",
              method: "PUT",
            },

            // INTERNAL. Use Sale.events() instead.
            "::get::Sale::events": {
              isArray: true,
              url: urlBase + "/Sales/:id/events",
              method: "GET",
            },

            // INTERNAL. Use Sale.events.create() instead.
            "::create::Sale::events": {
              url: urlBase + "/Sales/:id/events",
              method: "POST",
            },

            // INTERNAL. Use Sale.events.createMany() instead.
            "::createMany::Sale::events": {
              isArray: true,
              url: urlBase + "/Sales/:id/events",
              method: "POST",
            },

            // INTERNAL. Use Sale.events.destroyAll() instead.
            "::delete::Sale::events": {
              url: urlBase + "/Sales/:id/events",
              method: "DELETE",
            },

            // INTERNAL. Use Sale.events.count() instead.
            "::count::Sale::events": {
              url: urlBase + "/Sales/:id/events/count",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.events.findById() instead.
            "::findById::JournalEntry::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/events/:fk",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.events.destroyById() instead.
            "::destroyById::JournalEntry::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/events/:fk",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.events.updateById() instead.
            "::updateById::JournalEntry::events": {
              params: {
                'fk': '@fk',
              },
              url: urlBase + "/JournalEntries/:id/events/:fk",
              method: "PUT",
            },

            // INTERNAL. Use JournalEntry.events() instead.
            "::get::JournalEntry::events": {
              isArray: true,
              url: urlBase + "/JournalEntries/:id/events",
              method: "GET",
            },

            // INTERNAL. Use JournalEntry.events.create() instead.
            "::create::JournalEntry::events": {
              url: urlBase + "/JournalEntries/:id/events",
              method: "POST",
            },

            // INTERNAL. Use JournalEntry.events.createMany() instead.
            "::createMany::JournalEntry::events": {
              isArray: true,
              url: urlBase + "/JournalEntries/:id/events",
              method: "POST",
            },

            // INTERNAL. Use JournalEntry.events.destroyAll() instead.
            "::delete::JournalEntry::events": {
              url: urlBase + "/JournalEntries/:id/events",
              method: "DELETE",
            },

            // INTERNAL. Use JournalEntry.events.count() instead.
            "::count::JournalEntry::events": {
              url: urlBase + "/JournalEntries/:id/events/count",
              method: "GET",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Event#upsert
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Event#updateOrCreate
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Event#patchOrCreateWithWhere
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Event#destroyById
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Event#removeById
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Event#prototype$updateAttributes
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Event id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Event` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Event#modelName
        * @propertyOf lbServices.Event
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Event`.
        */
        R.modelName = "Event";


            /**
             * @ngdoc method
             * @name lbServices.Event#user
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Fetches belongsTo relation user.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Event id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `User` object.)
             * </em>
             */
        R.user = function() {
          var TargetResource = $injector.get("User");
          var action = TargetResource["::get::Event::user"];
          return action.apply(R, arguments);
        };

            /**
             * @ngdoc method
             * @name lbServices.Event#company
             * @methodOf lbServices.Event
             *
             * @description
             *
             * Fetches belongsTo relation company.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Event id
             *
             *  - `options` – `{object=}` -
             *
             *  - `refresh` – `{boolean=}` -
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Company` object.)
             * </em>
             */
        R.company = function() {
          var TargetResource = $injector.get("Company");
          var action = TargetResource["::get::Event::company"];
          return action.apply(R, arguments);
        };


        return R;
      }]);

/**
 * @ngdoc object
 * @name lbServices.Container
 * @header lbServices.Container
 * @object
 *
 * @description
 *
 * A $resource object for interacting with the `Container` model.
 *
 * ## Example
 *
 * See
 * {@link http://docs.angularjs.org/api/ngResource.$resource#example $resource}
 * for an example of using this object.
 *
 */
  module.factory(
    "Container",
    [
      'LoopBackResource', 'LoopBackAuth', '$injector', '$q',
      function(LoopBackResource, LoopBackAuth, $injector, $q) {
        var R = LoopBackResource(
        urlBase + "/containers/:id",
          { 'id': '@id' },
          {

            /**
             * @ngdoc method
             * @name lbServices.Container#getContainers
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "getContainers": {
              isArray: true,
              url: urlBase + "/containers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#createContainer
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             * This method expects a subset of model properties as request parameters.
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "createContainer": {
              url: urlBase + "/containers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#destroyContainer
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "destroyContainer": {
              url: urlBase + "/containers/:container",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#getContainer
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "getContainer": {
              url: urlBase + "/containers/:container",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#getFiles
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "getFiles": {
              isArray: true,
              url: urlBase + "/containers/:container/files",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#getFile
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "getFile": {
              url: urlBase + "/containers/:container/files/:file",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#removeFile
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `` – `{undefined=}` -
             */
            "removeFile": {
              url: urlBase + "/containers/:container/files/:file",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#upload
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             * @param {Object} postData Request data.
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `result` – `{object=}` -
             */
            "upload": {
              url: urlBase + "/containers/:container/upload",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#download
             * @methodOf lbServices.Container
             *
             * @description
             *
             * <em>
             * (The remote method definition does not provide any description.)
             * </em>
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `container` – `{string}` -
             *
             *  - `file` – `{string}` -
             *
             *  - `req` – `{object=}` -
             *
             *  - `res` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * This method returns no data.
             */
            "download": {
              url: urlBase + "/containers/:container/download/:file",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#create
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "create": {
              url: urlBase + "/containers",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#patchOrCreate
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "patchOrCreate": {
              url: urlBase + "/containers",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#replaceOrCreate
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Replace an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "replaceOrCreate": {
              url: urlBase + "/containers/replaceOrCreate",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#upsertWithWhere
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "upsertWithWhere": {
              url: urlBase + "/containers/upsertWithWhere",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#exists
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Check whether a model instance exists in the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `exists` – `{boolean=}` -
             */
            "exists": {
              url: urlBase + "/containers/:id/exists",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#findById
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Find a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `filter` – `{object=}` - Filter defining fields and include - must be a JSON-encoded string ({"something":"value"})
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "findById": {
              url: urlBase + "/containers/:id",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#replaceById
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Replace attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "replaceById": {
              url: urlBase + "/containers/:id/replace",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#find
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Find all instances of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "find": {
              isArray: true,
              url: urlBase + "/containers",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#findOne
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Find first instance of the model matched by filter from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `filter` – `{object=}` - Filter defining fields, where, include, order, offset, and limit - must be a JSON-encoded string (`{"where":{"something":"value"}}`).  See https://loopback.io/doc/en/lb3/Querying-data.html#using-stringified-json-in-rest-queries for more details.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "findOne": {
              url: urlBase + "/containers/findOne",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#updateAll
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
            "updateAll": {
              url: urlBase + "/containers/update",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#deleteById
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "deleteById": {
              url: urlBase + "/containers/:id",
              method: "DELETE",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#count
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Count instances of the model matched by where from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `count` – `{number=}` -
             */
            "count": {
              url: urlBase + "/containers/count",
              method: "GET",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#prototype$patchAttributes
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - container id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "prototype$patchAttributes": {
              url: urlBase + "/containers/:id",
              method: "PATCH",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#createChangeStream
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Create a change stream.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Data properties:
             *
             *  - `changes` – `{ReadableStream=}` -
             */
            "createChangeStream": {
              url: urlBase + "/containers/change-stream",
              method: "POST",
            },

            /**
             * @ngdoc method
             * @name lbServices.Container#createMany
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Create a new instance of the model and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *   This method does not accept any parameters.
             *   Supply an empty object or omit this argument altogether.
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Array.<Object>,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Array.<Object>} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
            "createMany": {
              isArray: true,
              url: urlBase + "/containers",
              method: "POST",
            },
          }
        );



            /**
             * @ngdoc method
             * @name lbServices.Container#upsert
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
        R["upsert"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Container#updateOrCreate
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Patch an existing model instance or insert a new one into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `data` – `{object=}` - Model instance data
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
        R["updateOrCreate"] = R["patchOrCreate"];

            /**
             * @ngdoc method
             * @name lbServices.Container#patchOrCreateWithWhere
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Update an existing model instance or insert a new one into the data source based on the where criteria.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
        R["patchOrCreateWithWhere"] = R["upsertWithWhere"];

            /**
             * @ngdoc method
             * @name lbServices.Container#update
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Update instances of the model matched by {{where}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `where` – `{object=}` - Criteria to match model instances
             *
             * @param {Object} postData Request data.
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * Information related to the outcome of the operation
             */
        R["update"] = R["updateAll"];

            /**
             * @ngdoc method
             * @name lbServices.Container#destroyById
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
        R["destroyById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Container#removeById
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Delete a model instance by {{id}} from the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - Model id
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
        R["removeById"] = R["deleteById"];

            /**
             * @ngdoc method
             * @name lbServices.Container#prototype$updateAttributes
             * @methodOf lbServices.Container
             *
             * @description
             *
             * Patch attributes for a model instance and persist it into the data source.
             *
             * @param {Object=} parameters Request parameters.
             *
             *  - `id` – `{*}` - container id
             *
             *  - `options` – `{object=}` -
             *
             *  - `data` – `{object=}` - An object of model property name/value pairs
             *
             *  - `options` – `{object=}` -
             *
             * @param {function(Object,Object)=} successCb
             *   Success callback with two arguments: `value`, `responseHeaders`.
             *
             * @param {function(Object)=} errorCb Error callback with one argument:
             *   `httpResponse`.
             *
             * @returns {Object} An empty reference that will be
             *   populated with the actual data once the response is returned
             *   from the server.
             *
             * <em>
             * (The remote method definition does not provide any description.
             * This usually means the response is a `Container` object.)
             * </em>
             */
        R["prototype$updateAttributes"] = R["prototype$patchAttributes"];


        /**
        * @ngdoc property
        * @name lbServices.Container#modelName
        * @propertyOf lbServices.Container
        * @description
        * The name of the model represented by this $resource,
        * i.e. `Container`.
        */
        R.modelName = "Container";



        return R;
      }]);


  module
  .factory('LoopBackAuth', function() {
    var props = ['accessTokenId', 'currentUserId', 'rememberMe'];
    var propsPrefix = '$LoopBack$';

    function LoopBackAuth() {
      var self = this;
      props.forEach(function(name) {
        self[name] = load(name);
      });
      this.currentUserData = null;
    }

    LoopBackAuth.prototype.save = function() {
      var self = this;
      var storage = this.rememberMe ? localStorage : sessionStorage;
      props.forEach(function(name) {
        save(storage, name, self[name]);
      });
    };

    LoopBackAuth.prototype.setUser = function(accessTokenId, userId, userData) {
      this.accessTokenId = accessTokenId;
      this.currentUserId = userId;
      this.currentUserData = userData;
    };

    LoopBackAuth.prototype.clearUser = function() {
      this.accessTokenId = null;
      this.currentUserId = null;
      this.currentUserData = null;
    };

    LoopBackAuth.prototype.clearStorage = function() {
      props.forEach(function(name) {
        save(sessionStorage, name, null);
        save(localStorage, name, null);
      });
    };

    return new LoopBackAuth();

    // Note: LocalStorage converts the value to string
    // We are using empty string as a marker for null/undefined values.
    function save(storage, name, value) {
      try {
        var key = propsPrefix + name;
        if (value == null) value = '';
        storage[key] = value;
      } catch (err) {
        console.log('Cannot access local/session storage:', err);
      }
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key] || sessionStorage[key] || null;
    }
  })
  .config(['$httpProvider', function($httpProvider) {
    $httpProvider.interceptors.push('LoopBackAuthRequestInterceptor');
  }])
  .factory('LoopBackAuthRequestInterceptor', ['$q', 'LoopBackAuth',
    function($q, LoopBackAuth) {
      return {
        'request': function(config) {
          // filter out external requests
          var host = getHost(config.url);
          if (host && config.url.indexOf(urlBaseHost) === -1) {
            return config;
          }

          if (LoopBackAuth.accessTokenId) {
            config.headers[authHeader] = LoopBackAuth.accessTokenId;
          } else if (config.__isGetCurrentUser__) {
            // Return a stub 401 error for User.getCurrent() when
            // there is no user logged in
            var res = {
              body: { error: { status: 401 }},
              status: 401,
              config: config,
              headers: function() { return undefined; },
            };
            return $q.reject(res);
          }
          return config || $q.when(config);
        },
      };
    }])

  /**
   * @ngdoc object
   * @name lbServices.LoopBackResourceProvider
   * @header lbServices.LoopBackResourceProvider
   * @description
   * Use `LoopBackResourceProvider` to change the global configuration
   * settings used by all models. Note that the provider is available
   * to Configuration Blocks only, see
   * {@link https://docs.angularjs.org/guide/module#module-loading-dependencies Module Loading & Dependencies}
   * for more details.
   *
   * ## Example
   *
   * ```js
   * angular.module('app')
   *  .config(function(LoopBackResourceProvider) {
   *     LoopBackResourceProvider.setAuthHeader('X-Access-Token');
   *  });
   * ```
   */
  .provider('LoopBackResource', function LoopBackResourceProvider() {
    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} header The header name to use, e.g. `X-Access-Token`
     * @description
     * Configure the REST transport to use a different header for sending
     * the authentication token. It is sent in the `Authorization` header
     * by default.
     */
    this.setAuthHeader = function(header) {
      authHeader = header;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getAuthHeader
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the header name that is used for sending the authentication token.
     */
    this.getAuthHeader = function() {
      return authHeader;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#setUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @param {string} url The URL to use, e.g. `/api` or `//example.com/api`.
     * @description
     * Change the URL of the REST API server. By default, the URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.setUrlBase = function(url) {
      urlBase = url;
      urlBaseHost = getHost(urlBase) || location.host;
    };

    /**
     * @ngdoc method
     * @name lbServices.LoopBackResourceProvider#getUrlBase
     * @methodOf lbServices.LoopBackResourceProvider
     * @description
     * Get the URL of the REST API server. The URL provided
     * to the code generator (`lb-ng` or `grunt-loopback-sdk-angular`) is used.
     */
    this.getUrlBase = function() {
      return urlBase;
    };

    this.$get = ['$resource', function($resource) {
      var LoopBackResource = function(url, params, actions) {
        var resource = $resource(url, params, actions);

        // Angular always calls POST on $save()
        // This hack is based on
        // http://kirkbushell.me/angular-js-using-ng-resource-in-a-more-restful-manner/
        resource.prototype.$save = function(success, error) {
          // Fortunately, LoopBack provides a convenient `upsert` method
          // that exactly fits our needs.
          var result = resource.upsert.call(this, {}, this, success, error);
          return result.$promise || result;
        };
        return resource;
      };

      LoopBackResource.getUrlBase = function() {
        return urlBase;
      };

      LoopBackResource.getAuthHeader = function() {
        return authHeader;
      };

      return LoopBackResource;
    }];
  });
})(window, window.angular);
